/*!
 * DevExtreme-Quill Editor v.0.9.5
 * https://js.devexpress.com/
 * Copyright (c) 2020, Developer Express Inc.
 * Copyright (c) 2017, Slab
 * Copyright (c) 2014, Jason Chen
 * Copyright (c) 2013, salesforce.com
 */
!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define([], e) : "object" == typeof exports ? exports.Quill = e() : (t.DevExpress = t.DevExpress || {}, t.DevExpress.Quill = e());
}(window, function () {
  return function (t) {
    var e = {};

    function n(r) {
      if (e[r]) return e[r].exports;
      var o = e[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return t[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }

    return n.m = t, n.c = e, n.d = function (t, e, r) {
      n.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, n.t = function (t, e) {
      if (1 & e && (t = n(t)), 8 & e) return t;
      if (4 & e && "object" == typeof t && t && t.__esModule) return t;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var o in t) {
        n.d(r, o, function (e) {
          return t[e];
        }.bind(null, o));
      }
      return r;
    }, n.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return n.d(e, "a", e), e;
    }, n.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, n.p = "", n(n.s = 98);
  }([function (t, e, n) {
    "use strict";

    var r = this && this.__importDefault || function (t) {
      return t && t.__esModule ? t : {
        default: t
      };
    },
        o = r(n(95)),
        i = r(n(1)),
        u = r(n(5)),
        a = r(n(96)),
        c = r(n(50)),
        l = String.fromCharCode(0),
        s = function () {
      function t(t) {
        Array.isArray(t) ? this.ops = t : null != t && Array.isArray(t.ops) ? this.ops = t.ops : this.ops = [];
      }

      return t.prototype.insert = function (t, e) {
        var n = {};
        return "string" == typeof t && 0 === t.length ? this : (n.insert = t, null != e && "object" == typeof e && Object.keys(e).length > 0 && (n.attributes = e), this.push(n));
      }, t.prototype.delete = function (t) {
        return t <= 0 ? this : this.push({
          delete: t
        });
      }, t.prototype.retain = function (t, e) {
        if (t <= 0) return this;
        var n = {
          retain: t
        };
        return null != e && "object" == typeof e && Object.keys(e).length > 0 && (n.attributes = e), this.push(n);
      }, t.prototype.push = function (t) {
        var e = this.ops.length,
            n = this.ops[e - 1];

        if (t = i.default(t), "object" == typeof n) {
          if ("number" == typeof t.delete && "number" == typeof n.delete) return this.ops[e - 1] = {
            delete: n.delete + t.delete
          }, this;
          if ("number" == typeof n.delete && null != t.insert && (e -= 1, "object" != typeof (n = this.ops[e - 1]))) return this.ops.unshift(t), this;

          if (u.default(t.attributes, n.attributes)) {
            if ("string" == typeof t.insert && "string" == typeof n.insert) return this.ops[e - 1] = {
              insert: n.insert + t.insert
            }, "object" == typeof t.attributes && (this.ops[e - 1].attributes = t.attributes), this;
            if ("number" == typeof t.retain && "number" == typeof n.retain) return this.ops[e - 1] = {
              retain: n.retain + t.retain
            }, "object" == typeof t.attributes && (this.ops[e - 1].attributes = t.attributes), this;
          }
        }

        return e === this.ops.length ? this.ops.push(t) : this.ops.splice(e, 0, t), this;
      }, t.prototype.chop = function () {
        var t = this.ops[this.ops.length - 1];
        return t && t.retain && !t.attributes && this.ops.pop(), this;
      }, t.prototype.filter = function (t) {
        return this.ops.filter(t);
      }, t.prototype.forEach = function (t) {
        this.ops.forEach(t);
      }, t.prototype.map = function (t) {
        return this.ops.map(t);
      }, t.prototype.partition = function (t) {
        var e = [],
            n = [];
        return this.forEach(function (r) {
          (t(r) ? e : n).push(r);
        }), [e, n];
      }, t.prototype.reduce = function (t, e) {
        return this.ops.reduce(t, e);
      }, t.prototype.changeLength = function () {
        return this.reduce(function (t, e) {
          return e.insert ? t + c.default.length(e) : e.delete ? t - e.delete : t;
        }, 0);
      }, t.prototype.length = function () {
        return this.reduce(function (t, e) {
          return t + c.default.length(e);
        }, 0);
      }, t.prototype.slice = function (e, n) {
        void 0 === e && (e = 0), void 0 === n && (n = 1 / 0);

        for (var r = [], o = c.default.iterator(this.ops), i = 0; i < n && o.hasNext();) {
          var u = void 0;
          i < e ? u = o.next(e - i) : (u = o.next(n - i), r.push(u)), i += c.default.length(u);
        }

        return new t(r);
      }, t.prototype.compose = function (e) {
        var n = c.default.iterator(this.ops),
            r = c.default.iterator(e.ops),
            o = [],
            i = r.peek();

        if (null != i && "number" == typeof i.retain && null == i.attributes) {
          for (var l = i.retain; "insert" === n.peekType() && n.peekLength() <= l;) {
            l -= n.peekLength(), o.push(n.next());
          }

          i.retain - l > 0 && r.next(i.retain - l);
        }

        for (var s = new t(o); n.hasNext() || r.hasNext();) {
          if ("insert" === r.peekType()) s.push(r.next());else if ("delete" === n.peekType()) s.push(n.next());else {
            var f = Math.min(n.peekLength(), r.peekLength()),
                h = n.next(f),
                p = r.next(f);

            if ("number" == typeof p.retain) {
              var y = {};
              "number" == typeof h.retain ? y.retain = f : y.insert = h.insert;
              var d = a.default.compose(h.attributes, p.attributes, "number" == typeof h.retain);

              if (d && (y.attributes = d), s.push(y), !r.hasNext() && u.default(s.ops[s.ops.length - 1], y)) {
                var v = new t(n.rest());
                return s.concat(v).chop();
              }
            } else "number" == typeof p.delete && "number" == typeof h.retain && s.push(p);
          }
        }

        return s.chop();
      }, t.prototype.concat = function (e) {
        var n = new t(this.ops.slice());
        return e.ops.length > 0 && (n.push(e.ops[0]), n.ops = n.ops.concat(e.ops.slice(1))), n;
      }, t.prototype.diff = function (e, n) {
        if (this.ops === e.ops) return new t();
        var r = [this, e].map(function (t) {
          return t.map(function (n) {
            if (null != n.insert) return "string" == typeof n.insert ? n.insert : l;
            throw new Error("diff() called " + (t === e ? "on" : "with") + " non-document");
          }).join("");
        }),
            i = new t(),
            s = o.default(r[0], r[1], n),
            f = c.default.iterator(this.ops),
            h = c.default.iterator(e.ops);
        return s.forEach(function (t) {
          for (var e = t[1].length; e > 0;) {
            var n = 0;

            switch (t[0]) {
              case o.default.INSERT:
                n = Math.min(h.peekLength(), e), i.push(h.next(n));
                break;

              case o.default.DELETE:
                n = Math.min(e, f.peekLength()), f.next(n), i.delete(n);
                break;

              case o.default.EQUAL:
                n = Math.min(f.peekLength(), h.peekLength(), e);
                var r = f.next(n),
                    c = h.next(n);
                u.default(r.insert, c.insert) ? i.retain(n, a.default.diff(r.attributes, c.attributes)) : i.push(c).delete(n);
            }

            e -= n;
          }
        }), i.chop();
      }, t.prototype.eachLine = function (e, n) {
        void 0 === n && (n = "\n");

        for (var r = c.default.iterator(this.ops), o = new t(), i = 0; r.hasNext();) {
          if ("insert" !== r.peekType()) return;
          var u = r.peek(),
              a = c.default.length(u) - r.peekLength(),
              l = "string" == typeof u.insert ? u.insert.indexOf(n, a) - a : -1;
          if (l < 0) o.push(r.next());else if (l > 0) o.push(r.next(l));else {
            if (!1 === e(o, r.next(1).attributes || {}, i)) return;
            i += 1, o = new t();
          }
        }

        o.length() > 0 && e(o, {}, i);
      }, t.prototype.invert = function (e) {
        var n = new t();
        return this.reduce(function (t, r) {
          if (r.insert) n.delete(c.default.length(r));else {
            if (r.retain && null == r.attributes) return n.retain(r.retain), t + r.retain;

            if (r.delete || r.retain && r.attributes) {
              var o = r.delete || r.retain;
              return e.slice(t, t + o).forEach(function (t) {
                r.delete ? n.push(t) : r.retain && r.attributes && n.retain(c.default.length(t), a.default.invert(r.attributes, t.attributes));
              }), t + o;
            }
          }
          return t;
        }, 0), n.chop();
      }, t.prototype.transform = function (e, n) {
        if (void 0 === n && (n = !1), n = !!n, "number" == typeof e) return this.transformPosition(e, n);

        for (var r = e, o = c.default.iterator(this.ops), i = c.default.iterator(r.ops), u = new t(); o.hasNext() || i.hasNext();) {
          if ("insert" !== o.peekType() || !n && "insert" === i.peekType()) {
            if ("insert" === i.peekType()) u.push(i.next());else {
              var l = Math.min(o.peekLength(), i.peekLength()),
                  s = o.next(l),
                  f = i.next(l);
              if (s.delete) continue;
              f.delete ? u.push(f) : u.retain(l, a.default.transform(s.attributes, f.attributes, n));
            }
          } else u.retain(c.default.length(o.next()));
        }

        return u.chop();
      }, t.prototype.transformPosition = function (t, e) {
        void 0 === e && (e = !1), e = !!e;

        for (var n = c.default.iterator(this.ops), r = 0; n.hasNext() && r <= t;) {
          var o = n.peekLength(),
              i = n.peekType();
          n.next(), "delete" !== i ? ("insert" === i && (r < t || !e) && (t += o), r += o) : t -= Math.min(o, t - r);
        }

        return t;
      }, t.Op = c.default, t.AttributeMap = a.default, t;
    }();

    t.exports = s;
  }, function (t, e, n) {
    (function (t, n) {
      var r = "[object Arguments]",
          o = "[object Function]",
          i = "[object GeneratorFunction]",
          u = "[object Map]",
          a = "[object Set]",
          c = /\w*$/,
          l = /^\[object .+?Constructor\]$/,
          s = /^(?:0|[1-9]\d*)$/,
          f = {};
      f[r] = f["[object Array]"] = f["[object ArrayBuffer]"] = f["[object DataView]"] = f["[object Boolean]"] = f["[object Date]"] = f["[object Float32Array]"] = f["[object Float64Array]"] = f["[object Int8Array]"] = f["[object Int16Array]"] = f["[object Int32Array]"] = f[u] = f["[object Number]"] = f["[object Object]"] = f["[object RegExp]"] = f[a] = f["[object String]"] = f["[object Symbol]"] = f["[object Uint8Array]"] = f["[object Uint8ClampedArray]"] = f["[object Uint16Array]"] = f["[object Uint32Array]"] = !0, f["[object Error]"] = f[o] = f["[object WeakMap]"] = !1;
      var h = "object" == typeof t && t && t.Object === Object && t,
          p = "object" == typeof self && self && self.Object === Object && self,
          y = h || p || Function("return this")(),
          d = e && !e.nodeType && e,
          v = d && "object" == typeof n && n && !n.nodeType && n,
          b = v && v.exports === d;

      function m(t, e) {
        return t.set(e[0], e[1]), t;
      }

      function g(t, e) {
        return t.add(e), t;
      }

      function O(t, e, n, r) {
        var o = -1,
            i = t ? t.length : 0;

        for (r && i && (n = t[++o]); ++o < i;) {
          n = e(n, t[o], o, t);
        }

        return n;
      }

      function w(t) {
        var e = !1;
        if (null != t && "function" != typeof t.toString) try {
          e = !!(t + "");
        } catch (t) {}
        return e;
      }

      function _(t) {
        var e = -1,
            n = Array(t.size);
        return t.forEach(function (t, r) {
          n[++e] = [r, t];
        }), n;
      }

      function j(t, e) {
        return function (n) {
          return t(e(n));
        };
      }

      function N(t) {
        var e = -1,
            n = Array(t.size);
        return t.forEach(function (t) {
          n[++e] = t;
        }), n;
      }

      var k,
          S = Array.prototype,
          x = Function.prototype,
          E = Object.prototype,
          A = y["__core-js_shared__"],
          R = (k = /[^.]+$/.exec(A && A.keys && A.keys.IE_PROTO || "")) ? "Symbol(src)_1." + k : "",
          T = x.toString,
          P = E.hasOwnProperty,
          C = E.toString,
          L = RegExp("^" + T.call(P).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"),
          D = b ? y.Buffer : void 0,
          q = y.Symbol,
          I = y.Uint8Array,
          B = j(Object.getPrototypeOf, Object),
          M = Object.create,
          U = E.propertyIsEnumerable,
          z = S.splice,
          F = Object.getOwnPropertySymbols,
          K = D ? D.isBuffer : void 0,
          W = j(Object.keys, Object),
          $ = vt(y, "DataView"),
          H = vt(y, "Map"),
          V = vt(y, "Promise"),
          G = vt(y, "Set"),
          X = vt(y, "WeakMap"),
          Y = vt(Object, "create"),
          Q = wt($),
          Z = wt(H),
          J = wt(V),
          tt = wt(G),
          et = wt(X),
          nt = q ? q.prototype : void 0,
          rt = nt ? nt.valueOf : void 0;

      function ot(t) {
        var e = -1,
            n = t ? t.length : 0;

        for (this.clear(); ++e < n;) {
          var r = t[e];
          this.set(r[0], r[1]);
        }
      }

      function it(t) {
        var e = -1,
            n = t ? t.length : 0;

        for (this.clear(); ++e < n;) {
          var r = t[e];
          this.set(r[0], r[1]);
        }
      }

      function ut(t) {
        var e = -1,
            n = t ? t.length : 0;

        for (this.clear(); ++e < n;) {
          var r = t[e];
          this.set(r[0], r[1]);
        }
      }

      function at(t) {
        this.__data__ = new it(t);
      }

      function ct(t, e) {
        var n = jt(t) || function (t) {
          return function (t) {
            return function (t) {
              return !!t && "object" == typeof t;
            }(t) && Nt(t);
          }(t) && P.call(t, "callee") && (!U.call(t, "callee") || C.call(t) == r);
        }(t) ? function (t, e) {
          for (var n = -1, r = Array(t); ++n < t;) {
            r[n] = e(n);
          }

          return r;
        }(t.length, String) : [],
            o = n.length,
            i = !!o;

        for (var u in t) {
          !e && !P.call(t, u) || i && ("length" == u || gt(u, o)) || n.push(u);
        }

        return n;
      }

      function lt(t, e, n) {
        var r = t[e];
        P.call(t, e) && _t(r, n) && (void 0 !== n || e in t) || (t[e] = n);
      }

      function st(t, e) {
        for (var n = t.length; n--;) {
          if (_t(t[n][0], e)) return n;
        }

        return -1;
      }

      function ft(t, e, n, l, s, h, p) {
        var y;
        if (l && (y = h ? l(t, s, h, p) : l(t)), void 0 !== y) return y;
        if (!xt(t)) return t;
        var d = jt(t);

        if (d) {
          if (y = function (t) {
            var e = t.length,
                n = t.constructor(e);
            e && "string" == typeof t[0] && P.call(t, "index") && (n.index = t.index, n.input = t.input);
            return n;
          }(t), !e) return function (t, e) {
            var n = -1,
                r = t.length;
            e || (e = Array(r));

            for (; ++n < r;) {
              e[n] = t[n];
            }

            return e;
          }(t, y);
        } else {
          var v = mt(t),
              b = v == o || v == i;
          if (kt(t)) return function (t, e) {
            if (e) return t.slice();
            var n = new t.constructor(t.length);
            return t.copy(n), n;
          }(t, e);

          if ("[object Object]" == v || v == r || b && !h) {
            if (w(t)) return h ? t : {};
            if (y = function (t) {
              return "function" != typeof t.constructor || Ot(t) ? {} : (e = B(t), xt(e) ? M(e) : {});
              var e;
            }(b ? {} : t), !e) return function (t, e) {
              return yt(t, bt(t), e);
            }(t, function (t, e) {
              return t && yt(e, Et(e), t);
            }(y, t));
          } else {
            if (!f[v]) return h ? t : {};

            y = function (t, e, n, r) {
              var o = t.constructor;

              switch (e) {
                case "[object ArrayBuffer]":
                  return pt(t);

                case "[object Boolean]":
                case "[object Date]":
                  return new o(+t);

                case "[object DataView]":
                  return function (t, e) {
                    var n = e ? pt(t.buffer) : t.buffer;
                    return new t.constructor(n, t.byteOffset, t.byteLength);
                  }(t, r);

                case "[object Float32Array]":
                case "[object Float64Array]":
                case "[object Int8Array]":
                case "[object Int16Array]":
                case "[object Int32Array]":
                case "[object Uint8Array]":
                case "[object Uint8ClampedArray]":
                case "[object Uint16Array]":
                case "[object Uint32Array]":
                  return function (t, e) {
                    var n = e ? pt(t.buffer) : t.buffer;
                    return new t.constructor(n, t.byteOffset, t.length);
                  }(t, r);

                case u:
                  return function (t, e, n) {
                    return O(e ? n(_(t), !0) : _(t), m, new t.constructor());
                  }(t, r, n);

                case "[object Number]":
                case "[object String]":
                  return new o(t);

                case "[object RegExp]":
                  return function (t) {
                    var e = new t.constructor(t.source, c.exec(t));
                    return e.lastIndex = t.lastIndex, e;
                  }(t);

                case a:
                  return function (t, e, n) {
                    return O(e ? n(N(t), !0) : N(t), g, new t.constructor());
                  }(t, r, n);

                case "[object Symbol]":
                  return i = t, rt ? Object(rt.call(i)) : {};
              }

              var i;
            }(t, v, ft, e);
          }
        }

        p || (p = new at());
        var j = p.get(t);
        if (j) return j;
        if (p.set(t, y), !d) var k = n ? function (t) {
          return function (t, e, n) {
            var r = e(t);
            return jt(t) ? r : function (t, e) {
              for (var n = -1, r = e.length, o = t.length; ++n < r;) {
                t[o + n] = e[n];
              }

              return t;
            }(r, n(t));
          }(t, Et, bt);
        }(t) : Et(t);
        return function (t, e) {
          for (var n = -1, r = t ? t.length : 0; ++n < r && !1 !== e(t[n], n, t);) {
            ;
          }
        }(k || t, function (r, o) {
          k && (r = t[o = r]), lt(y, o, ft(r, e, n, l, o, t, p));
        }), y;
      }

      function ht(t) {
        return !(!xt(t) || (e = t, R && R in e)) && (St(t) || w(t) ? L : l).test(wt(t));
        var e;
      }

      function pt(t) {
        var e = new t.constructor(t.byteLength);
        return new I(e).set(new I(t)), e;
      }

      function yt(t, e, n, r) {
        n || (n = {});

        for (var o = -1, i = e.length; ++o < i;) {
          var u = e[o],
              a = r ? r(n[u], t[u], u, n, t) : void 0;
          lt(n, u, void 0 === a ? t[u] : a);
        }

        return n;
      }

      function dt(t, e) {
        var n,
            r,
            o = t.__data__;
        return ("string" == (r = typeof (n = e)) || "number" == r || "symbol" == r || "boolean" == r ? "__proto__" !== n : null === n) ? o["string" == typeof e ? "string" : "hash"] : o.map;
      }

      function vt(t, e) {
        var n = function (t, e) {
          return null == t ? void 0 : t[e];
        }(t, e);

        return ht(n) ? n : void 0;
      }

      ot.prototype.clear = function () {
        this.__data__ = Y ? Y(null) : {};
      }, ot.prototype.delete = function (t) {
        return this.has(t) && delete this.__data__[t];
      }, ot.prototype.get = function (t) {
        var e = this.__data__;

        if (Y) {
          var n = e[t];
          return "__lodash_hash_undefined__" === n ? void 0 : n;
        }

        return P.call(e, t) ? e[t] : void 0;
      }, ot.prototype.has = function (t) {
        var e = this.__data__;
        return Y ? void 0 !== e[t] : P.call(e, t);
      }, ot.prototype.set = function (t, e) {
        return this.__data__[t] = Y && void 0 === e ? "__lodash_hash_undefined__" : e, this;
      }, it.prototype.clear = function () {
        this.__data__ = [];
      }, it.prototype.delete = function (t) {
        var e = this.__data__,
            n = st(e, t);
        return !(n < 0) && (n == e.length - 1 ? e.pop() : z.call(e, n, 1), !0);
      }, it.prototype.get = function (t) {
        var e = this.__data__,
            n = st(e, t);
        return n < 0 ? void 0 : e[n][1];
      }, it.prototype.has = function (t) {
        return st(this.__data__, t) > -1;
      }, it.prototype.set = function (t, e) {
        var n = this.__data__,
            r = st(n, t);
        return r < 0 ? n.push([t, e]) : n[r][1] = e, this;
      }, ut.prototype.clear = function () {
        this.__data__ = {
          hash: new ot(),
          map: new (H || it)(),
          string: new ot()
        };
      }, ut.prototype.delete = function (t) {
        return dt(this, t).delete(t);
      }, ut.prototype.get = function (t) {
        return dt(this, t).get(t);
      }, ut.prototype.has = function (t) {
        return dt(this, t).has(t);
      }, ut.prototype.set = function (t, e) {
        return dt(this, t).set(t, e), this;
      }, at.prototype.clear = function () {
        this.__data__ = new it();
      }, at.prototype.delete = function (t) {
        return this.__data__.delete(t);
      }, at.prototype.get = function (t) {
        return this.__data__.get(t);
      }, at.prototype.has = function (t) {
        return this.__data__.has(t);
      }, at.prototype.set = function (t, e) {
        var n = this.__data__;

        if (n instanceof it) {
          var r = n.__data__;
          if (!H || r.length < 199) return r.push([t, e]), this;
          n = this.__data__ = new ut(r);
        }

        return n.set(t, e), this;
      };

      var bt = F ? j(F, Object) : function () {
        return [];
      },
          mt = function mt(t) {
        return C.call(t);
      };

      function gt(t, e) {
        return !!(e = null == e ? 9007199254740991 : e) && ("number" == typeof t || s.test(t)) && t > -1 && t % 1 == 0 && t < e;
      }

      function Ot(t) {
        var e = t && t.constructor;
        return t === ("function" == typeof e && e.prototype || E);
      }

      function wt(t) {
        if (null != t) {
          try {
            return T.call(t);
          } catch (t) {}

          try {
            return t + "";
          } catch (t) {}
        }

        return "";
      }

      function _t(t, e) {
        return t === e || t != t && e != e;
      }

      ($ && "[object DataView]" != mt(new $(new ArrayBuffer(1))) || H && mt(new H()) != u || V && "[object Promise]" != mt(V.resolve()) || G && mt(new G()) != a || X && "[object WeakMap]" != mt(new X())) && (mt = function mt(t) {
        var e = C.call(t),
            n = "[object Object]" == e ? t.constructor : void 0,
            r = n ? wt(n) : void 0;
        if (r) switch (r) {
          case Q:
            return "[object DataView]";

          case Z:
            return u;

          case J:
            return "[object Promise]";

          case tt:
            return a;

          case et:
            return "[object WeakMap]";
        }
        return e;
      });
      var jt = Array.isArray;

      function Nt(t) {
        return null != t && function (t) {
          return "number" == typeof t && t > -1 && t % 1 == 0 && t <= 9007199254740991;
        }(t.length) && !St(t);
      }

      var kt = K || function () {
        return !1;
      };

      function St(t) {
        var e = xt(t) ? C.call(t) : "";
        return e == o || e == i;
      }

      function xt(t) {
        var e = typeof t;
        return !!t && ("object" == e || "function" == e);
      }

      function Et(t) {
        return Nt(t) ? ct(t) : function (t) {
          if (!Ot(t)) return W(t);
          var e = [];

          for (var n in Object(t)) {
            P.call(t, n) && "constructor" != n && e.push(n);
          }

          return e;
        }(t);
      }

      n.exports = function (t) {
        return ft(t, !0, !0);
      };
    }).call(this, n(14), n(30)(t));
  }, function (t, e, n) {
    (function (e) {
      var n = function n(t) {
        return t && t.Math == Math && t;
      };

      t.exports = n("object" == typeof globalThis && globalThis) || n("object" == typeof window && window) || n("object" == typeof self && self) || n("object" == typeof e && e) || Function("return this")();
    }).call(this, n(14));
  }, function (t, e, n) {
    var r = n(2),
        o = n(36),
        i = n(4),
        u = n(37),
        a = n(45),
        c = n(68),
        l = o("wks"),
        s = r.Symbol,
        f = c ? s : s && s.withoutSetter || u;

    t.exports = function (t) {
      return i(l, t) || (a && i(s, t) ? l[t] = s[t] : l[t] = f("Symbol." + t)), l[t];
    };
  }, function (t, e) {
    var n = {}.hasOwnProperty;

    t.exports = function (t, e) {
      return n.call(t, e);
    };
  }, function (t, e, n) {
    (function (t, n) {
      var r = "[object Arguments]",
          o = "[object Map]",
          i = "[object Object]",
          u = "[object Set]",
          a = /^\[object .+?Constructor\]$/,
          c = /^(?:0|[1-9]\d*)$/,
          l = {};
      l["[object Float32Array]"] = l["[object Float64Array]"] = l["[object Int8Array]"] = l["[object Int16Array]"] = l["[object Int32Array]"] = l["[object Uint8Array]"] = l["[object Uint8ClampedArray]"] = l["[object Uint16Array]"] = l["[object Uint32Array]"] = !0, l[r] = l["[object Array]"] = l["[object ArrayBuffer]"] = l["[object Boolean]"] = l["[object DataView]"] = l["[object Date]"] = l["[object Error]"] = l["[object Function]"] = l[o] = l["[object Number]"] = l[i] = l["[object RegExp]"] = l[u] = l["[object String]"] = l["[object WeakMap]"] = !1;

      var s = "object" == typeof t && t && t.Object === Object && t,
          f = "object" == typeof self && self && self.Object === Object && self,
          h = s || f || Function("return this")(),
          p = e && !e.nodeType && e,
          y = p && "object" == typeof n && n && !n.nodeType && n,
          d = y && y.exports === p,
          v = d && s.process,
          b = function () {
        try {
          return v && v.binding && v.binding("util");
        } catch (t) {}
      }(),
          m = b && b.isTypedArray;

      function g(t, e) {
        for (var n = -1, r = null == t ? 0 : t.length; ++n < r;) {
          if (e(t[n], n, t)) return !0;
        }

        return !1;
      }

      function O(t) {
        var e = -1,
            n = Array(t.size);
        return t.forEach(function (t, r) {
          n[++e] = [r, t];
        }), n;
      }

      function w(t) {
        var e = -1,
            n = Array(t.size);
        return t.forEach(function (t) {
          n[++e] = t;
        }), n;
      }

      var _,
          j,
          N,
          k = Array.prototype,
          S = Function.prototype,
          x = Object.prototype,
          E = h["__core-js_shared__"],
          A = S.toString,
          R = x.hasOwnProperty,
          T = (_ = /[^.]+$/.exec(E && E.keys && E.keys.IE_PROTO || "")) ? "Symbol(src)_1." + _ : "",
          P = x.toString,
          C = RegExp("^" + A.call(R).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"),
          L = d ? h.Buffer : void 0,
          D = h.Symbol,
          q = h.Uint8Array,
          I = x.propertyIsEnumerable,
          B = k.splice,
          M = D ? D.toStringTag : void 0,
          U = Object.getOwnPropertySymbols,
          z = L ? L.isBuffer : void 0,
          F = (j = Object.keys, N = Object, function (t) {
        return j(N(t));
      }),
          K = bt(h, "DataView"),
          W = bt(h, "Map"),
          $ = bt(h, "Promise"),
          H = bt(h, "Set"),
          V = bt(h, "WeakMap"),
          G = bt(Object, "create"),
          X = wt(K),
          Y = wt(W),
          Q = wt($),
          Z = wt(H),
          J = wt(V),
          tt = D ? D.prototype : void 0,
          et = tt ? tt.valueOf : void 0;

      function nt(t) {
        var e = -1,
            n = null == t ? 0 : t.length;

        for (this.clear(); ++e < n;) {
          var r = t[e];
          this.set(r[0], r[1]);
        }
      }

      function rt(t) {
        var e = -1,
            n = null == t ? 0 : t.length;

        for (this.clear(); ++e < n;) {
          var r = t[e];
          this.set(r[0], r[1]);
        }
      }

      function ot(t) {
        var e = -1,
            n = null == t ? 0 : t.length;

        for (this.clear(); ++e < n;) {
          var r = t[e];
          this.set(r[0], r[1]);
        }
      }

      function it(t) {
        var e = -1,
            n = null == t ? 0 : t.length;

        for (this.__data__ = new ot(); ++e < n;) {
          this.add(t[e]);
        }
      }

      function ut(t) {
        var e = this.__data__ = new rt(t);
        this.size = e.size;
      }

      function at(t, e) {
        var n = Nt(t),
            r = !n && jt(t),
            o = !n && !r && kt(t),
            i = !n && !r && !o && Rt(t),
            u = n || r || o || i,
            a = u ? function (t, e) {
          for (var n = -1, r = Array(t); ++n < t;) {
            r[n] = e(n);
          }

          return r;
        }(t.length, String) : [],
            c = a.length;

        for (var l in t) {
          !e && !R.call(t, l) || u && ("length" == l || o && ("offset" == l || "parent" == l) || i && ("buffer" == l || "byteLength" == l || "byteOffset" == l) || Ot(l, c)) || a.push(l);
        }

        return a;
      }

      function ct(t, e) {
        for (var n = t.length; n--;) {
          if (_t(t[n][0], e)) return n;
        }

        return -1;
      }

      function lt(t) {
        return null == t ? void 0 === t ? "[object Undefined]" : "[object Null]" : M && M in Object(t) ? function (t) {
          var e = R.call(t, M),
              n = t[M];

          try {
            t[M] = void 0;
            var r = !0;
          } catch (t) {}

          var o = P.call(t);
          r && (e ? t[M] = n : delete t[M]);
          return o;
        }(t) : function (t) {
          return P.call(t);
        }(t);
      }

      function st(t) {
        return At(t) && lt(t) == r;
      }

      function ft(t, e, n, a, c) {
        return t === e || (null == t || null == e || !At(t) && !At(e) ? t != t && e != e : function (t, e, n, a, c, l) {
          var s = Nt(t),
              f = Nt(e),
              h = s ? "[object Array]" : gt(t),
              p = f ? "[object Array]" : gt(e),
              y = (h = h == r ? i : h) == i,
              d = (p = p == r ? i : p) == i,
              v = h == p;

          if (v && kt(t)) {
            if (!kt(e)) return !1;
            s = !0, y = !1;
          }

          if (v && !y) return l || (l = new ut()), s || Rt(t) ? yt(t, e, n, a, c, l) : function (t, e, n, r, i, a, c) {
            switch (n) {
              case "[object DataView]":
                if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset) return !1;
                t = t.buffer, e = e.buffer;

              case "[object ArrayBuffer]":
                return !(t.byteLength != e.byteLength || !a(new q(t), new q(e)));

              case "[object Boolean]":
              case "[object Date]":
              case "[object Number]":
                return _t(+t, +e);

              case "[object Error]":
                return t.name == e.name && t.message == e.message;

              case "[object RegExp]":
              case "[object String]":
                return t == e + "";

              case o:
                var l = O;

              case u:
                var s = 1 & r;
                if (l || (l = w), t.size != e.size && !s) return !1;
                var f = c.get(t);
                if (f) return f == e;
                r |= 2, c.set(t, e);
                var h = yt(l(t), l(e), r, i, a, c);
                return c.delete(t), h;

              case "[object Symbol]":
                if (et) return et.call(t) == et.call(e);
            }

            return !1;
          }(t, e, h, n, a, c, l);

          if (!(1 & n)) {
            var b = y && R.call(t, "__wrapped__"),
                m = d && R.call(e, "__wrapped__");

            if (b || m) {
              var g = b ? t.value() : t,
                  _ = m ? e.value() : e;

              return l || (l = new ut()), c(g, _, n, a, l);
            }
          }

          if (!v) return !1;
          return l || (l = new ut()), function (t, e, n, r, o, i) {
            var u = 1 & n,
                a = dt(t),
                c = a.length,
                l = dt(e).length;
            if (c != l && !u) return !1;
            var s = c;

            for (; s--;) {
              var f = a[s];
              if (!(u ? f in e : R.call(e, f))) return !1;
            }

            var h = i.get(t);
            if (h && i.get(e)) return h == e;
            var p = !0;
            i.set(t, e), i.set(e, t);
            var y = u;

            for (; ++s < c;) {
              f = a[s];
              var d = t[f],
                  v = e[f];
              if (r) var b = u ? r(v, d, f, e, t, i) : r(d, v, f, t, e, i);

              if (!(void 0 === b ? d === v || o(d, v, n, r, i) : b)) {
                p = !1;
                break;
              }

              y || (y = "constructor" == f);
            }

            if (p && !y) {
              var m = t.constructor,
                  g = e.constructor;
              m == g || !("constructor" in t) || !("constructor" in e) || "function" == typeof m && m instanceof m && "function" == typeof g && g instanceof g || (p = !1);
            }

            return i.delete(t), i.delete(e), p;
          }(t, e, n, a, c, l);
        }(t, e, n, a, ft, c));
      }

      function ht(t) {
        return !(!Et(t) || function (t) {
          return !!T && T in t;
        }(t)) && (St(t) ? C : a).test(wt(t));
      }

      function pt(t) {
        if (n = (e = t) && e.constructor, r = "function" == typeof n && n.prototype || x, e !== r) return F(t);
        var e,
            n,
            r,
            o = [];

        for (var i in Object(t)) {
          R.call(t, i) && "constructor" != i && o.push(i);
        }

        return o;
      }

      function yt(t, e, n, r, o, i) {
        var u = 1 & n,
            a = t.length,
            c = e.length;
        if (a != c && !(u && c > a)) return !1;
        var l = i.get(t);
        if (l && i.get(e)) return l == e;
        var s = -1,
            f = !0,
            h = 2 & n ? new it() : void 0;

        for (i.set(t, e), i.set(e, t); ++s < a;) {
          var p = t[s],
              y = e[s];
          if (r) var d = u ? r(y, p, s, e, t, i) : r(p, y, s, t, e, i);

          if (void 0 !== d) {
            if (d) continue;
            f = !1;
            break;
          }

          if (h) {
            if (!g(e, function (t, e) {
              if (u = e, !h.has(u) && (p === t || o(p, t, n, r, i))) return h.push(e);
              var u;
            })) {
              f = !1;
              break;
            }
          } else if (p !== y && !o(p, y, n, r, i)) {
            f = !1;
            break;
          }
        }

        return i.delete(t), i.delete(e), f;
      }

      function dt(t) {
        return function (t, e, n) {
          var r = e(t);
          return Nt(t) ? r : function (t, e) {
            for (var n = -1, r = e.length, o = t.length; ++n < r;) {
              t[o + n] = e[n];
            }

            return t;
          }(r, n(t));
        }(t, Tt, mt);
      }

      function vt(t, e) {
        var n,
            r,
            o = t.__data__;
        return ("string" == (r = typeof (n = e)) || "number" == r || "symbol" == r || "boolean" == r ? "__proto__" !== n : null === n) ? o["string" == typeof e ? "string" : "hash"] : o.map;
      }

      function bt(t, e) {
        var n = function (t, e) {
          return null == t ? void 0 : t[e];
        }(t, e);

        return ht(n) ? n : void 0;
      }

      nt.prototype.clear = function () {
        this.__data__ = G ? G(null) : {}, this.size = 0;
      }, nt.prototype.delete = function (t) {
        var e = this.has(t) && delete this.__data__[t];
        return this.size -= e ? 1 : 0, e;
      }, nt.prototype.get = function (t) {
        var e = this.__data__;

        if (G) {
          var n = e[t];
          return "__lodash_hash_undefined__" === n ? void 0 : n;
        }

        return R.call(e, t) ? e[t] : void 0;
      }, nt.prototype.has = function (t) {
        var e = this.__data__;
        return G ? void 0 !== e[t] : R.call(e, t);
      }, nt.prototype.set = function (t, e) {
        var n = this.__data__;
        return this.size += this.has(t) ? 0 : 1, n[t] = G && void 0 === e ? "__lodash_hash_undefined__" : e, this;
      }, rt.prototype.clear = function () {
        this.__data__ = [], this.size = 0;
      }, rt.prototype.delete = function (t) {
        var e = this.__data__,
            n = ct(e, t);
        return !(n < 0) && (n == e.length - 1 ? e.pop() : B.call(e, n, 1), --this.size, !0);
      }, rt.prototype.get = function (t) {
        var e = this.__data__,
            n = ct(e, t);
        return n < 0 ? void 0 : e[n][1];
      }, rt.prototype.has = function (t) {
        return ct(this.__data__, t) > -1;
      }, rt.prototype.set = function (t, e) {
        var n = this.__data__,
            r = ct(n, t);
        return r < 0 ? (++this.size, n.push([t, e])) : n[r][1] = e, this;
      }, ot.prototype.clear = function () {
        this.size = 0, this.__data__ = {
          hash: new nt(),
          map: new (W || rt)(),
          string: new nt()
        };
      }, ot.prototype.delete = function (t) {
        var e = vt(this, t).delete(t);
        return this.size -= e ? 1 : 0, e;
      }, ot.prototype.get = function (t) {
        return vt(this, t).get(t);
      }, ot.prototype.has = function (t) {
        return vt(this, t).has(t);
      }, ot.prototype.set = function (t, e) {
        var n = vt(this, t),
            r = n.size;
        return n.set(t, e), this.size += n.size == r ? 0 : 1, this;
      }, it.prototype.add = it.prototype.push = function (t) {
        return this.__data__.set(t, "__lodash_hash_undefined__"), this;
      }, it.prototype.has = function (t) {
        return this.__data__.has(t);
      }, ut.prototype.clear = function () {
        this.__data__ = new rt(), this.size = 0;
      }, ut.prototype.delete = function (t) {
        var e = this.__data__,
            n = e.delete(t);
        return this.size = e.size, n;
      }, ut.prototype.get = function (t) {
        return this.__data__.get(t);
      }, ut.prototype.has = function (t) {
        return this.__data__.has(t);
      }, ut.prototype.set = function (t, e) {
        var n = this.__data__;

        if (n instanceof rt) {
          var r = n.__data__;
          if (!W || r.length < 199) return r.push([t, e]), this.size = ++n.size, this;
          n = this.__data__ = new ot(r);
        }

        return n.set(t, e), this.size = n.size, this;
      };
      var mt = U ? function (t) {
        return null == t ? [] : (t = Object(t), function (t, e) {
          for (var n = -1, r = null == t ? 0 : t.length, o = 0, i = []; ++n < r;) {
            var u = t[n];
            e(u, n, t) && (i[o++] = u);
          }

          return i;
        }(U(t), function (e) {
          return I.call(t, e);
        }));
      } : function () {
        return [];
      },
          gt = lt;

      function Ot(t, e) {
        return !!(e = null == e ? 9007199254740991 : e) && ("number" == typeof t || c.test(t)) && t > -1 && t % 1 == 0 && t < e;
      }

      function wt(t) {
        if (null != t) {
          try {
            return A.call(t);
          } catch (t) {}

          try {
            return t + "";
          } catch (t) {}
        }

        return "";
      }

      function _t(t, e) {
        return t === e || t != t && e != e;
      }

      (K && "[object DataView]" != gt(new K(new ArrayBuffer(1))) || W && gt(new W()) != o || $ && "[object Promise]" != gt($.resolve()) || H && gt(new H()) != u || V && "[object WeakMap]" != gt(new V())) && (gt = function gt(t) {
        var e = lt(t),
            n = e == i ? t.constructor : void 0,
            r = n ? wt(n) : "";
        if (r) switch (r) {
          case X:
            return "[object DataView]";

          case Y:
            return o;

          case Q:
            return "[object Promise]";

          case Z:
            return u;

          case J:
            return "[object WeakMap]";
        }
        return e;
      });
      var jt = st(function () {
        return arguments;
      }()) ? st : function (t) {
        return At(t) && R.call(t, "callee") && !I.call(t, "callee");
      },
          Nt = Array.isArray;

      var kt = z || function () {
        return !1;
      };

      function St(t) {
        if (!Et(t)) return !1;
        var e = lt(t);
        return "[object Function]" == e || "[object GeneratorFunction]" == e || "[object AsyncFunction]" == e || "[object Proxy]" == e;
      }

      function xt(t) {
        return "number" == typeof t && t > -1 && t % 1 == 0 && t <= 9007199254740991;
      }

      function Et(t) {
        var e = typeof t;
        return null != t && ("object" == e || "function" == e);
      }

      function At(t) {
        return null != t && "object" == typeof t;
      }

      var Rt = m ? function (t) {
        return function (e) {
          return t(e);
        };
      }(m) : function (t) {
        return At(t) && xt(t.length) && !!l[lt(t)];
      };

      function Tt(t) {
        return null != (e = t) && xt(e.length) && !St(e) ? at(t) : pt(t);
        var e;
      }

      n.exports = function (t, e) {
        return ft(t, e);
      };
    }).call(this, n(14), n(30)(t));
  }, function (t, e, n) {
    var r = n(12),
        o = n(8),
        i = n(15);
    t.exports = r ? function (t, e, n) {
      return o.f(t, e, i(1, n));
    } : function (t, e, n) {
      return t[e] = n, t;
    };
  }, function (t, e) {
    t.exports = function (t) {
      try {
        return !!t();
      } catch (t) {
        return !0;
      }
    };
  }, function (t, e, n) {
    var r = n(12),
        o = n(34),
        i = n(10),
        u = n(22),
        a = Object.defineProperty;
    e.f = r ? a : function (t, e, n) {
      if (i(t), e = u(e, !0), i(n), o) try {
        return a(t, e, n);
      } catch (t) {}
      if ("get" in n || "set" in n) throw TypeError("Accessors not supported");
      return "value" in n && (t[e] = n.value), t;
    };
  }, function (t, e) {
    t.exports = function (t) {
      return "object" == typeof t ? null !== t : "function" == typeof t;
    };
  }, function (t, e, n) {
    var r = n(9);

    t.exports = function (t) {
      if (!r(t)) throw TypeError(String(t) + " is not an object");
      return t;
    };
  }, function (t, e, n) {
    (function (t, n) {
      var r = /^\[object .+?Constructor\]$/,
          o = /^(?:0|[1-9]\d*)$/,
          i = {};
      i["[object Float32Array]"] = i["[object Float64Array]"] = i["[object Int8Array]"] = i["[object Int16Array]"] = i["[object Int32Array]"] = i["[object Uint8Array]"] = i["[object Uint8ClampedArray]"] = i["[object Uint16Array]"] = i["[object Uint32Array]"] = !0, i["[object Arguments]"] = i["[object Array]"] = i["[object ArrayBuffer]"] = i["[object Boolean]"] = i["[object DataView]"] = i["[object Date]"] = i["[object Error]"] = i["[object Function]"] = i["[object Map]"] = i["[object Number]"] = i["[object Object]"] = i["[object RegExp]"] = i["[object Set]"] = i["[object String]"] = i["[object WeakMap]"] = !1;

      var u = "object" == typeof t && t && t.Object === Object && t,
          a = "object" == typeof self && self && self.Object === Object && self,
          c = u || a || Function("return this")(),
          l = e && !e.nodeType && e,
          s = l && "object" == typeof n && n && !n.nodeType && n,
          f = s && s.exports === l,
          h = f && u.process,
          p = function () {
        try {
          var t = s && s.require && s.require("util").types;

          return t || h && h.binding && h.binding("util");
        } catch (t) {}
      }(),
          y = p && p.isTypedArray;

      function d(t, e, n) {
        switch (n.length) {
          case 0:
            return t.call(e);

          case 1:
            return t.call(e, n[0]);

          case 2:
            return t.call(e, n[0], n[1]);

          case 3:
            return t.call(e, n[0], n[1], n[2]);
        }

        return t.apply(e, n);
      }

      var v,
          b,
          m,
          g = Array.prototype,
          O = Function.prototype,
          w = Object.prototype,
          _ = c["__core-js_shared__"],
          j = O.toString,
          N = w.hasOwnProperty,
          k = (v = /[^.]+$/.exec(_ && _.keys && _.keys.IE_PROTO || "")) ? "Symbol(src)_1." + v : "",
          S = w.toString,
          x = j.call(Object),
          E = RegExp("^" + j.call(N).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"),
          A = f ? c.Buffer : void 0,
          R = c.Symbol,
          T = c.Uint8Array,
          P = A ? A.allocUnsafe : void 0,
          C = (b = Object.getPrototypeOf, m = Object, function (t) {
        return b(m(t));
      }),
          L = Object.create,
          D = w.propertyIsEnumerable,
          q = g.splice,
          I = R ? R.toStringTag : void 0,
          B = function () {
        try {
          var t = lt(Object, "defineProperty");
          return t({}, "", {}), t;
        } catch (t) {}
      }(),
          M = A ? A.isBuffer : void 0,
          U = Math.max,
          z = Date.now,
          F = lt(c, "Map"),
          K = lt(Object, "create"),
          W = function () {
        function t() {}

        return function (e) {
          if (!wt(e)) return {};
          if (L) return L(e);
          t.prototype = e;
          var n = new t();
          return t.prototype = void 0, n;
        };
      }();

      function $(t) {
        var e = -1,
            n = null == t ? 0 : t.length;

        for (this.clear(); ++e < n;) {
          var r = t[e];
          this.set(r[0], r[1]);
        }
      }

      function H(t) {
        var e = -1,
            n = null == t ? 0 : t.length;

        for (this.clear(); ++e < n;) {
          var r = t[e];
          this.set(r[0], r[1]);
        }
      }

      function V(t) {
        var e = -1,
            n = null == t ? 0 : t.length;

        for (this.clear(); ++e < n;) {
          var r = t[e];
          this.set(r[0], r[1]);
        }
      }

      function G(t) {
        var e = this.__data__ = new H(t);
        this.size = e.size;
      }

      function X(t, e) {
        var n = vt(t),
            r = !n && dt(t),
            o = !n && !r && mt(t),
            i = !n && !r && !o && jt(t),
            u = n || r || o || i,
            a = u ? function (t, e) {
          for (var n = -1, r = Array(t); ++n < t;) {
            r[n] = e(n);
          }

          return r;
        }(t.length, String) : [],
            c = a.length;

        for (var l in t) {
          !e && !N.call(t, l) || u && ("length" == l || o && ("offset" == l || "parent" == l) || i && ("buffer" == l || "byteLength" == l || "byteOffset" == l) || st(l, c)) || a.push(l);
        }

        return a;
      }

      function Y(t, e, n) {
        (void 0 !== n && !yt(t[e], n) || void 0 === n && !(e in t)) && J(t, e, n);
      }

      function Q(t, e, n) {
        var r = t[e];
        N.call(t, e) && yt(r, n) && (void 0 !== n || e in t) || J(t, e, n);
      }

      function Z(t, e) {
        for (var n = t.length; n--;) {
          if (yt(t[n][0], e)) return n;
        }

        return -1;
      }

      function J(t, e, n) {
        "__proto__" == e && B ? B(t, e, {
          configurable: !0,
          enumerable: !0,
          value: n,
          writable: !0
        }) : t[e] = n;
      }

      $.prototype.clear = function () {
        this.__data__ = K ? K(null) : {}, this.size = 0;
      }, $.prototype.delete = function (t) {
        var e = this.has(t) && delete this.__data__[t];
        return this.size -= e ? 1 : 0, e;
      }, $.prototype.get = function (t) {
        var e = this.__data__;

        if (K) {
          var n = e[t];
          return "__lodash_hash_undefined__" === n ? void 0 : n;
        }

        return N.call(e, t) ? e[t] : void 0;
      }, $.prototype.has = function (t) {
        var e = this.__data__;
        return K ? void 0 !== e[t] : N.call(e, t);
      }, $.prototype.set = function (t, e) {
        var n = this.__data__;
        return this.size += this.has(t) ? 0 : 1, n[t] = K && void 0 === e ? "__lodash_hash_undefined__" : e, this;
      }, H.prototype.clear = function () {
        this.__data__ = [], this.size = 0;
      }, H.prototype.delete = function (t) {
        var e = this.__data__,
            n = Z(e, t);
        return !(n < 0) && (n == e.length - 1 ? e.pop() : q.call(e, n, 1), --this.size, !0);
      }, H.prototype.get = function (t) {
        var e = this.__data__,
            n = Z(e, t);
        return n < 0 ? void 0 : e[n][1];
      }, H.prototype.has = function (t) {
        return Z(this.__data__, t) > -1;
      }, H.prototype.set = function (t, e) {
        var n = this.__data__,
            r = Z(n, t);
        return r < 0 ? (++this.size, n.push([t, e])) : n[r][1] = e, this;
      }, V.prototype.clear = function () {
        this.size = 0, this.__data__ = {
          hash: new $(),
          map: new (F || H)(),
          string: new $()
        };
      }, V.prototype.delete = function (t) {
        var e = ct(this, t).delete(t);
        return this.size -= e ? 1 : 0, e;
      }, V.prototype.get = function (t) {
        return ct(this, t).get(t);
      }, V.prototype.has = function (t) {
        return ct(this, t).has(t);
      }, V.prototype.set = function (t, e) {
        var n = ct(this, t),
            r = n.size;
        return n.set(t, e), this.size += n.size == r ? 0 : 1, this;
      }, G.prototype.clear = function () {
        this.__data__ = new H(), this.size = 0;
      }, G.prototype.delete = function (t) {
        var e = this.__data__,
            n = e.delete(t);
        return this.size = e.size, n;
      }, G.prototype.get = function (t) {
        return this.__data__.get(t);
      }, G.prototype.has = function (t) {
        return this.__data__.has(t);
      }, G.prototype.set = function (t, e) {
        var n = this.__data__;

        if (n instanceof H) {
          var r = n.__data__;
          if (!F || r.length < 199) return r.push([t, e]), this.size = ++n.size, this;
          n = this.__data__ = new V(r);
        }

        return n.set(t, e), this.size = n.size, this;
      };

      var tt,
          et = function et(t, e, n) {
        for (var r = -1, o = Object(t), i = n(t), u = i.length; u--;) {
          var a = i[tt ? u : ++r];
          if (!1 === e(o[a], a, o)) break;
        }

        return t;
      };

      function nt(t) {
        return null == t ? void 0 === t ? "[object Undefined]" : "[object Null]" : I && I in Object(t) ? function (t) {
          var e = N.call(t, I),
              n = t[I];

          try {
            t[I] = void 0;
            var r = !0;
          } catch (t) {}

          var o = S.call(t);
          r && (e ? t[I] = n : delete t[I]);
          return o;
        }(t) : function (t) {
          return S.call(t);
        }(t);
      }

      function rt(t) {
        return _t(t) && "[object Arguments]" == nt(t);
      }

      function ot(t) {
        return !(!wt(t) || function (t) {
          return !!k && k in t;
        }(t)) && (gt(t) ? E : r).test(function (t) {
          if (null != t) {
            try {
              return j.call(t);
            } catch (t) {}

            try {
              return t + "";
            } catch (t) {}
          }

          return "";
        }(t));
      }

      function it(t) {
        if (!wt(t)) return function (t) {
          var e = [];
          if (null != t) for (var n in Object(t)) {
            e.push(n);
          }
          return e;
        }(t);
        var e = ft(t),
            n = [];

        for (var r in t) {
          ("constructor" != r || !e && N.call(t, r)) && n.push(r);
        }

        return n;
      }

      function ut(t, e, n, r, o) {
        t !== e && et(e, function (i, u) {
          if (o || (o = new G()), wt(i)) !function (t, e, n, r, o, i, u) {
            var a = ht(t, n),
                c = ht(e, n),
                l = u.get(c);
            if (l) return void Y(t, n, l);
            var s = i ? i(a, c, n + "", t, e, u) : void 0,
                f = void 0 === s;

            if (f) {
              var h = vt(c),
                  p = !h && mt(c),
                  y = !h && !p && jt(c);
              s = c, h || p || y ? vt(a) ? s = a : _t(g = a) && bt(g) ? s = function (t, e) {
                var n = -1,
                    r = t.length;
                e || (e = Array(r));

                for (; ++n < r;) {
                  e[n] = t[n];
                }

                return e;
              }(a) : p ? (f = !1, s = function (t, e) {
                if (e) return t.slice();
                var n = t.length,
                    r = P ? P(n) : new t.constructor(n);
                return t.copy(r), r;
              }(c, !0)) : y ? (f = !1, d = c, v = !0 ? (b = d.buffer, m = new b.constructor(b.byteLength), new T(m).set(new T(b)), m) : d.buffer, s = new d.constructor(v, d.byteOffset, d.length)) : s = [] : function (t) {
                if (!_t(t) || "[object Object]" != nt(t)) return !1;
                var e = C(t);
                if (null === e) return !0;
                var n = N.call(e, "constructor") && e.constructor;
                return "function" == typeof n && n instanceof n && j.call(n) == x;
              }(c) || dt(c) ? (s = a, dt(a) ? s = function (t) {
                return function (t, e, n, r) {
                  var o = !n;
                  n || (n = {});
                  var i = -1,
                      u = e.length;

                  for (; ++i < u;) {
                    var a = e[i],
                        c = r ? r(n[a], t[a], a, n, t) : void 0;
                    void 0 === c && (c = t[a]), o ? J(n, a, c) : Q(n, a, c);
                  }

                  return n;
                }(t, Nt(t));
              }(a) : wt(a) && !gt(a) || (s = function (t) {
                return "function" != typeof t.constructor || ft(t) ? {} : W(C(t));
              }(c))) : f = !1;
            }

            var d, v, b, m;
            var g;
            f && (u.set(c, s), o(s, c, r, i, u), u.delete(c));
            Y(t, n, s);
          }(t, e, u, n, ut, r, o);else {
            var a = r ? r(ht(t, u), i, u + "", t, e, o) : void 0;
            void 0 === a && (a = i), Y(t, u, a);
          }
        }, Nt);
      }

      function at(t, e) {
        return pt(function (t, e, n) {
          return e = U(void 0 === e ? t.length - 1 : e, 0), function () {
            for (var r = arguments, o = -1, i = U(r.length - e, 0), u = Array(i); ++o < i;) {
              u[o] = r[e + o];
            }

            o = -1;

            for (var a = Array(e + 1); ++o < e;) {
              a[o] = r[o];
            }

            return a[e] = n(u), d(t, this, a);
          };
        }(t, e, xt), t + "");
      }

      function ct(t, e) {
        var n,
            r,
            o = t.__data__;
        return ("string" == (r = typeof (n = e)) || "number" == r || "symbol" == r || "boolean" == r ? "__proto__" !== n : null === n) ? o["string" == typeof e ? "string" : "hash"] : o.map;
      }

      function lt(t, e) {
        var n = function (t, e) {
          return null == t ? void 0 : t[e];
        }(t, e);

        return ot(n) ? n : void 0;
      }

      function st(t, e) {
        var n = typeof t;
        return !!(e = null == e ? 9007199254740991 : e) && ("number" == n || "symbol" != n && o.test(t)) && t > -1 && t % 1 == 0 && t < e;
      }

      function ft(t) {
        var e = t && t.constructor;
        return t === ("function" == typeof e && e.prototype || w);
      }

      function ht(t, e) {
        if (("constructor" !== e || "function" != typeof t[e]) && "__proto__" != e) return t[e];
      }

      var pt = function (t) {
        var e = 0,
            n = 0;
        return function () {
          var r = z(),
              o = 16 - (r - n);

          if (n = r, o > 0) {
            if (++e >= 800) return arguments[0];
          } else e = 0;

          return t.apply(void 0, arguments);
        };
      }(B ? function (t, e) {
        return B(t, "toString", {
          configurable: !0,
          enumerable: !1,
          value: (n = e, function () {
            return n;
          }),
          writable: !0
        });
        var n;
      } : xt);

      function yt(t, e) {
        return t === e || t != t && e != e;
      }

      var dt = rt(function () {
        return arguments;
      }()) ? rt : function (t) {
        return _t(t) && N.call(t, "callee") && !D.call(t, "callee");
      },
          vt = Array.isArray;

      function bt(t) {
        return null != t && Ot(t.length) && !gt(t);
      }

      var mt = M || function () {
        return !1;
      };

      function gt(t) {
        if (!wt(t)) return !1;
        var e = nt(t);
        return "[object Function]" == e || "[object GeneratorFunction]" == e || "[object AsyncFunction]" == e || "[object Proxy]" == e;
      }

      function Ot(t) {
        return "number" == typeof t && t > -1 && t % 1 == 0 && t <= 9007199254740991;
      }

      function wt(t) {
        var e = typeof t;
        return null != t && ("object" == e || "function" == e);
      }

      function _t(t) {
        return null != t && "object" == typeof t;
      }

      var jt = y ? function (t) {
        return function (e) {
          return t(e);
        };
      }(y) : function (t) {
        return _t(t) && Ot(t.length) && !!i[nt(t)];
      };

      function Nt(t) {
        return bt(t) ? X(t, !0) : it(t);
      }

      var kt,
          St = (kt = function kt(t, e, n) {
        ut(t, e, n);
      }, at(function (t, e) {
        var n = -1,
            r = e.length,
            o = r > 1 ? e[r - 1] : void 0,
            i = r > 2 ? e[2] : void 0;

        for (o = kt.length > 3 && "function" == typeof o ? (r--, o) : void 0, i && function (t, e, n) {
          if (!wt(n)) return !1;
          var r = typeof e;
          return !!("number" == r ? bt(n) && st(e, n.length) : "string" == r && (e in n)) && yt(n[e], t);
        }(e[0], e[1], i) && (o = r < 3 ? void 0 : o, r = 1), t = Object(t); ++n < r;) {
          var u = e[n];
          u && kt(t, u, n, o);
        }

        return t;
      }));

      function xt(t) {
        return t;
      }

      n.exports = St;
    }).call(this, n(14), n(30)(t));
  }, function (t, e, n) {
    var r = n(7);
    t.exports = !r(function () {
      return 7 != Object.defineProperty({}, 1, {
        get: function get() {
          return 7;
        }
      })[1];
    });
  }, function (t, e) {
    t.exports = function (t) {
      if (null == t) throw TypeError("Can't call method on " + t);
      return t;
    };
  }, function (t, e) {
    var n;

    n = function () {
      return this;
    }();

    try {
      n = n || new Function("return this")();
    } catch (t) {
      "object" == typeof window && (n = window);
    }

    t.exports = n;
  }, function (t, e) {
    t.exports = function (t, e) {
      return {
        enumerable: !(1 & t),
        configurable: !(2 & t),
        writable: !(4 & t),
        value: e
      };
    };
  }, function (t, e) {
    t.exports = !1;
  }, function (t, e, n) {
    var r = n(2),
        o = n(25).f,
        i = n(6),
        u = n(38),
        a = n(21),
        c = n(60),
        l = n(65);

    t.exports = function (t, e) {
      var n,
          s,
          f,
          h,
          p,
          y = t.target,
          d = t.global,
          v = t.stat;
      if (n = d ? r : v ? r[y] || a(y, {}) : (r[y] || {}).prototype) for (s in e) {
        if (h = e[s], f = t.noTargetGet ? (p = o(n, s)) && p.value : n[s], !l(d ? s : y + (v ? "." : "#") + s, t.forced) && void 0 !== f) {
          if (typeof h == typeof f) continue;
          c(h, f);
        }

        (t.sham || f && f.sham) && i(h, "sham", !0), u(n, s, h, t);
      }
    };
  }, function (t, e, n) {
    var r = n(20),
        o = Math.min;

    t.exports = function (t) {
      return t > 0 ? o(r(t), 9007199254740991) : 0;
    };
  }, function (t, e) {
    t.exports = {};
  }, function (t, e) {
    var n = Math.ceil,
        r = Math.floor;

    t.exports = function (t) {
      return isNaN(t = +t) ? 0 : (t > 0 ? r : n)(t);
    };
  }, function (t, e, n) {
    var r = n(2),
        o = n(6);

    t.exports = function (t, e) {
      try {
        o(r, t, e);
      } catch (n) {
        r[t] = e;
      }

      return e;
    };
  }, function (t, e, n) {
    var r = n(9);

    t.exports = function (t, e) {
      if (!r(t)) return t;
      var n, o;
      if (e && "function" == typeof (n = t.toString) && !r(o = n.call(t))) return o;
      if ("function" == typeof (n = t.valueOf) && !r(o = n.call(t))) return o;
      if (!e && "function" == typeof (n = t.toString) && !r(o = n.call(t))) return o;
      throw TypeError("Can't convert object to primitive value");
    };
  }, function (t, e, n) {
    var r = n(36),
        o = n(37),
        i = r("keys");

    t.exports = function (t) {
      return i[t] || (i[t] = o(t));
    };
  }, function (t, e) {
    t.exports = {};
  }, function (t, e, n) {
    var r = n(12),
        o = n(58),
        i = n(15),
        u = n(26),
        a = n(22),
        c = n(4),
        l = n(34),
        s = Object.getOwnPropertyDescriptor;
    e.f = r ? s : function (t, e) {
      if (t = u(t), e = a(e, !0), l) try {
        return s(t, e);
      } catch (t) {}
      if (c(t, e)) return i(!o.f.call(t, e), t[e]);
    };
  }, function (t, e, n) {
    var r = n(59),
        o = n(13);

    t.exports = function (t) {
      return r(o(t));
    };
  }, function (t, e) {
    var n = {}.toString;

    t.exports = function (t) {
      return n.call(t).slice(8, -1);
    };
  }, function (t, e) {
    t.exports = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"];
  }, function (t, e, n) {
    var r = n(13);

    t.exports = function (t) {
      return Object(r(t));
    };
  }, function (t, e) {
    t.exports = function (t) {
      return t.webpackPolyfill || (t.deprecate = function () {}, t.paths = [], t.children || (t.children = []), Object.defineProperty(t, "loaded", {
        enumerable: !0,
        get: function get() {
          return t.l;
        }
      }), Object.defineProperty(t, "id", {
        enumerable: !0,
        get: function get() {
          return t.i;
        }
      }), t.webpackPolyfill = 1), t;
    };
  }, function (t, e, n) {
    var r,
        o,
        i,
        u = n(56),
        a = n(2),
        c = n(9),
        l = n(6),
        s = n(4),
        f = n(23),
        h = n(24),
        p = a.WeakMap;

    if (u) {
      var y = new p(),
          d = y.get,
          v = y.has,
          b = y.set;
      r = function r(t, e) {
        return b.call(y, t, e), e;
      }, o = function o(t) {
        return d.call(y, t) || {};
      }, i = function i(t) {
        return v.call(y, t);
      };
    } else {
      var m = f("state");
      h[m] = !0, r = function r(t, e) {
        return l(t, m, e), e;
      }, o = function o(t) {
        return s(t, m) ? t[m] : {};
      }, i = function i(t) {
        return s(t, m);
      };
    }

    t.exports = {
      set: r,
      get: o,
      has: i,
      enforce: function enforce(t) {
        return i(t) ? o(t) : r(t, {});
      },
      getterFor: function getterFor(t) {
        return function (e) {
          var n;
          if (!c(e) || (n = o(e)).type !== t) throw TypeError("Incompatible receiver, " + t + " required");
          return n;
        };
      }
    };
  }, function (t, e, n) {
    var r = n(33),
        o = Function.toString;
    "function" != typeof r.inspectSource && (r.inspectSource = function (t) {
      return o.call(t);
    }), t.exports = r.inspectSource;
  }, function (t, e, n) {
    var r = n(2),
        o = n(21),
        i = r["__core-js_shared__"] || o("__core-js_shared__", {});
    t.exports = i;
  }, function (t, e, n) {
    var r = n(12),
        o = n(7),
        i = n(35);
    t.exports = !r && !o(function () {
      return 7 != Object.defineProperty(i("div"), "a", {
        get: function get() {
          return 7;
        }
      }).a;
    });
  }, function (t, e, n) {
    var r = n(2),
        o = n(9),
        i = r.document,
        u = o(i) && o(i.createElement);

    t.exports = function (t) {
      return u ? i.createElement(t) : {};
    };
  }, function (t, e, n) {
    var r = n(16),
        o = n(33);
    (t.exports = function (t, e) {
      return o[t] || (o[t] = void 0 !== e ? e : {});
    })("versions", []).push({
      version: "3.6.5",
      mode: r ? "pure" : "global",
      copyright: "© 2020 Denis Pushkarev (zloirock.ru)"
    });
  }, function (t, e) {
    var n = 0,
        r = Math.random();

    t.exports = function (t) {
      return "Symbol(" + String(void 0 === t ? "" : t) + ")_" + (++n + r).toString(36);
    };
  }, function (t, e, n) {
    var r = n(2),
        o = n(6),
        i = n(4),
        u = n(21),
        a = n(32),
        c = n(31),
        l = c.get,
        s = c.enforce,
        f = String(String).split("String");
    (t.exports = function (t, e, n, a) {
      var c = !!a && !!a.unsafe,
          l = !!a && !!a.enumerable,
          h = !!a && !!a.noTargetGet;
      "function" == typeof n && ("string" != typeof e || i(n, "name") || o(n, "name", e), s(n).source = f.join("string" == typeof e ? e : "")), t !== r ? (c ? !h && t[e] && (l = !0) : delete t[e], l ? t[e] = n : o(t, e, n)) : l ? t[e] = n : u(e, n);
    })(Function.prototype, "toString", function () {
      return "function" == typeof this && l(this).source || a(this);
    });
  }, function (t, e, n) {
    var r = n(40),
        o = n(2),
        i = function i(t) {
      return "function" == typeof t ? t : void 0;
    };

    t.exports = function (t, e) {
      return arguments.length < 2 ? i(r[t]) || i(o[t]) : r[t] && r[t][e] || o[t] && o[t][e];
    };
  }, function (t, e, n) {
    var r = n(2);
    t.exports = r;
  }, function (t, e, n) {
    var r = n(4),
        o = n(26),
        i = n(63).indexOf,
        u = n(24);

    t.exports = function (t, e) {
      var n,
          a = o(t),
          c = 0,
          l = [];

      for (n in a) {
        !r(u, n) && r(a, n) && l.push(n);
      }

      for (; e.length > c;) {
        r(a, n = e[c++]) && (~i(l, n) || l.push(n));
      }

      return l;
    };
  }, function (t, e, n) {
    var r = n(20),
        o = Math.max,
        i = Math.min;

    t.exports = function (t, e) {
      var n = r(t);
      return n < 0 ? o(n + e, 0) : i(n, e);
    };
  }, function (t, e, n) {
    "use strict";

    var r,
        o,
        i,
        u = n(44),
        a = n(6),
        c = n(4),
        l = n(3),
        s = n(16),
        f = l("iterator"),
        h = !1;
    [].keys && ("next" in (i = [].keys()) ? (o = u(u(i))) !== Object.prototype && (r = o) : h = !0), null == r && (r = {}), s || c(r, f) || a(r, f, function () {
      return this;
    }), t.exports = {
      IteratorPrototype: r,
      BUGGY_SAFARI_ITERATORS: h
    };
  }, function (t, e, n) {
    var r = n(4),
        o = n(29),
        i = n(23),
        u = n(67),
        a = i("IE_PROTO"),
        c = Object.prototype;
    t.exports = u ? Object.getPrototypeOf : function (t) {
      return t = o(t), r(t, a) ? t[a] : "function" == typeof t.constructor && t instanceof t.constructor ? t.constructor.prototype : t instanceof Object ? c : null;
    };
  }, function (t, e, n) {
    var r = n(7);
    t.exports = !!Object.getOwnPropertySymbols && !r(function () {
      return !String(Symbol());
    });
  }, function (t, e, n) {
    var r,
        o = n(10),
        i = n(69),
        u = n(28),
        a = n(24),
        c = n(71),
        l = n(35),
        s = n(23),
        f = s("IE_PROTO"),
        h = function h() {},
        p = function p(t) {
      return "<script>" + t + "<\/script>";
    },
        _y = function y() {
      try {
        r = document.domain && new ActiveXObject("htmlfile");
      } catch (t) {}

      var t, e;
      _y = r ? function (t) {
        t.write(p("")), t.close();
        var e = t.parentWindow.Object;
        return t = null, e;
      }(r) : ((e = l("iframe")).style.display = "none", c.appendChild(e), e.src = String("javascript:"), (t = e.contentWindow.document).open(), t.write(p("document.F=Object")), t.close(), t.F);

      for (var n = u.length; n--;) {
        delete _y.prototype[u[n]];
      }

      return _y();
    };

    a[f] = !0, t.exports = Object.create || function (t, e) {
      var n;
      return null !== t ? (h.prototype = o(t), n = new h(), h.prototype = null, n[f] = t) : n = _y(), void 0 === e ? n : i(n, e);
    };
  }, function (t, e, n) {
    var r = n(8).f,
        o = n(4),
        i = n(3)("toStringTag");

    t.exports = function (t, e, n) {
      t && !o(t = n ? t : t.prototype, i) && r(t, i, {
        configurable: !0,
        value: e
      });
    };
  }, function (t, e, n) {
    var r = n(76);

    t.exports = function (t, e, n) {
      if (r(t), void 0 === e) return t;

      switch (n) {
        case 0:
          return function () {
            return t.call(e);
          };

        case 1:
          return function (n) {
            return t.call(e, n);
          };

        case 2:
          return function (n, r) {
            return t.call(e, n, r);
          };

        case 3:
          return function (n, r, o) {
            return t.call(e, n, r, o);
          };
      }

      return function () {
        return t.apply(e, arguments);
      };
    };
  }, function (t, e, n) {
    var r = n(2),
        o = n(48),
        i = Function.call;

    t.exports = function (t, e, n) {
      return o(i, r[t].prototype[e], n);
    };
  }, function (t, e, n) {
    "use strict";

    var r = this && this.__importDefault || function (t) {
      return t && t.__esModule ? t : {
        default: t
      };
    };

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var o,
        i = r(n(97));
    !function (t) {
      t.iterator = function (t) {
        return new i.default(t);
      }, t.length = function (t) {
        return "number" == typeof t.delete ? t.delete : "number" == typeof t.retain ? t.retain : "string" == typeof t.insert ? t.insert.length : 1;
      };
    }(o || (o = {})), e.default = o;
  }, function (t, e, n) {
    "use strict";

    var r = Object.prototype.hasOwnProperty,
        o = "~";

    function i() {}

    function u(t, e, n) {
      this.fn = t, this.context = e, this.once = n || !1;
    }

    function a(t, e, n, r, i) {
      if ("function" != typeof n) throw new TypeError("The listener must be a function");
      var a = new u(n, r || t, i),
          c = o ? o + e : e;
      return t._events[c] ? t._events[c].fn ? t._events[c] = [t._events[c], a] : t._events[c].push(a) : (t._events[c] = a, t._eventsCount++), t;
    }

    function c(t, e) {
      0 == --t._eventsCount ? t._events = new i() : delete t._events[e];
    }

    function l() {
      this._events = new i(), this._eventsCount = 0;
    }

    Object.create && (i.prototype = Object.create(null), new i().__proto__ || (o = !1)), l.prototype.eventNames = function () {
      var t,
          e,
          n = [];
      if (0 === this._eventsCount) return n;

      for (e in t = this._events) {
        r.call(t, e) && n.push(o ? e.slice(1) : e);
      }

      return Object.getOwnPropertySymbols ? n.concat(Object.getOwnPropertySymbols(t)) : n;
    }, l.prototype.listeners = function (t) {
      var e = o ? o + t : t,
          n = this._events[e];
      if (!n) return [];
      if (n.fn) return [n.fn];

      for (var r = 0, i = n.length, u = new Array(i); r < i; r++) {
        u[r] = n[r].fn;
      }

      return u;
    }, l.prototype.listenerCount = function (t) {
      var e = o ? o + t : t,
          n = this._events[e];
      return n ? n.fn ? 1 : n.length : 0;
    }, l.prototype.emit = function (t, e, n, r, i, u) {
      var a = o ? o + t : t;
      if (!this._events[a]) return !1;
      var c,
          l,
          s = this._events[a],
          f = arguments.length;

      if (s.fn) {
        switch (s.once && this.removeListener(t, s.fn, void 0, !0), f) {
          case 1:
            return s.fn.call(s.context), !0;

          case 2:
            return s.fn.call(s.context, e), !0;

          case 3:
            return s.fn.call(s.context, e, n), !0;

          case 4:
            return s.fn.call(s.context, e, n, r), !0;

          case 5:
            return s.fn.call(s.context, e, n, r, i), !0;

          case 6:
            return s.fn.call(s.context, e, n, r, i, u), !0;
        }

        for (l = 1, c = new Array(f - 1); l < f; l++) {
          c[l - 1] = arguments[l];
        }

        s.fn.apply(s.context, c);
      } else {
        var h,
            p = s.length;

        for (l = 0; l < p; l++) {
          switch (s[l].once && this.removeListener(t, s[l].fn, void 0, !0), f) {
            case 1:
              s[l].fn.call(s[l].context);
              break;

            case 2:
              s[l].fn.call(s[l].context, e);
              break;

            case 3:
              s[l].fn.call(s[l].context, e, n);
              break;

            case 4:
              s[l].fn.call(s[l].context, e, n, r);
              break;

            default:
              if (!c) for (h = 1, c = new Array(f - 1); h < f; h++) {
                c[h - 1] = arguments[h];
              }
              s[l].fn.apply(s[l].context, c);
          }
        }
      }

      return !0;
    }, l.prototype.on = function (t, e, n) {
      return a(this, t, e, n, !1);
    }, l.prototype.once = function (t, e, n) {
      return a(this, t, e, n, !0);
    }, l.prototype.removeListener = function (t, e, n, r) {
      var i = o ? o + t : t;
      if (!this._events[i]) return this;
      if (!e) return c(this, i), this;
      var u = this._events[i];
      if (u.fn) u.fn !== e || r && !u.once || n && u.context !== n || c(this, i);else {
        for (var a = 0, l = [], s = u.length; a < s; a++) {
          (u[a].fn !== e || r && !u[a].once || n && u[a].context !== n) && l.push(u[a]);
        }

        l.length ? this._events[i] = 1 === l.length ? l[0] : l : c(this, i);
      }
      return this;
    }, l.prototype.removeAllListeners = function (t) {
      var e;
      return t ? (e = o ? o + t : t, this._events[e] && c(this, e)) : (this._events = new i(), this._eventsCount = 0), this;
    }, l.prototype.off = l.prototype.removeListener, l.prototype.addListener = l.prototype.on, l.prefixed = o, l.EventEmitter = l, t.exports = l;
  }, function (t, e, n) {
    var r = n(53);
    t.exports = r;
  }, function (t, e, n) {
    n(54), n(74);
    var r = n(40);
    t.exports = r.Array.from;
  }, function (t, e, n) {
    "use strict";

    var r = n(55).charAt,
        o = n(31),
        i = n(57),
        u = o.set,
        a = o.getterFor("String Iterator");
    i(String, "String", function (t) {
      u(this, {
        type: "String Iterator",
        string: String(t),
        index: 0
      });
    }, function () {
      var t,
          e = a(this),
          n = e.string,
          o = e.index;
      return o >= n.length ? {
        value: void 0,
        done: !0
      } : (t = r(n, o), e.index += t.length, {
        value: t,
        done: !1
      });
    });
  }, function (t, e, n) {
    var r = n(20),
        o = n(13),
        i = function i(t) {
      return function (e, n) {
        var i,
            u,
            a = String(o(e)),
            c = r(n),
            l = a.length;
        return c < 0 || c >= l ? t ? "" : void 0 : (i = a.charCodeAt(c)) < 55296 || i > 56319 || c + 1 === l || (u = a.charCodeAt(c + 1)) < 56320 || u > 57343 ? t ? a.charAt(c) : i : t ? a.slice(c, c + 2) : u - 56320 + (i - 55296 << 10) + 65536;
      };
    };

    t.exports = {
      codeAt: i(!1),
      charAt: i(!0)
    };
  }, function (t, e, n) {
    var r = n(2),
        o = n(32),
        i = r.WeakMap;
    t.exports = "function" == typeof i && /native code/.test(o(i));
  }, function (t, e, n) {
    "use strict";

    var r = n(17),
        o = n(66),
        i = n(44),
        u = n(72),
        a = n(47),
        c = n(6),
        l = n(38),
        s = n(3),
        f = n(16),
        h = n(19),
        p = n(43),
        y = p.IteratorPrototype,
        d = p.BUGGY_SAFARI_ITERATORS,
        v = s("iterator"),
        b = function b() {
      return this;
    };

    t.exports = function (t, e, n, s, p, m, g) {
      o(n, e, s);

      var O,
          w,
          _,
          j = function j(t) {
        if (t === p && E) return E;
        if (!d && t in S) return S[t];

        switch (t) {
          case "keys":
          case "values":
          case "entries":
            return function () {
              return new n(this, t);
            };
        }

        return function () {
          return new n(this);
        };
      },
          N = e + " Iterator",
          k = !1,
          S = t.prototype,
          x = S[v] || S["@@iterator"] || p && S[p],
          E = !d && x || j(p),
          A = "Array" == e && S.entries || x;

      if (A && (O = i(A.call(new t())), y !== Object.prototype && O.next && (f || i(O) === y || (u ? u(O, y) : "function" != typeof O[v] && c(O, v, b)), a(O, N, !0, !0), f && (h[N] = b))), "values" == p && x && "values" !== x.name && (k = !0, E = function E() {
        return x.call(this);
      }), f && !g || S[v] === E || c(S, v, E), h[e] = E, p) if (w = {
        values: j("values"),
        keys: m ? E : j("keys"),
        entries: j("entries")
      }, g) for (_ in w) {
        (d || k || !(_ in S)) && l(S, _, w[_]);
      } else r({
        target: e,
        proto: !0,
        forced: d || k
      }, w);
      return w;
    };
  }, function (t, e, n) {
    "use strict";

    var r = {}.propertyIsEnumerable,
        o = Object.getOwnPropertyDescriptor,
        i = o && !r.call({
      1: 2
    }, 1);
    e.f = i ? function (t) {
      var e = o(this, t);
      return !!e && e.enumerable;
    } : r;
  }, function (t, e, n) {
    var r = n(7),
        o = n(27),
        i = "".split;
    t.exports = r(function () {
      return !Object("z").propertyIsEnumerable(0);
    }) ? function (t) {
      return "String" == o(t) ? i.call(t, "") : Object(t);
    } : Object;
  }, function (t, e, n) {
    var r = n(4),
        o = n(61),
        i = n(25),
        u = n(8);

    t.exports = function (t, e) {
      for (var n = o(e), a = u.f, c = i.f, l = 0; l < n.length; l++) {
        var s = n[l];
        r(t, s) || a(t, s, c(e, s));
      }
    };
  }, function (t, e, n) {
    var r = n(39),
        o = n(62),
        i = n(64),
        u = n(10);

    t.exports = r("Reflect", "ownKeys") || function (t) {
      var e = o.f(u(t)),
          n = i.f;
      return n ? e.concat(n(t)) : e;
    };
  }, function (t, e, n) {
    var r = n(41),
        o = n(28).concat("length", "prototype");

    e.f = Object.getOwnPropertyNames || function (t) {
      return r(t, o);
    };
  }, function (t, e, n) {
    var r = n(26),
        o = n(18),
        i = n(42),
        u = function u(t) {
      return function (e, n, u) {
        var a,
            c = r(e),
            l = o(c.length),
            s = i(u, l);

        if (t && n != n) {
          for (; l > s;) {
            if ((a = c[s++]) != a) return !0;
          }
        } else for (; l > s; s++) {
          if ((t || s in c) && c[s] === n) return t || s || 0;
        }

        return !t && -1;
      };
    };

    t.exports = {
      includes: u(!0),
      indexOf: u(!1)
    };
  }, function (t, e) {
    e.f = Object.getOwnPropertySymbols;
  }, function (t, e, n) {
    var r = n(7),
        o = /#|\.prototype\./,
        i = function i(t, e) {
      var n = a[u(t)];
      return n == l || n != c && ("function" == typeof e ? r(e) : !!e);
    },
        u = i.normalize = function (t) {
      return String(t).replace(o, ".").toLowerCase();
    },
        a = i.data = {},
        c = i.NATIVE = "N",
        l = i.POLYFILL = "P";

    t.exports = i;
  }, function (t, e, n) {
    "use strict";

    var r = n(43).IteratorPrototype,
        o = n(46),
        i = n(15),
        u = n(47),
        a = n(19),
        c = function c() {
      return this;
    };

    t.exports = function (t, e, n) {
      var l = e + " Iterator";
      return t.prototype = o(r, {
        next: i(1, n)
      }), u(t, l, !1, !0), a[l] = c, t;
    };
  }, function (t, e, n) {
    var r = n(7);
    t.exports = !r(function () {
      function t() {}

      return t.prototype.constructor = null, Object.getPrototypeOf(new t()) !== t.prototype;
    });
  }, function (t, e, n) {
    var r = n(45);
    t.exports = r && !Symbol.sham && "symbol" == typeof Symbol.iterator;
  }, function (t, e, n) {
    var r = n(12),
        o = n(8),
        i = n(10),
        u = n(70);
    t.exports = r ? Object.defineProperties : function (t, e) {
      i(t);

      for (var n, r = u(e), a = r.length, c = 0; a > c;) {
        o.f(t, n = r[c++], e[n]);
      }

      return t;
    };
  }, function (t, e, n) {
    var r = n(41),
        o = n(28);

    t.exports = Object.keys || function (t) {
      return r(t, o);
    };
  }, function (t, e, n) {
    var r = n(39);
    t.exports = r("document", "documentElement");
  }, function (t, e, n) {
    var r = n(10),
        o = n(73);
    t.exports = Object.setPrototypeOf || ("__proto__" in {} ? function () {
      var t,
          e = !1,
          n = {};

      try {
        (t = Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set).call(n, []), e = n instanceof Array;
      } catch (t) {}

      return function (n, i) {
        return r(n), o(i), e ? t.call(n, i) : n.__proto__ = i, n;
      };
    }() : void 0);
  }, function (t, e, n) {
    var r = n(9);

    t.exports = function (t) {
      if (!r(t) && null !== t) throw TypeError("Can't set " + String(t) + " as a prototype");
      return t;
    };
  }, function (t, e, n) {
    var r = n(17),
        o = n(75);
    r({
      target: "Array",
      stat: !0,
      forced: !n(83)(function (t) {
        Array.from(t);
      })
    }, {
      from: o
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(48),
        o = n(29),
        i = n(77),
        u = n(78),
        a = n(18),
        c = n(79),
        l = n(80);

    t.exports = function (t) {
      var e,
          n,
          s,
          f,
          h,
          p,
          y = o(t),
          d = "function" == typeof this ? this : Array,
          v = arguments.length,
          b = v > 1 ? arguments[1] : void 0,
          m = void 0 !== b,
          g = l(y),
          O = 0;
      if (m && (b = r(b, v > 2 ? arguments[2] : void 0, 2)), null == g || d == Array && u(g)) for (n = new d(e = a(y.length)); e > O; O++) {
        p = m ? b(y[O], O) : y[O], c(n, O, p);
      } else for (h = (f = g.call(y)).next, n = new d(); !(s = h.call(f)).done; O++) {
        p = m ? i(f, b, [s.value, O], !0) : s.value, c(n, O, p);
      }
      return n.length = O, n;
    };
  }, function (t, e) {
    t.exports = function (t) {
      if ("function" != typeof t) throw TypeError(String(t) + " is not a function");
      return t;
    };
  }, function (t, e, n) {
    var r = n(10);

    t.exports = function (t, e, n, o) {
      try {
        return o ? e(r(n)[0], n[1]) : e(n);
      } catch (e) {
        var i = t.return;
        throw void 0 !== i && r(i.call(t)), e;
      }
    };
  }, function (t, e, n) {
    var r = n(3),
        o = n(19),
        i = r("iterator"),
        u = Array.prototype;

    t.exports = function (t) {
      return void 0 !== t && (o.Array === t || u[i] === t);
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(22),
        o = n(8),
        i = n(15);

    t.exports = function (t, e, n) {
      var u = r(e);
      u in t ? o.f(t, u, i(0, n)) : t[u] = n;
    };
  }, function (t, e, n) {
    var r = n(81),
        o = n(19),
        i = n(3)("iterator");

    t.exports = function (t) {
      if (null != t) return t[i] || t["@@iterator"] || o[r(t)];
    };
  }, function (t, e, n) {
    var r = n(82),
        o = n(27),
        i = n(3)("toStringTag"),
        u = "Arguments" == o(function () {
      return arguments;
    }());
    t.exports = r ? o : function (t) {
      var e, n, r;
      return void 0 === t ? "Undefined" : null === t ? "Null" : "string" == typeof (n = function (t, e) {
        try {
          return t[e];
        } catch (t) {}
      }(e = Object(t), i)) ? n : u ? o(e) : "Object" == (r = o(e)) && "function" == typeof e.callee ? "Arguments" : r;
    };
  }, function (t, e, n) {
    var r = {};
    r[n(3)("toStringTag")] = "z", t.exports = "[object z]" === String(r);
  }, function (t, e, n) {
    var r = n(3)("iterator"),
        o = !1;

    try {
      var i = 0,
          u = {
        next: function next() {
          return {
            done: !!i++
          };
        },
        return: function _return() {
          o = !0;
        }
      };
      u[r] = function () {
        return this;
      }, Array.from(u, function () {
        throw 2;
      });
    } catch (t) {}

    t.exports = function (t, e) {
      if (!e && !o) return !1;
      var n = !1;

      try {
        var i = {};
        i[r] = function () {
          return {
            next: function next() {
              return {
                done: n = !0
              };
            }
          };
        }, t(i);
      } catch (t) {}

      return n;
    };
  }, function (t, e, n) {
    var r = n(85);
    t.exports = r;
  }, function (t, e, n) {
    n(86);
    var r = n(49);
    t.exports = r("Array", "fill");
  }, function (t, e, n) {
    var r = n(17),
        o = n(87),
        i = n(88);
    r({
      target: "Array",
      proto: !0
    }, {
      fill: o
    }), i("fill");
  }, function (t, e, n) {
    "use strict";

    var r = n(29),
        o = n(42),
        i = n(18);

    t.exports = function (t) {
      for (var e = r(this), n = i(e.length), u = arguments.length, a = o(u > 1 ? arguments[1] : void 0, n), c = u > 2 ? arguments[2] : void 0, l = void 0 === c ? n : o(c, n); l > a;) {
        e[a++] = t;
      }

      return e;
    };
  }, function (t, e, n) {
    var r = n(3),
        o = n(46),
        i = n(8),
        u = r("unscopables"),
        a = Array.prototype;
    null == a[u] && i.f(a, u, {
      configurable: !0,
      value: o(null)
    }), t.exports = function (t) {
      a[u][t] = !0;
    };
  }, function (t, e, n) {
    var r = n(90);
    t.exports = r;
  }, function (t, e, n) {
    n(91);
    var r = n(49);
    t.exports = r("String", "endsWith");
  }, function (t, e, n) {
    "use strict";

    var r,
        o = n(17),
        i = n(25).f,
        u = n(18),
        a = n(92),
        c = n(13),
        l = n(94),
        s = n(16),
        f = "".endsWith,
        h = Math.min,
        p = l("endsWith");
    o({
      target: "String",
      proto: !0,
      forced: !!(s || p || (r = i(String.prototype, "endsWith"), !r || r.writable)) && !p
    }, {
      endsWith: function endsWith(t) {
        var e = String(c(this));
        a(t);
        var n = arguments.length > 1 ? arguments[1] : void 0,
            r = u(e.length),
            o = void 0 === n ? r : h(u(n), r),
            i = String(t);
        return f ? f.call(e, i, o) : e.slice(o - i.length, o) === i;
      }
    });
  }, function (t, e, n) {
    var r = n(93);

    t.exports = function (t) {
      if (r(t)) throw TypeError("The method doesn't accept regular expressions");
      return t;
    };
  }, function (t, e, n) {
    var r = n(9),
        o = n(27),
        i = n(3)("match");

    t.exports = function (t) {
      var e;
      return r(t) && (void 0 !== (e = t[i]) ? !!e : "RegExp" == o(t));
    };
  }, function (t, e, n) {
    var r = n(3)("match");

    t.exports = function (t) {
      var e = /./;

      try {
        "/./"[t](e);
      } catch (n) {
        try {
          return e[r] = !1, "/./"[t](e);
        } catch (t) {}
      }

      return !1;
    };
  }, function (t, e) {
    function n(t, e, u, a) {
      if (t === e) return t ? [[0, t]] : [];

      if (null != u) {
        var f = function (t, e, n) {
          var r = "number" == typeof n ? {
            index: n,
            length: 0
          } : n.oldRange,
              o = "number" == typeof n ? null : n.newRange,
              i = t.length,
              u = e.length;

          if (0 === r.length && (null === o || 0 === o.length)) {
            var a = r.index,
                c = t.slice(0, a),
                l = t.slice(a),
                f = o ? o.index : null,
                h = a + u - i;

            if ((null === f || f === h) && !(h < 0 || h > u)) {
              var p = e.slice(0, h);

              if ((O = e.slice(h)) === l) {
                var y = Math.min(a, h),
                    d = c.slice(0, y),
                    v = p.slice(0, y);

                if (d === v) {
                  var b = c.slice(y),
                      m = p.slice(y);
                  return s(d, b, m, l);
                }
              }
            }

            if (null === f || f === a) {
              var g = a,
                  O = (p = e.slice(0, g), e.slice(g));

              if (p === c) {
                var w = Math.min(i - g, u - g),
                    _ = l.slice(l.length - w),
                    j = O.slice(O.length - w);

                if (_ === j) {
                  b = l.slice(0, l.length - w), m = O.slice(0, O.length - w);
                  return s(c, b, m, _);
                }
              }
            }
          }

          if (r.length > 0 && o && 0 === o.length) {
            d = t.slice(0, r.index), _ = t.slice(r.index + r.length), y = d.length, w = _.length;

            if (!(u < y + w)) {
              v = e.slice(0, y), j = e.slice(u - w);

              if (d === v && _ === j) {
                b = t.slice(y, i - w), m = e.slice(y, u - w);
                return s(d, b, m, _);
              }
            }
          }

          return null;
        }(t, e, u);

        if (f) return f;
      }

      var h = o(t, e),
          p = t.substring(0, h);
      h = i(t = t.substring(h), e = e.substring(h));

      var y = t.substring(t.length - h),
          d = function (t, e) {
        var u;
        if (!t) return [[1, e]];
        if (!e) return [[-1, t]];
        var a = t.length > e.length ? t : e,
            c = t.length > e.length ? e : t,
            l = a.indexOf(c);
        if (-1 !== l) return u = [[1, a.substring(0, l)], [0, c], [1, a.substring(l + c.length)]], t.length > e.length && (u[0][0] = u[2][0] = -1), u;
        if (1 === c.length) return [[-1, t], [1, e]];

        var s = function (t, e) {
          var n = t.length > e.length ? t : e,
              r = t.length > e.length ? e : t;
          if (n.length < 4 || 2 * r.length < n.length) return null;

          function u(t, e, n) {
            for (var r, u, a, c, l = t.substring(n, n + Math.floor(t.length / 4)), s = -1, f = ""; -1 !== (s = e.indexOf(l, s + 1));) {
              var h = o(t.substring(n), e.substring(s)),
                  p = i(t.substring(0, n), e.substring(0, s));
              f.length < p + h && (f = e.substring(s - p, s) + e.substring(s, s + h), r = t.substring(0, n - p), u = t.substring(n + h), a = e.substring(0, s - p), c = e.substring(s + h));
            }

            return 2 * f.length >= t.length ? [r, u, a, c, f] : null;
          }

          var a,
              c,
              l,
              s,
              f,
              h = u(n, r, Math.ceil(n.length / 4)),
              p = u(n, r, Math.ceil(n.length / 2));
          if (!h && !p) return null;
          a = p ? h && h[4].length > p[4].length ? h : p : h;
          t.length > e.length ? (c = a[0], l = a[1], s = a[2], f = a[3]) : (s = a[0], f = a[1], c = a[2], l = a[3]);
          var y = a[4];
          return [c, l, s, f, y];
        }(t, e);

        if (s) {
          var f = s[0],
              h = s[1],
              p = s[2],
              y = s[3],
              d = s[4],
              v = n(f, p),
              b = n(h, y);
          return v.concat([[0, d]], b);
        }

        return function (t, e) {
          for (var n = t.length, o = e.length, i = Math.ceil((n + o) / 2), u = i, a = 2 * i, c = new Array(a), l = new Array(a), s = 0; s < a; s++) {
            c[s] = -1, l[s] = -1;
          }

          c[u + 1] = 0, l[u + 1] = 0;

          for (var f = n - o, h = f % 2 != 0, p = 0, y = 0, d = 0, v = 0, b = 0; b < i; b++) {
            for (var m = -b + p; m <= b - y; m += 2) {
              for (var g = u + m, O = (k = m === -b || m !== b && c[g - 1] < c[g + 1] ? c[g + 1] : c[g - 1] + 1) - m; k < n && O < o && t.charAt(k) === e.charAt(O);) {
                k++, O++;
              }

              if (c[g] = k, k > n) y += 2;else if (O > o) p += 2;else if (h) {
                if ((j = u + f - m) >= 0 && j < a && -1 !== l[j]) {
                  var w = n - l[j];
                  if (k >= w) return r(t, e, k, O);
                }
              }
            }

            for (var _ = -b + d; _ <= b - v; _ += 2) {
              for (var j = u + _, N = (w = _ === -b || _ !== b && l[j - 1] < l[j + 1] ? l[j + 1] : l[j - 1] + 1) - _; w < n && N < o && t.charAt(n - w - 1) === e.charAt(o - N - 1);) {
                w++, N++;
              }

              if (l[j] = w, w > n) v += 2;else if (N > o) d += 2;else if (!h) {
                if ((g = u + f - _) >= 0 && g < a && -1 !== c[g]) {
                  var k = c[g];
                  O = u + k - g;
                  if (k >= (w = n - w)) return r(t, e, k, O);
                }
              }
            }
          }

          return [[-1, t], [1, e]];
        }(t, e);
      }(t = t.substring(0, t.length - h), e = e.substring(0, e.length - h));

      return p && d.unshift([0, p]), y && d.push([0, y]), function t(e, n) {
        e.push([0, ""]);
        var r,
            u = 0,
            a = 0,
            s = 0,
            f = "",
            h = "";

        for (; u < e.length;) {
          if (u < e.length - 1 && !e[u][1]) e.splice(u, 1);else switch (e[u][0]) {
            case 1:
              s++, h += e[u][1], u++;
              break;

            case -1:
              a++, f += e[u][1], u++;
              break;

            case 0:
              var p = u - s - a - 1;

              if (n) {
                if (p >= 0 && l(e[p][1])) {
                  var y = e[p][1].slice(-1);

                  if (e[p][1] = e[p][1].slice(0, -1), f = y + f, h = y + h, !e[p][1]) {
                    e.splice(p, 1), u--;
                    var d = p - 1;
                    e[d] && 1 === e[d][0] && (s++, h = e[d][1] + h, d--), e[d] && -1 === e[d][0] && (a++, f = e[d][1] + f, d--), p = d;
                  }
                }

                if (c(e[u][1])) {
                  y = e[u][1].charAt(0);
                  e[u][1] = e[u][1].slice(1), f += y, h += y;
                }
              }

              if (u < e.length - 1 && !e[u][1]) {
                e.splice(u, 1);
                break;
              }

              if (f.length > 0 || h.length > 0) {
                f.length > 0 && h.length > 0 && (0 !== (r = o(h, f)) && (p >= 0 ? e[p][1] += h.substring(0, r) : (e.splice(0, 0, [0, h.substring(0, r)]), u++), h = h.substring(r), f = f.substring(r)), 0 !== (r = i(h, f)) && (e[u][1] = h.substring(h.length - r) + e[u][1], h = h.substring(0, h.length - r), f = f.substring(0, f.length - r)));
                var v = s + a;
                0 === f.length && 0 === h.length ? (e.splice(u - v, v), u -= v) : 0 === f.length ? (e.splice(u - v, v, [1, h]), u = u - v + 1) : 0 === h.length ? (e.splice(u - v, v, [-1, f]), u = u - v + 1) : (e.splice(u - v, v, [-1, f], [1, h]), u = u - v + 2);
              }

              0 !== u && 0 === e[u - 1][0] ? (e[u - 1][1] += e[u][1], e.splice(u, 1)) : u++, s = 0, a = 0, f = "", h = "";
          }
        }

        "" === e[e.length - 1][1] && e.pop();
        var b = !1;
        u = 1;

        for (; u < e.length - 1;) {
          0 === e[u - 1][0] && 0 === e[u + 1][0] && (e[u][1].substring(e[u][1].length - e[u - 1][1].length) === e[u - 1][1] ? (e[u][1] = e[u - 1][1] + e[u][1].substring(0, e[u][1].length - e[u - 1][1].length), e[u + 1][1] = e[u - 1][1] + e[u + 1][1], e.splice(u - 1, 1), b = !0) : e[u][1].substring(0, e[u + 1][1].length) == e[u + 1][1] && (e[u - 1][1] += e[u + 1][1], e[u][1] = e[u][1].substring(e[u + 1][1].length) + e[u + 1][1], e.splice(u + 1, 1), b = !0)), u++;
        }

        b && t(e, n);
      }(d, a), d;
    }

    function r(t, e, r, o) {
      var i = t.substring(0, r),
          u = e.substring(0, o),
          a = t.substring(r),
          c = e.substring(o),
          l = n(i, u),
          s = n(a, c);
      return l.concat(s);
    }

    function o(t, e) {
      if (!t || !e || t.charAt(0) !== e.charAt(0)) return 0;

      for (var n = 0, r = Math.min(t.length, e.length), o = r, i = 0; n < o;) {
        t.substring(i, o) == e.substring(i, o) ? i = n = o : r = o, o = Math.floor((r - n) / 2 + n);
      }

      return u(t.charCodeAt(o - 1)) && o--, o;
    }

    function i(t, e) {
      if (!t || !e || t.slice(-1) !== e.slice(-1)) return 0;

      for (var n = 0, r = Math.min(t.length, e.length), o = r, i = 0; n < o;) {
        t.substring(t.length - o, t.length - i) == e.substring(e.length - o, e.length - i) ? i = n = o : r = o, o = Math.floor((r - n) / 2 + n);
      }

      return a(t.charCodeAt(t.length - o)) && o--, o;
    }

    function u(t) {
      return t >= 55296 && t <= 56319;
    }

    function a(t) {
      return t >= 56320 && t <= 57343;
    }

    function c(t) {
      return a(t.charCodeAt(0));
    }

    function l(t) {
      return u(t.charCodeAt(t.length - 1));
    }

    function s(t, e, n, r) {
      return l(t) || c(r) ? null : function (t) {
        for (var e = [], n = 0; n < t.length; n++) {
          t[n][1].length > 0 && e.push(t[n]);
        }

        return e;
      }([[0, t], [-1, e], [1, n], [0, r]]);
    }

    function f(t, e, r) {
      return n(t, e, r, !0);
    }

    f.INSERT = 1, f.DELETE = -1, f.EQUAL = 0, t.exports = f;
  }, function (t, e, n) {
    "use strict";

    var r = this && this.__importDefault || function (t) {
      return t && t.__esModule ? t : {
        default: t
      };
    };

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var o,
        i = r(n(1)),
        u = r(n(5));
    !function (t) {
      t.compose = function (t, e, n) {
        void 0 === t && (t = {}), void 0 === e && (e = {}), "object" != typeof t && (t = {}), "object" != typeof e && (e = {});
        var r = i.default(e);

        for (var o in n || (r = Object.keys(r).reduce(function (t, e) {
          return null != r[e] && (t[e] = r[e]), t;
        }, {})), t) {
          void 0 !== t[o] && void 0 === e[o] && (r[o] = t[o]);
        }

        return Object.keys(r).length > 0 ? r : void 0;
      }, t.diff = function (t, e) {
        void 0 === t && (t = {}), void 0 === e && (e = {}), "object" != typeof t && (t = {}), "object" != typeof e && (e = {});
        var n = Object.keys(t).concat(Object.keys(e)).reduce(function (n, r) {
          return u.default(t[r], e[r]) || (n[r] = void 0 === e[r] ? null : e[r]), n;
        }, {});
        return Object.keys(n).length > 0 ? n : void 0;
      }, t.invert = function (t, e) {
        void 0 === t && (t = {}), void 0 === e && (e = {}), t = t || {};
        var n = Object.keys(e).reduce(function (n, r) {
          return e[r] !== t[r] && void 0 !== t[r] && (n[r] = e[r]), n;
        }, {});
        return Object.keys(t).reduce(function (n, r) {
          return t[r] !== e[r] && void 0 === e[r] && (n[r] = null), n;
        }, n);
      }, t.transform = function (t, e, n) {
        if (void 0 === n && (n = !1), "object" != typeof t) return e;

        if ("object" == typeof e) {
          if (!n) return e;
          var r = Object.keys(e).reduce(function (n, r) {
            return void 0 === t[r] && (n[r] = e[r]), n;
          }, {});
          return Object.keys(r).length > 0 ? r : void 0;
        }
      };
    }(o || (o = {})), e.default = o;
  }, function (t, e, n) {
    "use strict";

    var r = this && this.__importDefault || function (t) {
      return t && t.__esModule ? t : {
        default: t
      };
    };

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var o = r(n(50)),
        i = function () {
      function t(t) {
        this.ops = t, this.index = 0, this.offset = 0;
      }

      return t.prototype.hasNext = function () {
        return this.peekLength() < 1 / 0;
      }, t.prototype.next = function (t) {
        t || (t = 1 / 0);
        var e = this.ops[this.index];

        if (e) {
          var n = this.offset,
              r = o.default.length(e);
          if (t >= r - n ? (t = r - n, this.index += 1, this.offset = 0) : this.offset += t, "number" == typeof e.delete) return {
            delete: t
          };
          var i = {};
          return e.attributes && (i.attributes = e.attributes), "number" == typeof e.retain ? i.retain = t : "string" == typeof e.insert ? i.insert = e.insert.substr(n, t) : i.insert = e.insert, i;
        }

        return {
          retain: 1 / 0
        };
      }, t.prototype.peek = function () {
        return this.ops[this.index];
      }, t.prototype.peekLength = function () {
        return this.ops[this.index] ? o.default.length(this.ops[this.index]) - this.offset : 1 / 0;
      }, t.prototype.peekType = function () {
        return this.ops[this.index] ? "number" == typeof this.ops[this.index].delete ? "delete" : "number" == typeof this.ops[this.index].retain ? "retain" : "insert" : "retain";
      }, t.prototype.rest = function () {
        if (this.hasNext()) {
          if (0 === this.offset) return this.ops.slice(this.index);
          var t = this.offset,
              e = this.index,
              n = this.next(),
              r = this.ops.slice(this.index);
          return this.offset = t, this.index = e, [n].concat(r);
        }

        return [];
      }, t;
    }();

    e.default = i;
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = {};
    n.r(r), n.d(r, "ParentBlot", function () {
      return O;
    }), n.d(r, "ContainerBlot", function () {
      return _;
    }), n.d(r, "LeafBlot", function () {
      return N;
    }), n.d(r, "EmbedBlot", function () {
      return B;
    }), n.d(r, "ScrollBlot", function () {
      return z;
    }), n.d(r, "BlockBlot", function () {
      return q;
    }), n.d(r, "InlineBlot", function () {
      return L;
    }), n.d(r, "TextBlot", function () {
      return K;
    }), n.d(r, "Attributor", function () {
      return k;
    }), n.d(r, "ClassAttributor", function () {
      return E;
    }), n.d(r, "StyleAttributor", function () {
      return T;
    }), n.d(r, "AttributorStore", function () {
      return P;
    }), n.d(r, "Registry", function () {
      return v;
    }), n.d(r, "Scope", function () {
      return h;
    });
    n(52), n(84), n(89);
    var o,
        i = n(0),
        u = n.n(i),
        a = n(1),
        c = n.n(a),
        l = n(11),
        s = n.n(l);
    !function (t) {
      t[t.TYPE = 3] = "TYPE", t[t.LEVEL = 12] = "LEVEL", t[t.ATTRIBUTE = 13] = "ATTRIBUTE", t[t.BLOT = 14] = "BLOT", t[t.INLINE = 7] = "INLINE", t[t.BLOCK = 11] = "BLOCK", t[t.BLOCK_BLOT = 10] = "BLOCK_BLOT", t[t.INLINE_BLOT = 6] = "INLINE_BLOT", t[t.BLOCK_ATTRIBUTE = 9] = "BLOCK_ATTRIBUTE", t[t.INLINE_ATTRIBUTE = 5] = "INLINE_ATTRIBUTE", t[t.ANY = 15] = "ANY";
    }(o || (o = {}));

    var _f,
        h = o,
        p = function () {
      function t() {
        this.head = null, this.tail = null, this.length = 0;
      }

      return t.prototype.append = function () {
        for (var t = [], e = 0; e < arguments.length; e++) {
          t[e] = arguments[e];
        }

        if (this.insertBefore(t[0], null), t.length > 1) {
          var n = t.slice(1);
          this.append.apply(this, n);
        }
      }, t.prototype.at = function (t) {
        for (var e = this.iterator(), n = e(); n && t > 0;) {
          t -= 1, n = e();
        }

        return n;
      }, t.prototype.contains = function (t) {
        for (var e = this.iterator(), n = e(); n;) {
          if (n === t) return !0;
          n = e();
        }

        return !1;
      }, t.prototype.indexOf = function (t) {
        for (var e = this.iterator(), n = e(), r = 0; n;) {
          if (n === t) return r;
          r += 1, n = e();
        }

        return -1;
      }, t.prototype.insertBefore = function (t, e) {
        null != t && (this.remove(t), t.next = e, null != e ? (t.prev = e.prev, null != e.prev && (e.prev.next = t), e.prev = t, e === this.head && (this.head = t)) : null != this.tail ? (this.tail.next = t, t.prev = this.tail, this.tail = t) : (t.prev = null, this.head = this.tail = t), this.length += 1);
      }, t.prototype.offset = function (t) {
        for (var e = 0, n = this.head; null != n;) {
          if (n === t) return e;
          e += n.length(), n = n.next;
        }

        return -1;
      }, t.prototype.remove = function (t) {
        this.contains(t) && (null != t.prev && (t.prev.next = t.next), null != t.next && (t.next.prev = t.prev), t === this.head && (this.head = t.next), t === this.tail && (this.tail = t.prev), this.length -= 1);
      }, t.prototype.iterator = function (t) {
        return void 0 === t && (t = this.head), function () {
          var e = t;
          return null != t && (t = t.next), e;
        };
      }, t.prototype.find = function (t, e) {
        void 0 === e && (e = !1);

        for (var n = this.iterator(), r = n(); r;) {
          var o = r.length();
          if (t < o || e && t === o && (null == r.next || 0 !== r.next.length())) return [r, t];
          t -= o, r = n();
        }

        return [null, 0];
      }, t.prototype.forEach = function (t) {
        for (var e = this.iterator(), n = e(); n;) {
          t(n), n = e();
        }
      }, t.prototype.forEachAt = function (t, e, n) {
        if (!(e <= 0)) for (var r = this.find(t), o = r[0], i = t - r[1], u = this.iterator(o), a = u(); a && i < t + e;) {
          var c = a.length();
          t > i ? n(a, t - i, Math.min(e, i + c - t)) : n(a, 0, Math.min(c, t + e - i)), i += c, a = u();
        }
      }, t.prototype.map = function (t) {
        return this.reduce(function (e, n) {
          return e.push(t(n)), e;
        }, []);
      }, t.prototype.reduce = function (t, e) {
        for (var n = this.iterator(), r = n(); r;) {
          e = t(e, r), r = n();
        }

        return e;
      }, t;
    }(),
        y = (_f = function f(t, e) {
      return (_f = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (t, e) {
        t.__proto__ = e;
      } || function (t, e) {
        for (var n in e) {
          e.hasOwnProperty(n) && (t[n] = e[n]);
        }
      })(t, e);
    }, function (t, e) {
      function n() {
        this.constructor = t;
      }

      _f(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
    }),
        d = function (t) {
      function e(e) {
        var n = this;
        return e = "[Parchment] " + e, (n = t.call(this, e) || this).message = e, n.name = n.constructor.name, n;
      }

      return y(e, t), e;
    }(Error),
        v = function () {
      function t() {
        this.attributes = {}, this.classes = {}, this.tags = {}, this.types = {};
      }

      return t.find = function (t, e) {
        return void 0 === e && (e = !1), null == t ? null : this.blots.has(t) ? this.blots.get(t) || null : e ? this.find(t.parentNode, e) : null;
      }, t.prototype.create = function (e, n, r) {
        var o = this.query(n);
        if (null == o) throw new d("Unable to create " + n + " blot");
        var i = o,
            u = n instanceof Node || n.nodeType === Node.TEXT_NODE ? n : i.create(r),
            a = new i(e, u, r);
        return t.blots.set(a.domNode, a), a;
      }, t.prototype.find = function (e, n) {
        return void 0 === n && (n = !1), t.find(e, n);
      }, t.prototype.query = function (t, e) {
        var n,
            r = this;
        if (void 0 === e && (e = h.ANY), "string" == typeof t) n = this.types[t] || this.attributes[t];else if (t instanceof Text || t.nodeType === Node.TEXT_NODE) n = this.types.text;else if ("number" == typeof t) t & h.LEVEL & h.BLOCK ? n = this.types.block : t & h.LEVEL & h.INLINE && (n = this.types.inline);else if (t instanceof HTMLElement) {
          (t.getAttribute("class") || "").split(/\s+/).some(function (t) {
            return !!(n = r.classes[t]);
          }), n = n || this.tags[t.tagName];
        }
        return null == n ? null : e & h.LEVEL & n.scope && e & h.TYPE & n.scope ? n : null;
      }, t.prototype.register = function () {
        for (var t = this, e = [], n = 0; n < arguments.length; n++) {
          e[n] = arguments[n];
        }

        if (e.length > 1) return e.map(function (e) {
          return t.register(e);
        });
        var r = e[0];
        if ("string" != typeof r.blotName && "string" != typeof r.attrName) throw new d("Invalid definition");
        if ("abstract" === r.blotName) throw new d("Cannot register abstract class");
        if (this.types[r.blotName || r.attrName] = r, "string" == typeof r.keyName) this.attributes[r.keyName] = r;else if (null != r.className && (this.classes[r.className] = r), null != r.tagName) {
          Array.isArray(r.tagName) ? r.tagName = r.tagName.map(function (t) {
            return t.toUpperCase();
          }) : r.tagName = r.tagName.toUpperCase();
          var o = Array.isArray(r.tagName) ? r.tagName : [r.tagName];
          o.forEach(function (e) {
            null != t.tags[e] && null != r.className || (t.tags[e] = r);
          });
        }
        return r;
      }, t.blots = new WeakMap(), t;
    }(),
        b = function () {
      function t(t, e) {
        this.scroll = t, this.domNode = e, v.blots.set(e, this), this.prev = null, this.next = null;
      }

      return t.create = function (t) {
        if (null == this.tagName) throw new d("Blot definition missing tagName");
        var e;
        return Array.isArray(this.tagName) ? ("string" == typeof t && (t = t.toUpperCase(), parseInt(t, 10).toString() === t && (t = parseInt(t, 10))), e = "number" == typeof t ? document.createElement(this.tagName[t - 1]) : this.tagName.indexOf(t) > -1 ? document.createElement(t) : document.createElement(this.tagName[0])) : e = document.createElement(this.tagName), this.className && e.classList.add(this.className), e;
      }, Object.defineProperty(t.prototype, "statics", {
        get: function get() {
          return this.constructor;
        },
        enumerable: !0,
        configurable: !0
      }), t.prototype.attach = function () {}, t.prototype.clone = function () {
        var t = this.domNode.cloneNode(!1);
        return this.scroll.create(t);
      }, t.prototype.detach = function () {
        null != this.parent && this.parent.removeChild(this), v.blots.delete(this.domNode);
      }, t.prototype.deleteAt = function (t, e) {
        this.isolate(t, e).remove();
      }, t.prototype.formatAt = function (t, e, n, r) {
        var o = this.isolate(t, e);
        if (null != this.scroll.query(n, h.BLOT) && r) o.wrap(n, r);else if (null != this.scroll.query(n, h.ATTRIBUTE)) {
          var i = this.scroll.create(this.statics.scope);
          o.wrap(i), i.format(n, r);
        }
      }, t.prototype.insertAt = function (t, e, n) {
        var r = null == n ? this.scroll.create("text", e) : this.scroll.create(e, n),
            o = this.split(t);
        this.parent.insertBefore(r, o || void 0);
      }, t.prototype.isolate = function (t, e) {
        var n = this.split(t);
        if (null == n) throw new Error("Attempt to isolate at end");
        return n.split(e), n;
      }, t.prototype.length = function () {
        return 1;
      }, t.prototype.offset = function (t) {
        return void 0 === t && (t = this.parent), null == this.parent || this === t ? 0 : this.parent.children.offset(this) + this.parent.offset(t);
      }, t.prototype.optimize = function (t) {
        !this.statics.requiredContainer || this.parent instanceof this.statics.requiredContainer || this.wrap(this.statics.requiredContainer.blotName);
      }, t.prototype.remove = function () {
        null != this.domNode.parentNode && this.domNode.parentNode.removeChild(this.domNode), this.detach();
      }, t.prototype.replaceWith = function (t, e) {
        var n = "string" == typeof t ? this.scroll.create(t, e) : t;
        return null != this.parent && (this.parent.insertBefore(n, this.next || void 0), this.remove()), n;
      }, t.prototype.split = function (t, e) {
        return 0 === t ? this : this.next;
      }, t.prototype.update = function (t, e) {}, t.prototype.wrap = function (t, e) {
        var n = "string" == typeof t ? this.scroll.create(t, e) : t;
        if (null != this.parent && this.parent.insertBefore(n, this.next || void 0), "function" != typeof n.appendChild) throw new d("Cannot wrap " + t);
        return n.appendChild(this), n;
      }, t.blotName = "abstract", t;
    }(),
        m = function () {
      var _t2 = function t(e, n) {
        return (_t2 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var n in e) {
            e.hasOwnProperty(n) && (t[n] = e[n]);
          }
        })(e, n);
      };

      return function (e, n) {
        function r() {
          this.constructor = e;
        }

        _t2(e, n), e.prototype = null === n ? Object.create(n) : (r.prototype = n.prototype, new r());
      };
    }();

    function g(t, e) {
      var n = e.find(t);
      if (null == n) try {
        n = e.create(t);
      } catch (r) {
        n = e.create(h.INLINE), Array.from(t.childNodes).forEach(function (t) {
          n.domNode.appendChild(t);
        }), t.parentNode && t.parentNode.replaceChild(n.domNode, t), n.attach();
      }
      return n;
    }

    var O = function (t) {
      function e(e, n) {
        var r = t.call(this, e, n) || this;
        return r.uiNode = null, r.build(), r;
      }

      return m(e, t), e.prototype.appendChild = function (t) {
        this.insertBefore(t);
      }, e.prototype.attach = function () {
        t.prototype.attach.call(this), this.children.forEach(function (t) {
          t.attach();
        });
      }, e.prototype.attachUI = function (t) {
        null != this.uiNode && this.uiNode.remove(), this.uiNode = t, e.uiClass && this.uiNode.classList.add(e.uiClass), this.uiNode.setAttribute("contenteditable", "false"), this.domNode.insertBefore(this.uiNode, this.domNode.firstChild);
      }, e.prototype.build = function () {
        var t = this;
        this.children = new p(), Array.from(this.domNode.childNodes).filter(function (e) {
          return e !== t.uiNode;
        }).reverse().forEach(function (e) {
          try {
            var n = g(e, t.scroll);
            t.insertBefore(n, t.children.head || void 0);
          } catch (t) {
            if (t instanceof d) return;
            throw t;
          }
        });
      }, e.prototype.deleteAt = function (t, e) {
        if (0 === t && e === this.length()) return this.remove();
        this.children.forEachAt(t, e, function (t, e, n) {
          t.deleteAt(e, n);
        });
      }, e.prototype.descendant = function (t, n) {
        void 0 === n && (n = 0);
        var r = this.children.find(n),
            o = r[0],
            i = r[1];
        return null == t.blotName && t(o) || null != t.blotName && o instanceof t ? [o, i] : o instanceof e ? o.descendant(t, i) : [null, -1];
      }, e.prototype.descendants = function (t, n, r) {
        void 0 === n && (n = 0), void 0 === r && (r = Number.MAX_VALUE);
        var o = [],
            i = r;
        return this.children.forEachAt(n, r, function (n, r, u) {
          (null == t.blotName && t(n) || null != t.blotName && n instanceof t) && o.push(n), n instanceof e && (o = o.concat(n.descendants(t, r, i))), i -= u;
        }), o;
      }, e.prototype.detach = function () {
        this.children.forEach(function (t) {
          t.detach();
        }), t.prototype.detach.call(this);
      }, e.prototype.enforceAllowedChildren = function () {
        var t = this,
            n = !1;
        this.children.forEach(function (r) {
          n || t.statics.allowedChildren.some(function (t) {
            return r instanceof t;
          }) || (r.statics.scope === h.BLOCK_BLOT ? (null != r.next && t.splitAfter(r), null != r.prev && t.splitAfter(r.prev), r.parent.unwrap(), n = !0) : r instanceof e ? r.unwrap() : r.remove());
        });
      }, e.prototype.formatAt = function (t, e, n, r) {
        this.children.forEachAt(t, e, function (t, e, o) {
          t.formatAt(e, o, n, r);
        });
      }, e.prototype.insertAt = function (t, e, n) {
        var r = this.children.find(t),
            o = r[0],
            i = r[1];
        if (o) o.insertAt(i, e, n);else {
          var u = null == n ? this.scroll.create("text", e) : this.scroll.create(e, n);
          this.appendChild(u);
        }
      }, e.prototype.insertBefore = function (t, e) {
        null != t.parent && t.parent.children.remove(t);
        var n = null;
        this.children.insertBefore(t, e || null), t.parent = this, null != e && (n = e.domNode), this.domNode.parentNode === t.domNode && this.domNode.nextSibling === n || this.domNode.insertBefore(t.domNode, n), t.attach();
      }, e.prototype.length = function () {
        return this.children.reduce(function (t, e) {
          return t + e.length();
        }, 0);
      }, e.prototype.moveChildren = function (t, e) {
        this.children.forEach(function (n) {
          t.insertBefore(n, e);
        });
      }, e.prototype.optimize = function (e) {
        if (t.prototype.optimize.call(this, e), this.enforceAllowedChildren(), null != this.uiNode && this.uiNode !== this.domNode.firstChild && this.domNode.insertBefore(this.uiNode, this.domNode.firstChild), 0 === this.children.length) if (null != this.statics.defaultChild) {
          var n = this.scroll.create(this.statics.defaultChild.blotName);
          this.appendChild(n);
        } else this.remove();
      }, e.prototype.path = function (t, n) {
        void 0 === n && (n = !1);
        var r = this.children.find(t, n),
            o = r[0],
            i = r[1],
            u = [[this, t]];
        return o instanceof e ? u.concat(o.path(i, n)) : (null != o && u.push([o, i]), u);
      }, e.prototype.removeChild = function (t) {
        this.children.remove(t);
      }, e.prototype.replaceWith = function (n, r) {
        var o = "string" == typeof n ? this.scroll.create(n, r) : n;
        return o instanceof e && this.moveChildren(o), t.prototype.replaceWith.call(this, o);
      }, e.prototype.split = function (t, e) {
        if (void 0 === e && (e = !1), !e) {
          if (0 === t) return this;
          if (t === this.length()) return this.next;
        }

        var n = this.clone();
        return this.parent && this.parent.insertBefore(n, this.next || void 0), this.children.forEachAt(t, this.length(), function (t, r, o) {
          var i = t.split(r, e);
          null != i && n.appendChild(i);
        }), n;
      }, e.prototype.splitAfter = function (t) {
        for (var e = this.clone(); null != t.next;) {
          e.appendChild(t.next);
        }

        return this.parent && this.parent.insertBefore(e, this.next || void 0), e;
      }, e.prototype.unwrap = function () {
        this.parent && this.moveChildren(this.parent, this.next || void 0), this.remove();
      }, e.prototype.update = function (t, e) {
        var n = this,
            r = [],
            o = [];
        t.forEach(function (t) {
          t.target === n.domNode && "childList" === t.type && (r.push.apply(r, t.addedNodes), o.push.apply(o, t.removedNodes));
        }), o.forEach(function (t) {
          if (!(null != t.parentNode && "IFRAME" !== t.tagName && document.body.compareDocumentPosition(t) & Node.DOCUMENT_POSITION_CONTAINED_BY)) {
            var e = n.scroll.find(t);
            null != e && (null != e.domNode.parentNode && e.domNode.parentNode !== n.domNode || e.detach());
          }
        }), r.filter(function (t) {
          return t.parentNode === n.domNode || t === n.uiNode;
        }).sort(function (t, e) {
          return t === e ? 0 : t.compareDocumentPosition(e) & Node.DOCUMENT_POSITION_FOLLOWING ? 1 : -1;
        }).forEach(function (t) {
          var e = null;
          null != t.nextSibling && (e = n.scroll.find(t.nextSibling));
          var r = g(t, n.scroll);
          r.next === e && null != r.next || (null != r.parent && r.parent.removeChild(n), n.insertBefore(r, e || void 0));
        }), this.enforceAllowedChildren();
      }, e.uiClass = "", e;
    }(b),
        w = function () {
      var _t3 = function t(e, n) {
        return (_t3 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var n in e) {
            e.hasOwnProperty(n) && (t[n] = e[n]);
          }
        })(e, n);
      };

      return function (e, n) {
        function r() {
          this.constructor = e;
        }

        _t3(e, n), e.prototype = null === n ? Object.create(n) : (r.prototype = n.prototype, new r());
      };
    }(),
        _ = function (t) {
      function e() {
        return null !== t && t.apply(this, arguments) || this;
      }

      return w(e, t), e.prototype.checkMerge = function () {
        return null !== this.next && this.next.statics.blotName === this.statics.blotName;
      }, e.prototype.deleteAt = function (e, n) {
        t.prototype.deleteAt.call(this, e, n), this.enforceAllowedChildren();
      }, e.prototype.formatAt = function (e, n, r, o) {
        t.prototype.formatAt.call(this, e, n, r, o), this.enforceAllowedChildren();
      }, e.prototype.insertAt = function (e, n, r) {
        t.prototype.insertAt.call(this, e, n, r), this.enforceAllowedChildren();
      }, e.prototype.optimize = function (e) {
        t.prototype.optimize.call(this, e), this.children.length > 0 && null != this.next && this.checkMerge() && (this.next.moveChildren(this), this.next.remove());
      }, e.blotName = "container", e.scope = h.BLOCK_BLOT, e;
    }(O),
        j = function () {
      var _t4 = function t(e, n) {
        return (_t4 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var n in e) {
            e.hasOwnProperty(n) && (t[n] = e[n]);
          }
        })(e, n);
      };

      return function (e, n) {
        function r() {
          this.constructor = e;
        }

        _t4(e, n), e.prototype = null === n ? Object.create(n) : (r.prototype = n.prototype, new r());
      };
    }(),
        N = function (t) {
      function e() {
        return null !== t && t.apply(this, arguments) || this;
      }

      return j(e, t), e.value = function (t) {
        return !0;
      }, e.prototype.index = function (t, e) {
        return this.domNode === t || this.domNode.compareDocumentPosition(t) & Node.DOCUMENT_POSITION_CONTAINED_BY ? Math.min(e, 1) : -1;
      }, e.prototype.position = function (t, e) {
        var n = Array.from(this.parent.domNode.childNodes).indexOf(this.domNode);
        return t > 0 && (n += 1), [this.parent.domNode, n];
      }, e.prototype.value = function () {
        var t;
        return (t = {})[this.statics.blotName] = this.statics.value(this.domNode) || !0, t;
      }, e.scope = h.INLINE_BLOT, e;
    }(b),
        k = function () {
      function t(t, e, n) {
        void 0 === n && (n = {}), this.attrName = t, this.keyName = e;
        var r = h.TYPE & h.ATTRIBUTE;
        this.scope = null != n.scope ? n.scope & h.LEVEL | r : h.ATTRIBUTE, null != n.whitelist && (this.whitelist = n.whitelist);
      }

      return t.keys = function (t) {
        return Array.from(t.attributes).map(function (t) {
          return t.name;
        });
      }, t.prototype.add = function (t, e) {
        return !!this.canAdd(t, e) && (t.setAttribute(this.keyName, e), !0);
      }, t.prototype.canAdd = function (t, e) {
        return null == this.whitelist || ("string" == typeof e ? this.whitelist.indexOf(e.replace(/["']/g, "")) > -1 : this.whitelist.indexOf(e) > -1);
      }, t.prototype.remove = function (t) {
        t.removeAttribute(this.keyName);
      }, t.prototype.value = function (t) {
        var e = t.getAttribute(this.keyName);
        return this.canAdd(t, e) && e ? e : "";
      }, t;
    }(),
        S = function () {
      var _t5 = function t(e, n) {
        return (_t5 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var n in e) {
            e.hasOwnProperty(n) && (t[n] = e[n]);
          }
        })(e, n);
      };

      return function (e, n) {
        function r() {
          this.constructor = e;
        }

        _t5(e, n), e.prototype = null === n ? Object.create(n) : (r.prototype = n.prototype, new r());
      };
    }();

    function x(t, e) {
      return (t.getAttribute("class") || "").split(/\s+/).filter(function (t) {
        return 0 === t.indexOf(e + "-");
      });
    }

    var E = function (t) {
      function e() {
        return null !== t && t.apply(this, arguments) || this;
      }

      return S(e, t), e.keys = function (t) {
        return (t.getAttribute("class") || "").split(/\s+/).map(function (t) {
          return t.split("-").slice(0, -1).join("-");
        });
      }, e.prototype.add = function (t, e) {
        return !!this.canAdd(t, e) && (this.remove(t), t.classList.add(this.keyName + "-" + e), !0);
      }, e.prototype.remove = function (t) {
        x(t, this.keyName).forEach(function (e) {
          t.classList.remove(e);
        }), 0 === t.classList.length && t.removeAttribute("class");
      }, e.prototype.value = function (t) {
        var e = (x(t, this.keyName)[0] || "").slice(this.keyName.length + 1);
        return this.canAdd(t, e) ? e : "";
      }, e;
    }(k),
        A = function () {
      var _t6 = function t(e, n) {
        return (_t6 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var n in e) {
            e.hasOwnProperty(n) && (t[n] = e[n]);
          }
        })(e, n);
      };

      return function (e, n) {
        function r() {
          this.constructor = e;
        }

        _t6(e, n), e.prototype = null === n ? Object.create(n) : (r.prototype = n.prototype, new r());
      };
    }();

    function R(t) {
      var e = t.split("-"),
          n = e.slice(1).map(function (t) {
        return t[0].toUpperCase() + t.slice(1);
      }).join("");
      return e[0] + n;
    }

    var T = function (t) {
      function e() {
        return null !== t && t.apply(this, arguments) || this;
      }

      return A(e, t), e.keys = function (t) {
        return (t.getAttribute("style") || "").split(";").map(function (t) {
          return t.split(":")[0].trim();
        });
      }, e.prototype.add = function (t, e) {
        return !!this.canAdd(t, e) && (t.style[R(this.keyName)] = e, !0);
      }, e.prototype.remove = function (t) {
        t.style[R(this.keyName)] = "", t.getAttribute("style") || t.removeAttribute("style");
      }, e.prototype.value = function (t) {
        var e = t.style[R(this.keyName)];
        return this.canAdd(t, e) ? e : "";
      }, e;
    }(k),
        P = function () {
      function t(t) {
        this.attributes = {}, this.domNode = t, this.build();
      }

      return t.prototype.attribute = function (t, e) {
        e ? t.add(this.domNode, e) && (null != t.value(this.domNode) ? this.attributes[t.attrName] = t : delete this.attributes[t.attrName]) : (t.remove(this.domNode), delete this.attributes[t.attrName]);
      }, t.prototype.build = function () {
        var t = this;
        this.attributes = {};
        var e = v.find(this.domNode);

        if (null != e) {
          var n = k.keys(this.domNode),
              r = E.keys(this.domNode),
              o = T.keys(this.domNode);
          n.concat(r).concat(o).forEach(function (n) {
            var r = e.scroll.query(n, h.ATTRIBUTE);
            r instanceof k && (t.attributes[r.attrName] = r);
          });
        }
      }, t.prototype.copy = function (t) {
        var e = this;
        Object.keys(this.attributes).forEach(function (n) {
          var r = e.attributes[n].value(e.domNode);
          t.format(n, r);
        });
      }, t.prototype.move = function (t) {
        var e = this;
        this.copy(t), Object.keys(this.attributes).forEach(function (t) {
          e.attributes[t].remove(e.domNode);
        }), this.attributes = {};
      }, t.prototype.values = function () {
        var t = this;
        return Object.keys(this.attributes).reduce(function (e, n) {
          return e[n] = t.attributes[n].value(t.domNode), e;
        }, {});
      }, t;
    }(),
        C = function () {
      var _t7 = function t(e, n) {
        return (_t7 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var n in e) {
            e.hasOwnProperty(n) && (t[n] = e[n]);
          }
        })(e, n);
      };

      return function (e, n) {
        function r() {
          this.constructor = e;
        }

        _t7(e, n), e.prototype = null === n ? Object.create(n) : (r.prototype = n.prototype, new r());
      };
    }();

    var L = function (t) {
      function e(e, n) {
        var r = t.call(this, e, n) || this;
        return r.attributes = new P(r.domNode), r;
      }

      return C(e, t), e.formats = function (t, n) {
        var r = n.query(e.blotName);
        if (null == r || t.tagName !== r.tagName) return "string" == typeof this.tagName || (Array.isArray(this.tagName) ? t.tagName.toLowerCase() : void 0);
      }, e.prototype.format = function (t, n) {
        var r = this;

        if (t !== this.statics.blotName || n) {
          var o = this.scroll.query(t, h.INLINE);
          if (null == o) return;
          o instanceof k ? this.attributes.attribute(o, n) : !n || t === this.statics.blotName && this.formats()[t] === n || this.replaceWith(t, n);
        } else this.children.forEach(function (t) {
          t instanceof e || (t = t.wrap(e.blotName, !0)), r.attributes.copy(t);
        }), this.unwrap();
      }, e.prototype.formats = function () {
        var t = this.attributes.values(),
            e = this.statics.formats(this.domNode, this.scroll);
        return null != e && (t[this.statics.blotName] = e), t;
      }, e.prototype.formatAt = function (e, n, r, o) {
        null != this.formats()[r] || this.scroll.query(r, h.ATTRIBUTE) ? this.isolate(e, n).format(r, o) : t.prototype.formatAt.call(this, e, n, r, o);
      }, e.prototype.optimize = function (n) {
        t.prototype.optimize.call(this, n);
        var r = this.formats();
        if (0 === Object.keys(r).length) return this.unwrap();
        var o = this.next;
        o instanceof e && o.prev === this && function (t, e) {
          if (Object.keys(t).length !== Object.keys(e).length) return !1;

          for (var n in t) {
            if (t[n] !== e[n]) return !1;
          }

          return !0;
        }(r, o.formats()) && (o.moveChildren(this), o.remove());
      }, e.prototype.replaceWith = function (e, n) {
        var r = t.prototype.replaceWith.call(this, e, n);
        return this.attributes.copy(r), r;
      }, e.prototype.update = function (e, n) {
        var r = this;
        t.prototype.update.call(this, e, n), e.some(function (t) {
          return t.target === r.domNode && "attributes" === t.type;
        }) && this.attributes.build();
      }, e.prototype.wrap = function (n, r) {
        var o = t.prototype.wrap.call(this, n, r);
        return o instanceof e && this.attributes.move(o), o;
      }, e.allowedChildren = [e, N], e.blotName = "inline", e.scope = h.INLINE_BLOT, e.tagName = "SPAN", e;
    }(O),
        D = function () {
      var _t8 = function t(e, n) {
        return (_t8 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var n in e) {
            e.hasOwnProperty(n) && (t[n] = e[n]);
          }
        })(e, n);
      };

      return function (e, n) {
        function r() {
          this.constructor = e;
        }

        _t8(e, n), e.prototype = null === n ? Object.create(n) : (r.prototype = n.prototype, new r());
      };
    }(),
        q = function (t) {
      function e(e, n) {
        var r = t.call(this, e, n) || this;
        return r.attributes = new P(r.domNode), r;
      }

      return D(e, t), e.formats = function (t, n) {
        var r = n.query(e.blotName);
        if (null == r || t.tagName !== r.tagName) return "string" == typeof this.tagName || (Array.isArray(this.tagName) ? t.tagName.toLowerCase() : void 0);
      }, e.prototype.format = function (t, n) {
        var r = this.scroll.query(t, h.BLOCK);
        null != r && (r instanceof k ? this.attributes.attribute(r, n) : t !== this.statics.blotName || n ? !n || t === this.statics.blotName && this.formats()[t] === n || this.replaceWith(t, n) : this.replaceWith(e.blotName));
      }, e.prototype.formats = function () {
        var t = this.attributes.values(),
            e = this.statics.formats(this.domNode, this.scroll);
        return null != e && (t[this.statics.blotName] = e), t;
      }, e.prototype.formatAt = function (e, n, r, o) {
        null != this.scroll.query(r, h.BLOCK) ? this.format(r, o) : t.prototype.formatAt.call(this, e, n, r, o);
      }, e.prototype.insertAt = function (e, n, r) {
        if (null == r || null != this.scroll.query(n, h.INLINE)) t.prototype.insertAt.call(this, e, n, r);else {
          var o = this.split(e);
          if (null == o) throw new Error("Attempt to insertAt after block boundaries");
          var i = this.scroll.create(n, r);
          o.parent.insertBefore(i, o);
        }
      }, e.prototype.replaceWith = function (e, n) {
        var r = t.prototype.replaceWith.call(this, e, n);
        return this.attributes.copy(r), r;
      }, e.prototype.update = function (e, n) {
        var r = this;
        t.prototype.update.call(this, e, n), e.some(function (t) {
          return t.target === r.domNode && "attributes" === t.type;
        }) && this.attributes.build();
      }, e.blotName = "block", e.scope = h.BLOCK_BLOT, e.tagName = "P", e.allowedChildren = [L, e, N], e;
    }(O),
        I = function () {
      var _t9 = function t(e, n) {
        return (_t9 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var n in e) {
            e.hasOwnProperty(n) && (t[n] = e[n]);
          }
        })(e, n);
      };

      return function (e, n) {
        function r() {
          this.constructor = e;
        }

        _t9(e, n), e.prototype = null === n ? Object.create(n) : (r.prototype = n.prototype, new r());
      };
    }(),
        B = function (t) {
      function e() {
        return null !== t && t.apply(this, arguments) || this;
      }

      return I(e, t), e.formats = function (t, e) {}, e.prototype.format = function (e, n) {
        t.prototype.formatAt.call(this, 0, this.length(), e, n);
      }, e.prototype.formatAt = function (e, n, r, o) {
        0 === e && n === this.length() ? this.format(r, o) : t.prototype.formatAt.call(this, e, n, r, o);
      }, e.prototype.formats = function () {
        return this.statics.formats(this.domNode, this.scroll);
      }, e;
    }(N),
        M = function () {
      var _t10 = function t(e, n) {
        return (_t10 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var n in e) {
            e.hasOwnProperty(n) && (t[n] = e[n]);
          }
        })(e, n);
      };

      return function (e, n) {
        function r() {
          this.constructor = e;
        }

        _t10(e, n), e.prototype = null === n ? Object.create(n) : (r.prototype = n.prototype, new r());
      };
    }(),
        U = {
      attributes: !0,
      characterData: !0,
      characterDataOldValue: !0,
      childList: !0,
      subtree: !0
    },
        z = function (t) {
      function e(e, n) {
        var r = t.call(this, null, n) || this;
        return r.registry = e, r.scroll = r, r.build(), r.observer = new MutationObserver(function (t) {
          r.update(t);
        }), r.observer.observe(r.domNode, U), r.attach(), r;
      }

      return M(e, t), e.prototype.create = function (t, e) {
        return this.registry.create(this, t, e);
      }, e.prototype.find = function (t, e) {
        return void 0 === e && (e = !1), this.registry.find(t, e);
      }, e.prototype.query = function (t, e) {
        return void 0 === e && (e = h.ANY), this.registry.query(t, e);
      }, e.prototype.register = function () {
        for (var t, e = [], n = 0; n < arguments.length; n++) {
          e[n] = arguments[n];
        }

        return (t = this.registry).register.apply(t, e);
      }, e.prototype.build = function () {
        null != this.scroll && t.prototype.build.call(this);
      }, e.prototype.detach = function () {
        t.prototype.detach.call(this), this.observer.disconnect();
      }, e.prototype.deleteAt = function (e, n) {
        this.update(), 0 === e && n === this.length() ? this.children.forEach(function (t) {
          t.remove();
        }) : t.prototype.deleteAt.call(this, e, n);
      }, e.prototype.formatAt = function (e, n, r, o) {
        this.update(), t.prototype.formatAt.call(this, e, n, r, o);
      }, e.prototype.insertAt = function (e, n, r) {
        this.update(), t.prototype.insertAt.call(this, e, n, r);
      }, e.prototype.optimize = function (e, n) {
        var r = this;
        void 0 === e && (e = []), void 0 === n && (n = {}), t.prototype.optimize.call(this, n);

        for (var o = n.mutationsMap || new WeakMap(), i = Array.from(this.observer.takeRecords()); i.length > 0;) {
          e.push(i.pop());
        }

        for (var u = function t(e, n) {
          void 0 === n && (n = !0), null != e && e !== r && null != e.domNode.parentNode && (o.has(e.domNode) || o.set(e.domNode, []), n && t(e.parent));
        }, a = function t(e) {
          o.has(e.domNode) && (e instanceof O && e.children.forEach(t), o.delete(e.domNode), e.optimize(n));
        }, c = e, l = 0; c.length > 0; l += 1) {
          if (l >= 100) throw new Error("[Parchment] Maximum optimize iterations reached");

          for (c.forEach(function (t) {
            var e = r.find(t.target, !0);
            null != e && (e.domNode === t.target && ("childList" === t.type ? (u(r.find(t.previousSibling, !1)), Array.from(t.addedNodes).forEach(function (t) {
              var e = r.find(t, !1);
              u(e, !1), e instanceof O && e.children.forEach(function (t) {
                u(t, !1);
              });
            })) : "attributes" === t.type && u(e.prev)), u(e));
          }), this.children.forEach(a), i = (c = Array.from(this.observer.takeRecords())).slice(); i.length > 0;) {
            e.push(i.pop());
          }
        }
      }, e.prototype.update = function (e, n) {
        var r = this;
        void 0 === n && (n = {}), e = e || this.observer.takeRecords();
        var o = new WeakMap();
        e.map(function (t) {
          var e = v.find(t.target, !0);
          return null == e ? null : o.has(e.domNode) ? (o.get(e.domNode).push(t), null) : (o.set(e.domNode, [t]), e);
        }).forEach(function (t) {
          null != t && t !== r && o.has(t.domNode) && t.update(o.get(t.domNode) || [], n);
        }), n.mutationsMap = o, o.has(this.domNode) && t.prototype.update.call(this, o.get(this.domNode), n), this.optimize(e, n);
      }, e.blotName = "scroll", e.defaultChild = q, e.allowedChildren = [q, _], e.scope = h.BLOCK_BLOT, e.tagName = "DIV", e;
    }(O),
        F = function () {
      var _t11 = function t(e, n) {
        return (_t11 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var n in e) {
            e.hasOwnProperty(n) && (t[n] = e[n]);
          }
        })(e, n);
      };

      return function (e, n) {
        function r() {
          this.constructor = e;
        }

        _t11(e, n), e.prototype = null === n ? Object.create(n) : (r.prototype = n.prototype, new r());
      };
    }(),
        K = function (t) {
      function e(e, n) {
        var r = t.call(this, e, n) || this;
        return r.text = r.statics.value(r.domNode), r;
      }

      return F(e, t), e.create = function (t) {
        return document.createTextNode(t);
      }, e.value = function (t) {
        return t.data;
      }, e.prototype.deleteAt = function (t, e) {
        this.domNode.data = this.text = this.text.slice(0, t) + this.text.slice(t + e);
      }, e.prototype.index = function (t, e) {
        return this.domNode === t ? e : -1;
      }, e.prototype.insertAt = function (e, n, r) {
        null == r ? (this.text = this.text.slice(0, e) + n + this.text.slice(e), this.domNode.data = this.text) : t.prototype.insertAt.call(this, e, n, r);
      }, e.prototype.length = function () {
        return this.text.length;
      }, e.prototype.optimize = function (n) {
        t.prototype.optimize.call(this, n), this.text = this.statics.value(this.domNode), 0 === this.text.length ? this.remove() : this.next instanceof e && this.next.prev === this && (this.insertAt(this.length(), this.next.value()), this.next.remove());
      }, e.prototype.position = function (t, e) {
        return void 0 === e && (e = !1), [this.domNode, t];
      }, e.prototype.split = function (t, e) {
        if (void 0 === e && (e = !1), !e) {
          if (0 === t) return this;
          if (t === this.length()) return this.next;
        }

        var n = this.scroll.create(this.domNode.splitText(t));
        return this.parent.insertBefore(n, this.next || void 0), this.text = this.statics.value(this.domNode), n;
      }, e.prototype.update = function (t, e) {
        var n = this;
        t.some(function (t) {
          return "characterData" === t.type && t.target === n.domNode;
        }) && (this.text = this.statics.value(this.domNode));
      }, e.prototype.value = function () {
        return this.text;
      }, e.blotName = "text", e.scope = h.INLINE_BLOT, e;
    }(N),
        W = n(5),
        $ = n.n(W),
        H = n(51),
        V = n.n(H),
        G = new WeakMap(),
        X = ["error", "warn", "log", "info"],
        Y = "warn";

    function Q(t) {
      if (X.indexOf(t) <= X.indexOf(Y)) {
        for (var e, n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++) {
          r[o - 1] = arguments[o];
        }

        (e = console)[t].apply(e, r);
      }
    }

    function Z(t) {
      return X.reduce(function (e, n) {
        return e[n] = Q.bind(console, n, t), e;
      }, {});
    }

    Z.level = function (t) {
      Y = t;
    }, Q.level = Z.level;
    var J = Z;

    function tt(t) {
      return (tt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function et(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    function nt(t, e, n) {
      return (nt = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, n) {
        var r = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = ut(t));) {
            ;
          }

          return t;
        }(t, e);

        if (r) {
          var o = Object.getOwnPropertyDescriptor(r, e);
          return o.get ? o.get.call(n) : o.value;
        }
      })(t, e, n || t);
    }

    function rt(t, e) {
      return (rt = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      })(t, e);
    }

    function ot(t) {
      var e = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = ut(t);

        if (e) {
          var o = ut(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return it(this, n);
      };
    }

    function it(t, e) {
      return !e || "object" !== tt(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }(t) : e;
    }

    function ut(t) {
      return (ut = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
    }

    var at = J("quill:events");
    ["selectionchange", "mousedown", "mouseup", "click"].forEach(function (t) {
      document.addEventListener(t, function () {
        for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) {
          e[n] = arguments[n];
        }

        Array.from(document.querySelectorAll(".ql-container")).forEach(function (t) {
          var n,
              r = G.get(t);
          r && r.emitter && (n = r.emitter).handleDOM.apply(n, e);
        });
      });
    });

    var ct = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && rt(t, e);
      }(i, t);
      var e,
          n,
          r,
          o = ot(i);

      function i() {
        var t;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, i), (t = o.call(this)).listeners = {}, t.on("error", at.error), t;
      }

      return e = i, (n = [{
        key: "emit",
        value: function value() {
          for (var t, e, n = arguments.length, r = new Array(n), o = 0; o < n; o++) {
            r[o] = arguments[o];
          }

          (t = at.log).call.apply(t, [at].concat(r)), (e = nt(ut(i.prototype), "emit", this)).call.apply(e, [this].concat(r));
        }
      }, {
        key: "handleDOM",
        value: function value(t) {
          for (var e = arguments.length, n = new Array(e > 1 ? e - 1 : 0), r = 1; r < e; r++) {
            n[r - 1] = arguments[r];
          }

          (this.listeners[t.type] || []).forEach(function (e) {
            var r = e.node,
                o = e.handler;
            (t.target === r || r.contains(t.target)) && o.apply(void 0, [t].concat(n));
          });
        }
      }, {
        key: "listenDOM",
        value: function value(t, e, n) {
          this.listeners[t] || (this.listeners[t] = []), this.listeners[t].push({
            node: e,
            handler: n
          });
        }
      }]) && et(e.prototype, n), r && et(e, r), i;
    }(V.a);

    ct.events = {
      EDITOR_CHANGE: "editor-change",
      SCROLL_BEFORE_UPDATE: "scroll-before-update",
      SCROLL_BLOT_MOUNT: "scroll-blot-mount",
      SCROLL_BLOT_UNMOUNT: "scroll-blot-unmount",
      SCROLL_OPTIMIZE: "scroll-optimize",
      SCROLL_UPDATE: "scroll-update",
      SELECTION_CHANGE: "selection-change",
      TEXT_CHANGE: "text-change"
    }, ct.sources = {
      API: "api",
      SILENT: "silent",
      USER: "user"
    };
    var lt = ct;

    function st(t) {
      return function (t) {
        if (Array.isArray(t)) return pt(t);
      }(t) || function (t) {
        if ("undefined" != typeof Symbol && Symbol.iterator in Object(t)) return Array.from(t);
      }(t) || ht(t) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function ft(t, e) {
      return function (t) {
        if (Array.isArray(t)) return t;
      }(t) || function (t, e) {
        if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(t))) return;
        var n = [],
            r = !0,
            o = !1,
            i = void 0;

        try {
          for (var u, a = t[Symbol.iterator](); !(r = (u = a.next()).done) && (n.push(u.value), !e || n.length !== e); r = !0) {
            ;
          }
        } catch (t) {
          o = !0, i = t;
        } finally {
          try {
            r || null == a.return || a.return();
          } finally {
            if (o) throw i;
          }
        }

        return n;
      }(t, e) || ht(t, e) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function ht(t, e) {
      if (t) {
        if ("string" == typeof t) return pt(t, e);
        var n = Object.prototype.toString.call(t).slice(8, -1);
        return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? pt(t, e) : void 0;
      }
    }

    function pt(t, e) {
      (null == e || e > t.length) && (e = t.length);

      for (var n = 0, r = new Array(e); n < e; n++) {
        r[n] = t[n];
      }

      return r;
    }

    function yt(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    function dt(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }

    var vt = J("quill:selection"),
        bt = function t(e) {
      var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
      dt(this, t), this.index = e, this.length = n;
    },
        mt = function () {
      function t(e, n) {
        var r = this;
        dt(this, t), this.emitter = n, this.scroll = e, this.composing = !1, this.mouseDown = !1, this.root = this.scroll.domNode, this.cursor = this.scroll.create("cursor", this), this.savedRange = new bt(0, 0), this.lastRange = this.savedRange, this.lastNative = null, this.handleComposition(), this.handleDragging(), this.emitter.listenDOM("selectionchange", document, function () {
          r.mouseDown || r.composing || setTimeout(r.update.bind(r, lt.sources.USER), 1);
        }), this.emitter.on(lt.events.SCROLL_BEFORE_UPDATE, function () {
          if (r.hasFocus()) {
            var t = r.getNativeRange();
            null != t && t.start.node !== r.cursor.textNode && r.emitter.once(lt.events.SCROLL_UPDATE, function () {
              try {
                r.root.contains(t.start.node) && r.root.contains(t.end.node) && r.setNativeRange(t.start.node, t.start.offset, t.end.node, t.end.offset), r.update(lt.sources.SILENT);
              } catch (t) {}
            });
          }
        }), this.emitter.on(lt.events.SCROLL_OPTIMIZE, function (t, e) {
          if (e.range) {
            var n = e.range,
                o = n.startNode,
                i = n.startOffset,
                u = n.endNode,
                a = n.endOffset;
            r.setNativeRange(o, i, u, a), r.update(lt.sources.SILENT);
          }
        }), this.update(lt.sources.SILENT);
      }

      var e, n, r;
      return e = t, (n = [{
        key: "handleComposition",
        value: function value() {
          var t = this;
          this.root.addEventListener("compositionstart", function () {
            t.composing = !0, t.scroll.batchStart();
          }), this.root.addEventListener("compositionend", function () {
            if (t.scroll.batchEnd(), t.composing = !1, t.cursor.parent) {
              var e = t.cursor.restore();
              if (!e) return;
              setTimeout(function () {
                t.setNativeRange(e.startNode, e.startOffset, e.endNode, e.endOffset);
              }, 1);
            }
          });
        }
      }, {
        key: "handleDragging",
        value: function value() {
          var t = this;
          this.emitter.listenDOM("mousedown", document.body, function () {
            t.mouseDown = !0;
          }), this.emitter.listenDOM("mouseup", document.body, function () {
            t.mouseDown = !1, t.update(lt.sources.USER);
          });
        }
      }, {
        key: "focus",
        value: function value() {
          this.hasFocus() || (this.root.focus(), this.setRange(this.savedRange));
        }
      }, {
        key: "format",
        value: function value(t, e) {
          this.scroll.update();
          var n = this.getNativeRange();

          if (null != n && n.native.collapsed && !this.scroll.query(t, h.BLOCK)) {
            if (n.start.node !== this.cursor.textNode) {
              var r = this.scroll.find(n.start.node, !1);
              if (null == r) return;

              if (r instanceof N) {
                var o = r.split(n.start.offset);
                r.parent.insertBefore(this.cursor, o);
              } else r.insertBefore(this.cursor, n.start.node);

              this.cursor.attach();
            }

            this.cursor.format(t, e), this.scroll.optimize(), this.setNativeRange(this.cursor.textNode, this.cursor.textNode.data.length), this.update();
          }
        }
      }, {
        key: "getBounds",
        value: function value(t) {
          var e,
              n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
              r = this.scroll.length();
          t = Math.min(t, r - 1), n = Math.min(t + n, r - 1) - t;
          var o = this.scroll.leaf(t),
              i = ft(o, 2),
              u = i[0],
              a = i[1];
          if (null == u) return null;
          var c = u.position(a, !0),
              l = ft(c, 2);
          e = l[0], a = l[1];
          var s = document.createRange();

          if (n > 0) {
            s.setStart(e, a);
            var f = this.scroll.leaf(t + n),
                h = ft(f, 2);
            if (u = h[0], a = h[1], null == u) return null;
            var p = u.position(a, !0),
                y = ft(p, 2);
            return e = y[0], a = y[1], s.setEnd(e, a), s.getBoundingClientRect();
          }

          var d,
              v = "left";
          return e instanceof Text ? (a < e.data.length ? (s.setStart(e, a), s.setEnd(e, a + 1)) : (s.setStart(e, a - 1), s.setEnd(e, a), v = "right"), d = s.getBoundingClientRect()) : (d = u.domNode.getBoundingClientRect(), a > 0 && (v = "right")), {
            bottom: d.top + d.height,
            height: d.height,
            left: d[v],
            right: d[v],
            top: d.top,
            width: 0
          };
        }
      }, {
        key: "getNativeRange",
        value: function value() {
          var t = document.getSelection();
          if (null == t || t.rangeCount <= 0) return null;
          var e = t.getRangeAt(0);
          if (null == e) return null;
          var n = this.normalizeNative(e);
          return vt.info("getNativeRange", n), n;
        }
      }, {
        key: "getRange",
        value: function value() {
          var t = this.getNativeRange();
          return null == t ? [null, null] : [this.normalizedToRange(t), t];
        }
      }, {
        key: "hasFocus",
        value: function value() {
          return document.activeElement === this.root || gt(this.root, document.activeElement);
        }
      }, {
        key: "normalizedToRange",
        value: function value(t) {
          var e = this,
              n = [[t.start.node, t.start.offset]];
          t.native.collapsed || n.push([t.end.node, t.end.offset]);
          var r = n.map(function (t) {
            var n = ft(t, 2),
                r = n[0],
                o = n[1],
                i = e.scroll.find(r, !0),
                u = i.offset(e.scroll);
            return 0 === o ? u : i instanceof N ? u + i.index(r, o) : u + i.length();
          }),
              o = Math.min(Math.max.apply(Math, st(r)), this.scroll.length() - 1),
              i = Math.min.apply(Math, [o].concat(st(r)));
          return new bt(i, o - i);
        }
      }, {
        key: "normalizeNative",
        value: function value(t) {
          if (!gt(this.root, t.startContainer) || !t.collapsed && !gt(this.root, t.endContainer)) return null;
          var e = {
            start: {
              node: t.startContainer,
              offset: t.startOffset
            },
            end: {
              node: t.endContainer,
              offset: t.endOffset
            },
            native: t
          };
          return [e.start, e.end].forEach(function (t) {
            for (var e = t.node, n = t.offset; !(e instanceof Text) && e.childNodes.length > 0;) {
              if (e.childNodes.length > n) e = e.childNodes[n], n = 0;else {
                if (e.childNodes.length !== n) break;
                n = (e = e.lastChild) instanceof Text ? e.data.length : e.childNodes.length > 0 ? e.childNodes.length : e.childNodes.length + 1;
              }
            }

            t.node = e, t.offset = n;
          }), e;
        }
      }, {
        key: "rangeToNative",
        value: function value(t) {
          var e = this,
              n = t.collapsed ? [t.index] : [t.index, t.index + t.length],
              r = [],
              o = this.scroll.length();
          return n.forEach(function (t, n) {
            t = Math.min(o - 1, t);
            var i = ft(e.scroll.leaf(t), 2),
                u = i[0],
                a = i[1],
                c = ft(u.position(a, 0 !== n), 2),
                l = c[0],
                s = c[1];
            r.push(l, s);
          }), r.length < 2 ? r.concat(r) : r;
        }
      }, {
        key: "scrollIntoView",
        value: function value(t) {
          var e = this.lastRange;

          if (null != e) {
            var n = this.getBounds(e.index, e.length);

            if (null != n) {
              var r = this.scroll.length() - 1,
                  o = ft(this.scroll.line(Math.min(e.index, r)), 1)[0],
                  i = o;

              if (e.length > 0 && (i = ft(this.scroll.line(Math.min(e.index + e.length, r)), 1)[0]), null != o && null != i) {
                var u = t.getBoundingClientRect();
                n.top < u.top ? t.scrollTop -= u.top - n.top : n.bottom > u.bottom && (t.scrollTop += n.bottom - u.bottom);
              }
            }
          }
        }
      }, {
        key: "setNativeRange",
        value: function value(t, e) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : t,
              r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : e,
              o = arguments.length > 4 && void 0 !== arguments[4] && arguments[4];

          if (vt.info("setNativeRange", t, e, n, r), null == t || null != this.root.parentNode && null != t.parentNode && null != n.parentNode) {
            var i = document.getSelection();
            if (null != i) if (null != t) {
              this.hasFocus() || this.root.focus();
              var u = this.getNativeRange() || {},
                  a = u.native;

              if (null == a || o || t !== a.startContainer || e !== a.startOffset || n !== a.endContainer || r !== a.endOffset) {
                "BR" === t.tagName && (e = Array.from(t.parentNode.childNodes).indexOf(t), t = t.parentNode), "BR" === n.tagName && (r = Array.from(n.parentNode.childNodes).indexOf(n), n = n.parentNode);
                var c = document.createRange();
                c.setStart(t, e), c.setEnd(n, r), i.removeAllRanges(), i.addRange(c);
              }
            } else i.removeAllRanges(), this.root.blur(), document.body.focus();
          }
        }
      }, {
        key: "setRange",
        value: function value(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
              n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : lt.sources.API;

          if ("string" == typeof e && (n = e, e = !1), vt.info("setRange", t), null != t) {
            var r = this.rangeToNative(t);
            this.setNativeRange.apply(this, st(r).concat([e]));
          } else this.setNativeRange(null);

          this.update(n);
        }
      }, {
        key: "update",
        value: function value() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : lt.sources.USER,
              e = this.lastRange,
              n = this.getRange(),
              r = ft(n, 2),
              o = r[0],
              i = r[1];

          if (this.lastRange = o, this.lastNative = i, null != this.lastRange && (this.savedRange = this.lastRange), !$()(e, this.lastRange)) {
            var u;

            if (!this.composing && null != i && i.native.collapsed && i.start.node !== this.cursor.textNode) {
              var a = this.cursor.restore();
              a && this.setNativeRange(a.startNode, a.startOffset, a.endNode, a.endOffset);
            }

            var l,
                s = [lt.events.SELECTION_CHANGE, c()(this.lastRange), c()(e), t];
            (u = this.emitter).emit.apply(u, [lt.events.EDITOR_CHANGE].concat(s)), t !== lt.sources.SILENT && (l = this.emitter).emit.apply(l, s);
          }
        }
      }]) && yt(e.prototype, n), r && yt(e, r), t;
    }();

    function gt(t, e) {
      try {
        e.parentNode;
      } catch (t) {
        return !1;
      }

      return e instanceof Text && (e = e.parentNode), t.contains(e);
    }

    function Ot(t) {
      return (Ot = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function wt(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }

    function _t(t, e) {
      return (_t = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      })(t, e);
    }

    function jt(t) {
      var e = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = kt(t);

        if (e) {
          var o = kt(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return Nt(this, n);
      };
    }

    function Nt(t, e) {
      return !e || "object" !== Ot(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }(t) : e;
    }

    function kt(t) {
      return (kt = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
    }

    var St = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && _t(t, e);
      }(n, t);
      var e = jt(n);

      function n() {
        return wt(this, n), e.apply(this, arguments);
      }

      return n;
    }(K);

    function xt(t) {
      return t.replace(/[&<>"']/g, function (t) {
        return {
          "&": "&amp;",
          "<": "&lt;",
          ">": "&gt;",
          '"': "&quot;",
          "'": "&#39;"
        }[t];
      });
    }

    function Et(t) {
      return (Et = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function At(t, e, n) {
      return (At = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, n) {
        var r = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = Dt(t));) {
            ;
          }

          return t;
        }(t, e);

        if (r) {
          var o = Object.getOwnPropertyDescriptor(r, e);
          return o.get ? o.get.call(n) : o.value;
        }
      })(t, e, n || t);
    }

    function Rt(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    function Tt(t, e, n) {
      return e && Rt(t.prototype, e), n && Rt(t, n), t;
    }

    function Pt(t, e) {
      return (Pt = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      })(t, e);
    }

    function Ct(t) {
      var e = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = Dt(t);

        if (e) {
          var o = Dt(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return Lt(this, n);
      };
    }

    function Lt(t, e) {
      return !e || "object" !== Et(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }(t) : e;
    }

    function Dt(t) {
      return (Dt = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
    }

    var qt = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && Pt(t, e);
      }(n, t);
      var e = Ct(n);

      function n(t, r, o) {
        var i;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, n), (i = e.call(this, t, r)).selection = o, i.textNode = document.createTextNode(n.CONTENTS), i.domNode.appendChild(i.textNode), i.savedLength = 0, i;
      }

      return Tt(n, null, [{
        key: "value",
        value: function value() {}
      }]), Tt(n, [{
        key: "detach",
        value: function value() {
          null != this.parent && this.parent.removeChild(this);
        }
      }, {
        key: "format",
        value: function value(t, e) {
          if (0 === this.savedLength) {
            for (var r = this, o = 0; null != r && r.statics.scope !== h.BLOCK_BLOT;) {
              o += r.offset(r.parent), r = r.parent;
            }

            null != r && (this.savedLength = n.CONTENTS.length, r.optimize(), r.formatAt(o, n.CONTENTS.length, t, e), this.savedLength = 0);
          } else At(Dt(n.prototype), "format", this).call(this, t, e);
        }
      }, {
        key: "index",
        value: function value(t, e) {
          return t === this.textNode ? 0 : At(Dt(n.prototype), "index", this).call(this, t, e);
        }
      }, {
        key: "length",
        value: function value() {
          return this.savedLength;
        }
      }, {
        key: "position",
        value: function value() {
          return [this.textNode, this.textNode.data.length];
        }
      }, {
        key: "remove",
        value: function value() {
          At(Dt(n.prototype), "remove", this).call(this), this.parent = null;
        }
      }, {
        key: "restore",
        value: function value() {
          if (this.selection.composing || null == this.parent) return null;

          for (var t = this.selection.getNativeRange(); null != this.domNode.lastChild && this.domNode.lastChild !== this.textNode;) {
            this.domNode.parentNode.insertBefore(this.domNode.lastChild, this.domNode);
          }

          var e,
              r = this.prev instanceof St ? this.prev : null,
              o = r ? r.length() : 0,
              i = this.next instanceof St ? this.next : null,
              u = i ? i.text : "",
              a = this.textNode,
              c = a.data.split(n.CONTENTS).join("");
          if (a.data = n.CONTENTS, r) e = r, (c || i) && (r.insertAt(r.length(), c + u), i && i.remove());else if (i) e = i, i.insertAt(0, c);else {
            var l = document.createTextNode(c);
            e = this.scroll.create(l), this.parent.insertBefore(e, this);
          }

          if (this.remove(), t) {
            var s = function s(t, e) {
              return r && t === r.domNode ? e : t === a ? o + e - 1 : i && t === i.domNode ? o + c.length + e : null;
            },
                f = s(t.start.node, t.start.offset),
                h = s(t.end.node, t.end.offset);

            if (null !== f && null !== h) return {
              startNode: e.domNode,
              startOffset: f,
              endNode: e.domNode,
              endOffset: h
            };
          }

          return null;
        }
      }, {
        key: "update",
        value: function value(t, e) {
          var n = this;

          if (t.some(function (t) {
            return "characterData" === t.type && t.target === n.textNode;
          })) {
            var r = this.restore();
            r && (e.range = r);
          }
        }
      }, {
        key: "value",
        value: function value() {
          return "";
        }
      }]), n;
    }(B);

    qt.blotName = "cursor", qt.className = "ql-cursor", qt.tagName = "span", qt.CONTENTS = "\uFEFF";
    var It = qt;

    function Bt(t) {
      return (Bt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function Mt(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }

    function Ut(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    function zt(t, e) {
      return (zt = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      })(t, e);
    }

    function Ft(t) {
      var e = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = Wt(t);

        if (e) {
          var o = Wt(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return Kt(this, n);
      };
    }

    function Kt(t, e) {
      return !e || "object" !== Bt(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }(t) : e;
    }

    function Wt(t) {
      return (Wt = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
    }

    var $t = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && zt(t, e);
      }(i, t);
      var e,
          n,
          r,
          o = Ft(i);

      function i() {
        return Mt(this, i), o.apply(this, arguments);
      }

      return e = i, r = [{
        key: "value",
        value: function value() {}
      }], (n = [{
        key: "optimize",
        value: function value() {
          (this.prev || this.next) && this.remove();
        }
      }, {
        key: "length",
        value: function value() {
          return 0;
        }
      }, {
        key: "value",
        value: function value() {
          return "";
        }
      }]) && Ut(e.prototype, n), r && Ut(e, r), i;
    }(B);

    $t.blotName = "break", $t.tagName = "BR";
    var Ht = $t;

    function Vt(t) {
      return (Vt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function Gt(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }

    function Xt(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    function Yt(t, e, n) {
      return (Yt = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, n) {
        var r = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = te(t));) {
            ;
          }

          return t;
        }(t, e);

        if (r) {
          var o = Object.getOwnPropertyDescriptor(r, e);
          return o.get ? o.get.call(n) : o.value;
        }
      })(t, e, n || t);
    }

    function Qt(t, e) {
      return (Qt = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      })(t, e);
    }

    function Zt(t) {
      var e = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = te(t);

        if (e) {
          var o = te(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return Jt(this, n);
      };
    }

    function Jt(t, e) {
      return !e || "object" !== Vt(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }(t) : e;
    }

    function te(t) {
      return (te = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
    }

    var ee = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && Qt(t, e);
      }(i, t);
      var e,
          n,
          r,
          o = Zt(i);

      function i() {
        return Gt(this, i), o.apply(this, arguments);
      }

      return e = i, r = [{
        key: "compare",
        value: function value(t, e) {
          var n = i.order.indexOf(t),
              r = i.order.indexOf(e);
          return n >= 0 || r >= 0 ? n - r : t === e ? 0 : t < e ? -1 : 1;
        }
      }], (n = [{
        key: "formatAt",
        value: function value(t, e, n, r) {
          if (i.compare(this.statics.blotName, n) < 0 && this.scroll.query(n, h.BLOT)) {
            var o = this.isolate(t, e);
            r && o.wrap(n, r);
          } else Yt(te(i.prototype), "formatAt", this).call(this, t, e, n, r);
        }
      }, {
        key: "optimize",
        value: function value(t) {
          if (Yt(te(i.prototype), "optimize", this).call(this, t), this.parent instanceof i && i.compare(this.statics.blotName, this.parent.statics.blotName) > 0) {
            var e = this.parent.isolate(this.offset(), this.length());
            this.moveChildren(e), e.wrap(this);
          }
        }
      }]) && Xt(e.prototype, n), r && Xt(e, r), i;
    }(L);

    ee.allowedChildren = [ee, Ht, B, St], ee.order = ["cursor", "inline", "link", "underline", "strike", "italic", "bold", "script", "code"];
    var ne = ee;

    function re(t, e) {
      var n = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }

      return n;
    }

    function oe(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? re(Object(n), !0).forEach(function (e) {
          ie(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : re(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }

      return t;
    }

    function ie(t, e, n) {
      return e in t ? Object.defineProperty(t, e, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = n, t;
    }

    function ue(t) {
      return (ue = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function ae(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }

    function ce(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    function le(t, e, n) {
      return e && ce(t.prototype, e), n && ce(t, n), t;
    }

    function se(t, e, n) {
      return (se = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, n) {
        var r = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = de(t));) {
            ;
          }

          return t;
        }(t, e);

        if (r) {
          var o = Object.getOwnPropertyDescriptor(r, e);
          return o.get ? o.get.call(n) : o.value;
        }
      })(t, e, n || t);
    }

    function fe(t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          writable: !0,
          configurable: !0
        }
      }), e && he(t, e);
    }

    function he(t, e) {
      return (he = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      })(t, e);
    }

    function pe(t) {
      var e = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = de(t);

        if (e) {
          var o = de(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return ye(this, n);
      };
    }

    function ye(t, e) {
      return !e || "object" !== ue(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }(t) : e;
    }

    function de(t) {
      return (de = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
    }

    var ve = function (t) {
      fe(n, t);
      var e = pe(n);

      function n(t, r) {
        var o;
        return ae(this, n), (o = e.call(this, t, r)).cache = {}, o;
      }

      return le(n, [{
        key: "delta",
        value: function value() {
          return null == this.cache.delta && (this.cache.delta = me(this)), this.cache.delta;
        }
      }, {
        key: "deleteAt",
        value: function value(t, e) {
          se(de(n.prototype), "deleteAt", this).call(this, t, e), this.cache = {};
        }
      }, {
        key: "formatAt",
        value: function value(t, e, r, o) {
          e <= 0 || (this.scroll.query(r, h.BLOCK) ? t + e === this.length() && this.format(r, o) : se(de(n.prototype), "formatAt", this).call(this, t, Math.min(e, this.length() - t - 1), r, o), this.cache = {});
        }
      }, {
        key: "insertAt",
        value: function value(t, e, r) {
          if (null != r) return se(de(n.prototype), "insertAt", this).call(this, t, e, r), void (this.cache = {});

          if (0 !== e.length) {
            var o = e.split("\n"),
                i = o.shift();
            i.length > 0 && (t < this.length() - 1 || null == this.children.tail ? se(de(n.prototype), "insertAt", this).call(this, Math.min(t, this.length() - 1), i) : this.children.tail.insertAt(this.children.tail.length(), i), this.cache = {});
            var u = this;
            o.reduce(function (t, e) {
              return (u = u.split(t, !0)).insertAt(0, e), e.length;
            }, t + i.length);
          }
        }
      }, {
        key: "insertBefore",
        value: function value(t, e) {
          var r = this.children.head;
          se(de(n.prototype), "insertBefore", this).call(this, t, e), r instanceof Ht && r.remove(), this.cache = {};
        }
      }, {
        key: "length",
        value: function value() {
          return null == this.cache.length && (this.cache.length = se(de(n.prototype), "length", this).call(this) + 1), this.cache.length;
        }
      }, {
        key: "moveChildren",
        value: function value(t, e) {
          se(de(n.prototype), "moveChildren", this).call(this, t, e), this.cache = {};
        }
      }, {
        key: "optimize",
        value: function value(t) {
          se(de(n.prototype), "optimize", this).call(this, t), this.cache = {};
        }
      }, {
        key: "path",
        value: function value(t) {
          return se(de(n.prototype), "path", this).call(this, t, !0);
        }
      }, {
        key: "removeChild",
        value: function value(t) {
          se(de(n.prototype), "removeChild", this).call(this, t), this.cache = {};
        }
      }, {
        key: "split",
        value: function value(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];

          if (e && (0 === t || t >= this.length() - 1)) {
            var r = this.clone();
            return 0 === t ? (this.parent.insertBefore(r, this), this) : (this.parent.insertBefore(r, this.next), r);
          }

          var o = se(de(n.prototype), "split", this).call(this, t, e);
          return this.cache = {}, o;
        }
      }]), n;
    }(q);

    ve.blotName = "block", ve.tagName = "P", ve.defaultChild = Ht, ve.allowedChildren = [Ht, ne, B, St];

    var be = function (t) {
      fe(n, t);
      var e = pe(n);

      function n() {
        return ae(this, n), e.apply(this, arguments);
      }

      return le(n, [{
        key: "attach",
        value: function value() {
          se(de(n.prototype), "attach", this).call(this), this.attributes = new P(this.domNode);
        }
      }, {
        key: "delta",
        value: function value() {
          return new u.a().insert(this.value(), oe(oe({}, this.formats()), this.attributes.values()));
        }
      }, {
        key: "format",
        value: function value(t, e) {
          var n = this.scroll.query(t, h.BLOCK_ATTRIBUTE);
          null != n && this.attributes.attribute(n, e);
        }
      }, {
        key: "formatAt",
        value: function value(t, e, n, r) {
          this.format(n, r);
        }
      }, {
        key: "insertAt",
        value: function value(t, e, r) {
          if ("string" == typeof e && e.endsWith("\n")) {
            var o = this.scroll.create(ve.blotName);
            this.parent.insertBefore(o, 0 === t ? this : this.next), o.insertAt(0, e.slice(0, -1));
          } else se(de(n.prototype), "insertAt", this).call(this, t, e, r);
        }
      }]), n;
    }(B);

    function me(t) {
      var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
      return t.descendants(N).reduce(function (t, n) {
        return 0 === n.length() ? t : t.insert(n.value(), ge(n, {}, e));
      }, new u.a()).insert("\n", ge(t));
    }

    function ge(t) {
      var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          n = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
      return null == t ? e : ("function" == typeof t.formats && (e = oe(oe({}, e), t.formats()), n && delete e["code-token"]), null == t.parent || "scroll" === t.parent.statics.blotName || t.parent.statics.scope !== t.statics.scope ? e : ge(t.parent, e, n));
    }

    function Oe(t) {
      return Ae(t) || function (t) {
        if ("undefined" != typeof Symbol && Symbol.iterator in Object(t)) return Array.from(t);
      }(t) || xe(t) || Se();
    }

    function we(t, e) {
      var n = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }

      return n;
    }

    function _e(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? we(Object(n), !0).forEach(function (e) {
          je(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : we(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }

      return t;
    }

    function je(t, e, n) {
      return e in t ? Object.defineProperty(t, e, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = n, t;
    }

    function Ne(t) {
      return (Ne = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function ke(t, e) {
      return Ae(t) || function (t, e) {
        if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(t))) return;
        var n = [],
            r = !0,
            o = !1,
            i = void 0;

        try {
          for (var u, a = t[Symbol.iterator](); !(r = (u = a.next()).done) && (n.push(u.value), !e || n.length !== e); r = !0) {
            ;
          }
        } catch (t) {
          o = !0, i = t;
        } finally {
          try {
            r || null == a.return || a.return();
          } finally {
            if (o) throw i;
          }
        }

        return n;
      }(t, e) || xe(t, e) || Se();
    }

    function Se() {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }

    function xe(t, e) {
      if (t) {
        if ("string" == typeof t) return Ee(t, e);
        var n = Object.prototype.toString.call(t).slice(8, -1);
        return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Ee(t, e) : void 0;
      }
    }

    function Ee(t, e) {
      (null == e || e > t.length) && (e = t.length);

      for (var n = 0, r = new Array(e); n < e; n++) {
        r[n] = t[n];
      }

      return r;
    }

    function Ae(t) {
      if (Array.isArray(t)) return t;
    }

    function Re(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    be.scope = h.BLOCK_BLOT;
    var Te = /^[ -~]*$/;

    function Pe(t, e, n) {
      if (0 === t.length) {
        var r = ke(qe(n.pop()), 1)[0];
        return e <= 0 ? "</li></".concat(r, ">") : "</li></".concat(r, ">").concat(Pe([], e - 1, n));
      }

      var o = Oe(t),
          i = o[0],
          u = i.child,
          a = i.offset,
          c = i.length,
          l = i.indent,
          s = i.type,
          f = o.slice(1),
          h = ke(qe(s, u), 2),
          p = h[0],
          y = h[1];
      if (l > e) return n.push(s), l === e + 1 ? "<".concat(p, "><li").concat(y, ">").concat(Ce(u, a, c)).concat(Pe(f, l, n)) : "<".concat(p, "><li>").concat(Pe(t, e + 1, n));
      var d = n[n.length - 1];
      if (l === e && s === d) return "</li><li".concat(y, ">").concat(Ce(u, a, c)).concat(Pe(f, l, n));
      var v = ke(qe(n.pop()), 1)[0];
      return "</li></".concat(v, ">").concat(Pe(t, e - 1, n));
    }

    function Ce(t, e, n) {
      var r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
      if ("function" == typeof t.html) return t.html(e, n);
      if (t instanceof St) return xt(t.value().slice(e, e + n));

      if (t.children) {
        if ("list-container" === t.statics.blotName) {
          var o = [];
          return t.children.forEachAt(e, n, function (t, e, n) {
            var r = t.formats();
            o.push({
              child: t,
              offset: e,
              length: n,
              indent: r.indent || 0,
              type: r.list
            });
          }), Pe(o, -1, []);
        }

        var i = [];
        if (t.children.forEachAt(e, n, function (t, e, n) {
          i.push(Ce(t, e, n));
        }), Le(t.children, i), r || "list" === t.statics.blotName) return i.join("");
        var u = t.domNode,
            a = u.outerHTML,
            c = u.innerHTML,
            l = a.split(">".concat(c, "<")),
            s = ke(l, 2),
            f = s[0],
            h = s[1];
        return "<table" === f ? '<table style="border: 1px solid #000;">'.concat(i.join(""), "<").concat(h) : "".concat(f, ">").concat(i.join(""), "<").concat(h);
      }

      return t.domNode.outerHTML;
    }

    function Le(t, e) {
      1 === t.length && t.head instanceof Ht && e.push("<br>");
    }

    function De(t, e) {
      return Object.keys(e).reduce(function (n, r) {
        return null == t[r] || (e[r] === t[r] ? n[r] = e[r] : Array.isArray(e[r]) ? e[r].indexOf(t[r]) < 0 && (n[r] = e[r].concat([t[r]])) : n[r] = [e[r], t[r]]), n;
      }, {});
    }

    function qe(t, e) {
      var n = "ordered" === t ? "ol" : "ul",
          r = e ? "".concat(function (t) {
        var e = t.domNode;
        if (!e.hasAttributes()) return "";

        for (var n = e.attributes, r = " ", o = 0; o < n.length; o += 1) {
          var i = n[o].name,
              u = n[o].value;
          "class" === i && (u = u.replace(/ql-indent-\d/g, "").trim()), u.length && -1 === i.indexOf("data-") && (r += "".concat(i, '="').concat(u, '"'));
        }

        return r.length > 1 ? r : "";
      }(e)) : "";

      switch (t) {
        case "checked":
          return [n, "".concat(r, ' data-list="checked"')];

        case "unchecked":
          return [n, "".concat(r, ' data-list="unchecked"')];

        default:
          return [n, r];
      }
    }

    function Ie(t, e) {
      var n = t.index,
          r = t.length;
      return new bt(n + e, r);
    }

    var Be = function () {
      function t(e) {
        !function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, t), this.scroll = e, this.delta = this.getDelta();
      }

      var e, n, r;
      return e = t, (n = [{
        key: "applyDelta",
        value: function value(t) {
          var e = this,
              n = !1;
          this.scroll.update();
          var r = this.scroll.length();
          this.scroll.batchStart();

          var o = function (t) {
            return t.reduce(function (t, e) {
              if ("string" == typeof e.insert) {
                var n = e.insert.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
                return t.insert(n, e.attributes);
              }

              return t.push(e);
            }, new u.a());
          }(t);

          return o.reduce(function (t, o) {
            var u = o.retain || o.delete || o.insert.length || 1,
                a = o.attributes || {};

            if (null != o.insert) {
              if ("string" == typeof o.insert) {
                var c = o.insert;
                c.endsWith("\n") && n && (n = !1, c = c.slice(0, -1)), (t >= r || e.scroll.descendant(be, t)[0]) && !c.endsWith("\n") && (n = !0), e.scroll.insertAt(t, c);
                var l = ke(e.scroll.line(t), 2),
                    f = l[0],
                    h = l[1],
                    p = s()({}, ge(f));

                if (f instanceof ve) {
                  var y = ke(f.descendant(N, h), 1)[0];
                  p = s()(p, ge(y));
                }

                a = i.AttributeMap.diff(p, a) || {};
              } else if ("object" === Ne(o.insert)) {
                var d = Object.keys(o.insert)[0];
                if (null == d) return t;
                e.scroll.insertAt(t, d, o.insert[d]);
              }

              r += u;
            }

            return Object.keys(a).forEach(function (n) {
              e.scroll.formatAt(t, u, n, a[n]);
            }), t + u;
          }, 0), o.reduce(function (t, n) {
            return "number" == typeof n.delete ? (e.scroll.deleteAt(t, n.delete), t) : t + (n.retain || n.insert.length || 1);
          }, 0), this.scroll.batchEnd(), this.scroll.optimize(), this.update(o);
        }
      }, {
        key: "deleteText",
        value: function value(t, e) {
          return this.scroll.deleteAt(t, e), this.update(new u.a().retain(t).delete(e));
        }
      }, {
        key: "formatLine",
        value: function value(t, e) {
          var n = this,
              r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          this.scroll.update(), Object.keys(r).forEach(function (o) {
            n.scroll.lines(t, Math.max(e, 1)).forEach(function (t) {
              t.format(o, r[o]);
            });
          }), this.scroll.optimize();
          var o = new u.a().retain(t).retain(e, c()(r));
          return this.update(o);
        }
      }, {
        key: "formatText",
        value: function value(t, e) {
          var n = this,
              r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          Object.keys(r).forEach(function (o) {
            n.scroll.formatAt(t, e, o, r[o]);
          });
          var o = new u.a().retain(t).retain(e, c()(r));
          return this.update(o);
        }
      }, {
        key: "getContents",
        value: function value(t, e) {
          return this.delta.slice(t, t + e);
        }
      }, {
        key: "getDelta",
        value: function value() {
          return this.scroll.lines().reduce(function (t, e) {
            return t.concat(e.delta());
          }, new u.a());
        }
      }, {
        key: "getFormat",
        value: function value(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
              n = [],
              r = [];
          0 === e ? this.scroll.path(t).forEach(function (t) {
            var e = ke(t, 1)[0];
            e instanceof ve ? n.push(e) : e instanceof N && r.push(e);
          }) : (n = this.scroll.lines(t, e), r = this.scroll.descendants(N, t, e));
          var o = [n, r].map(function (t) {
            if (0 === t.length) return {};

            for (var e = ge(t.shift()); Object.keys(e).length > 0;) {
              var n = t.shift();
              if (null == n) return e;
              e = De(ge(n), e);
            }

            return e;
          }),
              i = ke(o, 2);
          return n = i[0], r = i[1], _e(_e({}, n), r);
        }
      }, {
        key: "getHTML",
        value: function value(t, e) {
          var n = ke(this.scroll.line(t), 2),
              r = n[0],
              o = n[1];
          return r.length() >= o + e ? Ce(r, o, e, !0) : Ce(this.scroll, t, e, !0);
        }
      }, {
        key: "getText",
        value: function value(t, e) {
          return this.getContents(t, e).filter(function (t) {
            return "string" == typeof t.insert;
          }).map(function (t) {
            return t.insert;
          }).join("");
        }
      }, {
        key: "insertEmbed",
        value: function value(t, e, n) {
          return this.scroll.insertAt(t, e, n), this.update(new u.a().retain(t).insert(je({}, e, n)));
        }
      }, {
        key: "insertText",
        value: function value(t, e) {
          var n = this,
              r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          return e = e.replace(/\r\n/g, "\n").replace(/\r/g, "\n"), this.scroll.insertAt(t, e), Object.keys(r).forEach(function (o) {
            n.scroll.formatAt(t, e.length, o, r[o]);
          }), this.update(new u.a().retain(t).insert(e, c()(r)));
        }
      }, {
        key: "isBlank",
        value: function value() {
          if (0 === this.scroll.children.length) return !0;
          if (this.scroll.children.length > 1) return !1;
          var t = this.scroll.children.head;
          return t.statics.blotName === ve.blotName && !(t.children.length > 1) && t.children.head instanceof Ht;
        }
      }, {
        key: "removeFormat",
        value: function value(t, e) {
          var n = this.getText(t, e),
              r = ke(this.scroll.line(t + e), 2),
              o = r[0],
              i = r[1],
              a = 0,
              c = new u.a();
          null != o && (a = o.length() - i, c = o.delta().slice(i, i + a - 1).insert("\n"));
          var l = this.getContents(t, e + a).diff(new u.a().insert(n).concat(c)),
              s = new u.a().retain(t).concat(l);
          return this.applyDelta(s);
        }
      }, {
        key: "update",
        value: function value(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [],
              n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : void 0,
              r = this.delta;

          if (1 === e.length && "characterData" === e[0].type && e[0].target.data.match(Te) && this.scroll.find(e[0].target)) {
            var o = this.scroll.find(e[0].target),
                i = ge(o),
                a = o.offset(this.scroll),
                c = e[0].oldValue.replace(It.CONTENTS, ""),
                l = new u.a().insert(c),
                s = new u.a().insert(o.value()),
                f = n && {
              oldRange: Ie(n.oldRange, -a),
              newRange: Ie(n.newRange, -a)
            },
                h = new u.a().retain(a).concat(l.diff(s, f));
            t = h.reduce(function (t, e) {
              return e.insert ? t.insert(e.insert, i) : t.push(e);
            }, new u.a()), this.delta = r.compose(t);
          } else this.delta = this.getDelta(), t && $()(r.compose(t), this.delta) || (t = r.diff(this.delta, n));

          return t;
        }
      }]) && Re(e.prototype, n), r && Re(e, r), t;
    }();

    function Me(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }

    var Ue = function t(e) {
      var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      Me(this, t), this.quill = e, this.options = n;
    };

    Ue.DEFAULTS = {};
    var ze = Ue;

    function Fe(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    var Ke = function () {
      function t(e, n) {
        !function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, t), this.quill = e, this.options = n, this.modules = {};
      }

      var e, n, r;
      return e = t, (n = [{
        key: "init",
        value: function value() {
          var t = this;
          Object.keys(this.options.modules).forEach(function (e) {
            null == t.modules[e] && t.addModule(e);
          });
        }
      }, {
        key: "addModule",
        value: function value(t) {
          var e = this.quill.constructor.import("modules/".concat(t));
          return this.modules[t] = new e(this.quill, this.options.modules[t] || {}), this.modules[t];
        }
      }]) && Fe(e.prototype, n), r && Fe(e, r), t;
    }();

    Ke.DEFAULTS = {
      modules: {}
    }, Ke.themes = {
      default: Ke
    };
    var We = Ke;

    function $e(t) {
      return ($e = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function He(t, e, n) {
      return e in t ? Object.defineProperty(t, e, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = n, t;
    }

    function Ve(t, e) {
      return function (t) {
        if (Array.isArray(t)) return t;
      }(t) || function (t, e) {
        if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(t))) return;
        var n = [],
            r = !0,
            o = !1,
            i = void 0;

        try {
          for (var u, a = t[Symbol.iterator](); !(r = (u = a.next()).done) && (n.push(u.value), !e || n.length !== e); r = !0) {
            ;
          }
        } catch (t) {
          o = !0, i = t;
        } finally {
          try {
            r || null == a.return || a.return();
          } finally {
            if (o) throw i;
          }
        }

        return n;
      }(t, e) || function (t, e) {
        if (!t) return;
        if ("string" == typeof t) return Ge(t, e);
        var n = Object.prototype.toString.call(t).slice(8, -1);
        "Object" === n && t.constructor && (n = t.constructor.name);
        if ("Map" === n || "Set" === n) return Array.from(t);
        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Ge(t, e);
      }(t, e) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function Ge(t, e) {
      (null == e || e > t.length) && (e = t.length);

      for (var n = 0, r = new Array(e); n < e; n++) {
        r[n] = t[n];
      }

      return r;
    }

    function Xe(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }

    function Ye(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    function Qe(t, e, n) {
      return e && Ye(t.prototype, e), n && Ye(t, n), t;
    }

    var Ze = J("quill"),
        Je = new v();
    O.uiClass = "ql-ui";

    var tn = function () {
      function t(e) {
        var n = this,
            r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        if (Xe(this, t), this.options = en(e, r), this.container = this.options.container, null == this.container) return Ze.error("Invalid Quill container", e);
        this.options.debug && t.debug(this.options.debug);
        var o = this.container.innerHTML.trim();
        this.container.classList.add("ql-container"), this.container.innerHTML = "", G.set(this.container, this), this.root = this.addContainer("ql-editor"), this.root.classList.add("ql-blank"), this.scrollingContainer = this.options.scrollingContainer || this.root, this.emitter = new lt();
        var i = this.options.registry.query(z.blotName);
        this.scroll = new i(this.options.registry, this.root, {
          emitter: this.emitter
        }), this.editor = new Be(this.scroll), this.selection = new mt(this.scroll, this.emitter), this.theme = new this.options.theme(this, this.options), this.keyboard = this.theme.addModule("keyboard"), this.clipboard = this.theme.addModule("clipboard"), this.history = this.theme.addModule("history"), this.uploader = this.theme.addModule("uploader"), this.theme.init(), this.emitter.on(lt.events.EDITOR_CHANGE, function (t) {
          t === lt.events.TEXT_CHANGE && n.root.classList.toggle("ql-blank", n.editor.isBlank());
        }), this.emitter.on(lt.events.SCROLL_UPDATE, function (t, e) {
          var r = n.selection.lastRange,
              o = Ve(n.selection.getRange(), 1)[0],
              i = r && o ? {
            oldRange: r,
            newRange: o
          } : void 0;
          nn.call(n, function () {
            return n.editor.update(null, e, i);
          }, t);
        });
        var u = this.clipboard.convert({
          html: "".concat(o, "<p><br></p>"),
          text: "\n"
        });
        this.setContents(u), this.history.clear(), this.options.placeholder && this.root.setAttribute("data-placeholder", this.options.placeholder), this.options.readOnly && this.disable(), this.allowReadOnlyEdits = !1;
      }

      return Qe(t, null, [{
        key: "debug",
        value: function value(t) {
          !0 === t && (t = "log"), J.level(t);
        }
      }, {
        key: "find",
        value: function value(t) {
          return G.get(t) || Je.find(t);
        }
      }, {
        key: "import",
        value: function value(t) {
          return null == this.imports[t] && Ze.error("Cannot import ".concat(t, ". Are you sure it was registered?")), this.imports[t];
        }
      }, {
        key: "register",
        value: function value(t, e) {
          var n = this,
              r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];

          if ("string" != typeof t) {
            var o = t.attrName || t.blotName;
            "string" == typeof o ? this.register("formats/".concat(o), t, e) : Object.keys(t).forEach(function (r) {
              n.register(r, t[r], e);
            });
          } else null == this.imports[t] || r || Ze.warn("Overwriting ".concat(t, " with"), e), this.imports[t] = e, 0 !== t.indexOf("blots/") && 0 !== t.indexOf("formats/") || "abstract" === e.blotName || Je.register(e), "function" == typeof e.register && e.register(Je);
        }
      }]), Qe(t, [{
        key: "addContainer",
        value: function value(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;

          if ("string" == typeof t) {
            var n = t;
            (t = document.createElement("div")).classList.add(n);
          }

          return this.container.insertBefore(t, e), t;
        }
      }, {
        key: "blur",
        value: function value() {
          this.selection.setRange(null);
        }
      }, {
        key: "deleteText",
        value: function value(t, e, n) {
          var r = this,
              o = Ve(rn(t, e, n), 4);
          return t = o[0], e = o[1], n = o[3], nn.call(this, function () {
            return r.editor.deleteText(t, e);
          }, n, t, -1 * e);
        }
      }, {
        key: "disable",
        value: function value() {
          this.enable(!1);
        }
      }, {
        key: "editReadOnly",
        value: function value(t) {
          this.allowReadOnlyEdits = !0;
          var e = t();
          return this.allowReadOnlyEdits = !1, e;
        }
      }, {
        key: "enable",
        value: function value() {
          var t = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
          this.scroll.enable(t), this.container.classList.toggle("ql-disabled", !t);
        }
      }, {
        key: "focus",
        value: function value() {
          var t = this.scrollingContainer.scrollTop;
          this.selection.focus(), this.scrollingContainer.scrollTop = t, this.scrollIntoView();
        }
      }, {
        key: "format",
        value: function value(t, e) {
          var n = this,
              r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : lt.sources.API;
          return nn.call(this, function () {
            var r = n.getSelection(!0),
                o = new u.a();
            if (null == r) return o;
            if (n.scroll.query(t, h.BLOCK)) o = n.editor.formatLine(r.index, r.length, He({}, t, e));else {
              if (0 === r.length) return n.selection.format(t, e), o;
              o = n.editor.formatText(r.index, r.length, He({}, t, e));
            }
            return n.setSelection(r, lt.sources.SILENT), o;
          }, r);
        }
      }, {
        key: "formatLine",
        value: function value(t, e, n, r, o) {
          var i,
              u = this,
              a = Ve(rn(t, e, n, r, o), 4);
          return t = a[0], e = a[1], i = a[2], o = a[3], nn.call(this, function () {
            return u.editor.formatLine(t, e, i);
          }, o, t, 0);
        }
      }, {
        key: "formatText",
        value: function value(t, e, n, r, o) {
          var i,
              u = this,
              a = Ve(rn(t, e, n, r, o), 4);
          return t = a[0], e = a[1], i = a[2], o = a[3], nn.call(this, function () {
            return u.editor.formatText(t, e, i);
          }, o, t, 0);
        }
      }, {
        key: "getBounds",
        value: function value(t) {
          var e,
              n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
          e = "number" == typeof t ? this.selection.getBounds(t, n) : this.selection.getBounds(t.index, t.length);
          var r = this.container.getBoundingClientRect();
          return {
            bottom: e.bottom - r.top,
            height: e.height,
            left: e.left - r.left,
            right: e.right - r.left,
            top: e.top - r.top,
            width: e.width
          };
        }
      }, {
        key: "getContents",
        value: function value() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
              e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.getLength() - t,
              n = rn(t, e),
              r = Ve(n, 2);
          return t = r[0], e = r[1], this.editor.getContents(t, e);
        }
      }, {
        key: "getFormat",
        value: function value() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.getSelection(!0),
              e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
          return "number" == typeof t ? this.editor.getFormat(t, e) : this.editor.getFormat(t.index, t.length);
        }
      }, {
        key: "getIndex",
        value: function value(t) {
          return t.offset(this.scroll);
        }
      }, {
        key: "getLength",
        value: function value() {
          return this.scroll.length();
        }
      }, {
        key: "getLeaf",
        value: function value(t) {
          return this.scroll.leaf(t);
        }
      }, {
        key: "getLine",
        value: function value(t) {
          return this.scroll.line(t);
        }
      }, {
        key: "getLines",
        value: function value() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
              e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Number.MAX_VALUE;
          return "number" != typeof t ? this.scroll.lines(t.index, t.length) : this.scroll.lines(t, e);
        }
      }, {
        key: "getModule",
        value: function value(t) {
          return this.theme.modules[t];
        }
      }, {
        key: "getSelection",
        value: function value() {
          var t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
          return t && this.focus(), this.update(), this.selection.getRange()[0];
        }
      }, {
        key: "getSemanticHTML",
        value: function value() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
              e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.getLength() - t,
              n = rn(t, e),
              r = Ve(n, 2);
          return t = r[0], e = r[1], this.editor.getHTML(t, e);
        }
      }, {
        key: "getText",
        value: function value() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
              e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.getLength() - t,
              n = rn(t, e),
              r = Ve(n, 2);
          return t = r[0], e = r[1], this.editor.getText(t, e);
        }
      }, {
        key: "hasFocus",
        value: function value() {
          return this.selection.hasFocus();
        }
      }, {
        key: "insertEmbed",
        value: function value(e, n, r) {
          var o = this,
              i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : t.sources.API;
          return nn.call(this, function () {
            return o.editor.insertEmbed(e, n, r);
          }, i, e);
        }
      }, {
        key: "insertText",
        value: function value(t, e, n, r, o) {
          var i,
              u = this,
              a = Ve(rn(t, 0, n, r, o), 4);
          return t = a[0], i = a[2], o = a[3], nn.call(this, function () {
            return u.editor.insertText(t, e, i);
          }, o, t, e.length);
        }
      }, {
        key: "isEnabled",
        value: function value() {
          return this.scroll.isEnabled();
        }
      }, {
        key: "off",
        value: function value() {
          var t;
          return (t = this.emitter).off.apply(t, arguments);
        }
      }, {
        key: "on",
        value: function value() {
          var t;
          return (t = this.emitter).on.apply(t, arguments);
        }
      }, {
        key: "once",
        value: function value() {
          var t;
          return (t = this.emitter).once.apply(t, arguments);
        }
      }, {
        key: "removeFormat",
        value: function value(t, e, n) {
          var r = this,
              o = Ve(rn(t, e, n), 4);
          return t = o[0], e = o[1], n = o[3], nn.call(this, function () {
            return r.editor.removeFormat(t, e);
          }, n, t);
        }
      }, {
        key: "scrollIntoView",
        value: function value() {
          this.selection.scrollIntoView(this.scrollingContainer);
        }
      }, {
        key: "setContents",
        value: function value(t) {
          var e = this,
              n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : lt.sources.API;
          return nn.call(this, function () {
            t = new u.a(t);
            var n = e.getLength(),
                r = e.editor.deleteText(0, n),
                o = e.editor.applyDelta(t),
                i = e.editor.deleteText(e.getLength() - 1, 1);
            return r.compose(o).compose(i);
          }, n);
        }
      }, {
        key: "setSelection",
        value: function value(e, n, r) {
          if (null == e) this.selection.setRange(null, n || t.sources.API);else {
            var o = Ve(rn(e, n, r), 4);
            e = o[0], n = o[1], r = o[3], this.selection.setRange(new bt(Math.max(0, e), n), r), r !== lt.sources.SILENT && this.selection.scrollIntoView(this.scrollingContainer);
          }
        }
      }, {
        key: "setText",
        value: function value(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : lt.sources.API,
              n = new u.a().insert(t);
          return this.setContents(n, e);
        }
      }, {
        key: "update",
        value: function value() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : lt.sources.USER,
              e = this.scroll.update(t);
          return this.selection.update(t), e;
        }
      }, {
        key: "updateContents",
        value: function value(t) {
          var e = this,
              n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : lt.sources.API;
          return nn.call(this, function () {
            return t = new u.a(t), e.editor.applyDelta(t, n);
          }, n, !0);
        }
      }]), t;
    }();

    function en(t, e) {
      if ((e = s()({
        container: t,
        modules: {
          clipboard: !0,
          keyboard: !0,
          history: !0,
          uploader: !0
        }
      }, e)).theme && e.theme !== tn.DEFAULTS.theme) {
        if (e.theme = tn.import("themes/".concat(e.theme)), null == e.theme) throw new Error("Invalid theme ".concat(e.theme, ". Did you register it?"));
      } else e.theme = We;

      var n = c()(e.theme.DEFAULTS);
      [n, e].forEach(function (t) {
        t.modules = t.modules || {}, Object.keys(t.modules).forEach(function (e) {
          !0 === t.modules[e] && (t.modules[e] = {});
        });
      });
      var r = Object.keys(n.modules).concat(Object.keys(e.modules)).reduce(function (t, e) {
        var n = tn.import("modules/".concat(e));
        return null == n ? Ze.error("Cannot load ".concat(e, " module. Are you sure you registered it?")) : t[e] = n.DEFAULTS || {}, t;
      }, {});
      return null != e.modules && e.modules.toolbar && e.modules.toolbar.constructor !== Object && (e.modules.toolbar = {
        container: e.modules.toolbar
      }), e = s()({}, tn.DEFAULTS, {
        modules: r
      }, n, e), ["bounds", "container", "scrollingContainer"].forEach(function (t) {
        "string" == typeof e[t] && (e[t] = document.querySelector(e[t]));
      }), e.modules = Object.keys(e.modules).reduce(function (t, n) {
        return e.modules[n] && (t[n] = e.modules[n]), t;
      }, {}), e;
    }

    function nn(t, e, n, r) {
      if (!this.isEnabled() && e === lt.sources.USER && !this.allowReadOnlyEdits) return new u.a();
      var o = null == n ? null : this.getSelection(),
          i = this.editor.delta,
          a = t();

      if (null != o && (!0 === n && (n = o.index), null == r ? o = on(o, a, e) : 0 !== r && (o = on(o, n, r, e)), this.setSelection(o, lt.sources.SILENT)), a.length() > 0) {
        var c,
            l,
            s = [lt.events.TEXT_CHANGE, a, i, e];
        if ((c = this.emitter).emit.apply(c, [lt.events.EDITOR_CHANGE].concat(s)), e !== lt.sources.SILENT) (l = this.emitter).emit.apply(l, s);
      }

      return a;
    }

    function rn(t, e, n, r, o) {
      var i = {};
      return "number" == typeof t.index && "number" == typeof t.length ? "number" != typeof e ? (o = r, r = n, n = e, e = t.length, t = t.index) : (e = t.length, t = t.index) : "number" != typeof e && (o = r, r = n, n = e, e = 0), "object" === $e(n) ? (i = n, o = r) : "string" == typeof n && (null != r ? i[n] = r : o = n), [t, e, i, o = o || lt.sources.API];
    }

    function on(t, e, n, r) {
      if (null == t) return null;
      var o, i;

      if (e instanceof u.a) {
        var a = Ve([t.index, t.index + t.length].map(function (t) {
          return e.transformPosition(t, r !== lt.sources.USER);
        }), 2);
        o = a[0], i = a[1];
      } else {
        var c = Ve([t.index, t.index + t.length].map(function (t) {
          return t < e || t === e && r === lt.sources.USER ? t : n >= 0 ? t + n : Math.max(e, t + n);
        }), 2);
        o = c[0], i = c[1];
      }

      return new bt(o, i - o);
    }

    function un(t) {
      return (un = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function an(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }

    function cn(t, e) {
      return (cn = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      })(t, e);
    }

    function ln(t) {
      var e = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = fn(t);

        if (e) {
          var o = fn(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return sn(this, n);
      };
    }

    function sn(t, e) {
      return !e || "object" !== un(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }(t) : e;
    }

    function fn(t) {
      return (fn = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
    }

    tn.DEFAULTS = {
      bounds: null,
      modules: {},
      placeholder: "",
      readOnly: !1,
      registry: Je,
      scrollingContainer: null,
      theme: "default"
    }, tn.events = lt.events, tn.sources = lt.sources, tn.version = "0.9.5", tn.imports = {
      delta: u.a,
      parchment: r,
      "core/module": ze,
      "core/theme": We
    };

    var hn = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && cn(t, e);
      }(n, t);
      var e = ln(n);

      function n() {
        return an(this, n), e.apply(this, arguments);
      }

      return n;
    }(_);

    function pn(t) {
      return (pn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function yn(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    function dn(t, e, n) {
      return (dn = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, n) {
        var r = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = gn(t));) {
            ;
          }

          return t;
        }(t, e);

        if (r) {
          var o = Object.getOwnPropertyDescriptor(r, e);
          return o.get ? o.get.call(n) : o.value;
        }
      })(t, e, n || t);
    }

    function vn(t, e) {
      return (vn = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      })(t, e);
    }

    function bn(t) {
      var e = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = gn(t);

        if (e) {
          var o = gn(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return mn(this, n);
      };
    }

    function mn(t, e) {
      return !e || "object" !== pn(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }(t) : e;
    }

    function gn(t) {
      return (gn = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
    }

    var On = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && vn(t, e);
      }(i, t);
      var e,
          n,
          r,
          o = bn(i);

      function i(t, e) {
        var n;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, i), (n = o.call(this, t, e)).contentNode = document.createElement("span"), n.contentNode.setAttribute("contenteditable", !1), Array.from(n.domNode.childNodes).forEach(function (t) {
          n.contentNode.appendChild(t);
        }), n.leftGuard = document.createTextNode("\uFEFF"), n.rightGuard = document.createTextNode("\uFEFF"), n.domNode.appendChild(n.leftGuard), n.domNode.appendChild(n.contentNode), n.domNode.appendChild(n.rightGuard), n;
      }

      return e = i, (n = [{
        key: "index",
        value: function value(t, e) {
          return t === this.leftGuard ? 0 : t === this.rightGuard ? 1 : dn(gn(i.prototype), "index", this).call(this, t, e);
        }
      }, {
        key: "restore",
        value: function value(t) {
          var e,
              n,
              r = t.data.split("\uFEFF").join("");
          if (t === this.leftGuard) {
            if (this.prev instanceof St) {
              var o = this.prev.length();
              this.prev.insertAt(o, r), e = {
                startNode: this.prev.domNode,
                startOffset: o + r.length
              };
            } else n = document.createTextNode(r), this.parent.insertBefore(this.scroll.create(n), this), e = {
              startNode: n,
              startOffset: r.length
            };
          } else t === this.rightGuard && (this.next instanceof St ? (this.next.insertAt(0, r), e = {
            startNode: this.next.domNode,
            startOffset: r.length
          }) : (n = document.createTextNode(r), this.parent.insertBefore(this.scroll.create(n), this.next), e = {
            startNode: n,
            startOffset: r.length
          }));
          return t.data = "\uFEFF", e;
        }
      }, {
        key: "update",
        value: function value(t, e) {
          var n = this;
          t.forEach(function (t) {
            if ("characterData" === t.type && (t.target === n.leftGuard || t.target === n.rightGuard)) {
              var r = n.restore(t.target);
              r && (e.range = r);
            }
          });
        }
      }]) && yn(e.prototype, n), r && yn(e, r), i;
    }(B);

    function wn(t) {
      return (wn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function _n(t, e) {
      return function (t) {
        if (Array.isArray(t)) return t;
      }(t) || function (t, e) {
        if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(t))) return;
        var n = [],
            r = !0,
            o = !1,
            i = void 0;

        try {
          for (var u, a = t[Symbol.iterator](); !(r = (u = a.next()).done) && (n.push(u.value), !e || n.length !== e); r = !0) {
            ;
          }
        } catch (t) {
          o = !0, i = t;
        } finally {
          try {
            r || null == a.return || a.return();
          } finally {
            if (o) throw i;
          }
        }

        return n;
      }(t, e) || function (t, e) {
        if (!t) return;
        if ("string" == typeof t) return jn(t, e);
        var n = Object.prototype.toString.call(t).slice(8, -1);
        "Object" === n && t.constructor && (n = t.constructor.name);
        if ("Map" === n || "Set" === n) return Array.from(t);
        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return jn(t, e);
      }(t, e) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function jn(t, e) {
      (null == e || e > t.length) && (e = t.length);

      for (var n = 0, r = new Array(e); n < e; n++) {
        r[n] = t[n];
      }

      return r;
    }

    function Nn(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    function kn(t, e, n) {
      return (kn = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, n) {
        var r = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = An(t));) {
            ;
          }

          return t;
        }(t, e);

        if (r) {
          var o = Object.getOwnPropertyDescriptor(r, e);
          return o.get ? o.get.call(n) : o.value;
        }
      })(t, e, n || t);
    }

    function Sn(t, e) {
      return (Sn = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      })(t, e);
    }

    function xn(t) {
      var e = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = An(t);

        if (e) {
          var o = An(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return En(this, n);
      };
    }

    function En(t, e) {
      return !e || "object" !== wn(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }(t) : e;
    }

    function An(t) {
      return (An = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
    }

    function Rn(t) {
      return t instanceof ve || t instanceof be;
    }

    var Tn = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && Sn(t, e);
      }(i, t);
      var e,
          n,
          r,
          o = xn(i);

      function i(t, e, n) {
        var r,
            u = n.emitter;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, i), (r = o.call(this, t, e)).emitter = u, r.batch = !1, r.optimize(), r.enable(), r.domNode.addEventListener("dragstart", function (t) {
          return r.handleDragStart(t);
        }), r;
      }

      return e = i, (n = [{
        key: "batchStart",
        value: function value() {
          Array.isArray(this.batch) || (this.batch = []);
        }
      }, {
        key: "batchEnd",
        value: function value() {
          var t = this.batch;
          this.batch = !1, this.update(t);
        }
      }, {
        key: "emitMount",
        value: function value(t) {
          this.emitter.emit(lt.events.SCROLL_BLOT_MOUNT, t);
        }
      }, {
        key: "emitUnmount",
        value: function value(t) {
          this.emitter.emit(lt.events.SCROLL_BLOT_UNMOUNT, t);
        }
      }, {
        key: "deleteAt",
        value: function value(t, e) {
          var n = _n(this.line(t), 2),
              r = n[0],
              o = n[1],
              u = _n(this.line(t + e), 1)[0];

          if (kn(An(i.prototype), "deleteAt", this).call(this, t, e), null != u && r !== u && o > 0) {
            if (r instanceof be || u instanceof be) return void this.optimize();
            var a = u.children.head instanceof Ht ? null : u.children.head;
            r.moveChildren(u, a), r.remove();
          }

          this.optimize();
        }
      }, {
        key: "enable",
        value: function value() {
          var t = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
          this.domNode.setAttribute("contenteditable", t);
        }
      }, {
        key: "formatAt",
        value: function value(t, e, n, r) {
          kn(An(i.prototype), "formatAt", this).call(this, t, e, n, r), this.optimize();
        }
      }, {
        key: "handleDragStart",
        value: function value(t) {
          t.preventDefault();
        }
      }, {
        key: "insertAt",
        value: function value(t, e, n) {
          if (t >= this.length()) {
            if (null == n || null == this.scroll.query(e, h.BLOCK)) {
              var r = this.scroll.create(this.statics.defaultChild.blotName);
              this.appendChild(r), null == n && e.endsWith("\n") ? r.insertAt(0, e.slice(0, -1), n) : r.insertAt(0, e, n);
            } else {
              var o = this.scroll.create(e, n);
              this.appendChild(o);
            }
          } else kn(An(i.prototype), "insertAt", this).call(this, t, e, n);
          this.optimize();
        }
      }, {
        key: "insertBefore",
        value: function value(t, e) {
          if (t.statics.scope === h.INLINE_BLOT) {
            var n = this.scroll.create(this.statics.defaultChild.blotName);
            n.appendChild(t), kn(An(i.prototype), "insertBefore", this).call(this, n, e);
          } else kn(An(i.prototype), "insertBefore", this).call(this, t, e);
        }
      }, {
        key: "isEnabled",
        value: function value() {
          return "true" === this.domNode.getAttribute("contenteditable");
        }
      }, {
        key: "leaf",
        value: function value(t) {
          return this.path(t).pop() || [null, -1];
        }
      }, {
        key: "line",
        value: function value(t) {
          return t === this.length() ? this.line(t - 1) : this.descendant(Rn, t);
        }
      }, {
        key: "lines",
        value: function value() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
              e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Number.MAX_VALUE,
              n = function t(e, n, r) {
            var o = [],
                i = r;
            return e.children.forEachAt(n, r, function (e, n, r) {
              Rn(e) ? o.push(e) : e instanceof _ && (o = o.concat(t(e, n, i))), i -= r;
            }), o;
          };

          return n(this, t, e);
        }
      }, {
        key: "optimize",
        value: function value() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
              e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          this.batch || (kn(An(i.prototype), "optimize", this).call(this, t, e), t.length > 0 && this.emitter.emit(lt.events.SCROLL_OPTIMIZE, t, e));
        }
      }, {
        key: "path",
        value: function value(t) {
          return kn(An(i.prototype), "path", this).call(this, t).slice(1);
        }
      }, {
        key: "remove",
        value: function value() {}
      }, {
        key: "update",
        value: function value(t) {
          if (this.batch) Array.isArray(t) && (this.batch = this.batch.concat(t));else {
            var e = lt.sources.USER;
            "string" == typeof t && (e = t), Array.isArray(t) || (t = this.observer.takeRecords()), t.length > 0 && this.emitter.emit(lt.events.SCROLL_BEFORE_UPDATE, e, t), kn(An(i.prototype), "update", this).call(this, t.concat([])), t.length > 0 && this.emitter.emit(lt.events.SCROLL_UPDATE, e, t);
          }
        }
      }]) && Nn(e.prototype, n), r && Nn(e, r), i;
    }(z);

    Tn.blotName = "scroll", Tn.className = "ql-editor", Tn.tagName = "DIV", Tn.defaultChild = ve, Tn.allowedChildren = [ve, be, hn];
    var Pn = Tn,
        Cn = {
      scope: h.BLOCK,
      whitelist: ["right", "center", "justify"]
    },
        Ln = new k("align", "align", Cn),
        Dn = new E("align", "ql-align", Cn),
        qn = new T("align", "text-align", Cn);

    function In(t) {
      return (In = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function Bn(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }

    function Mn(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    function Un(t, e, n) {
      return (Un = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, n) {
        var r = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = Wn(t));) {
            ;
          }

          return t;
        }(t, e);

        if (r) {
          var o = Object.getOwnPropertyDescriptor(r, e);
          return o.get ? o.get.call(n) : o.value;
        }
      })(t, e, n || t);
    }

    function zn(t, e) {
      return (zn = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      })(t, e);
    }

    function Fn(t) {
      var e = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = Wn(t);

        if (e) {
          var o = Wn(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return Kn(this, n);
      };
    }

    function Kn(t, e) {
      return !e || "object" !== In(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }(t) : e;
    }

    function Wn(t) {
      return (Wn = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
    }

    var $n = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && zn(t, e);
      }(i, t);
      var e,
          n,
          r,
          o = Fn(i);

      function i() {
        return Bn(this, i), o.apply(this, arguments);
      }

      return e = i, (n = [{
        key: "value",
        value: function value(t) {
          var e = Un(Wn(i.prototype), "value", this).call(this, t);
          if (0 !== e.indexOf("rgb(")) return e;
          e = e.replace(/^[^\d]+/, "").replace(/[^\d]+$/, "");
          var n = e.split(",").map(function (t) {
            return "00".concat(parseInt(t, 10).toString(16)).slice(-2);
          }).join("");
          return "#".concat(n);
        }
      }]) && Mn(e.prototype, n), r && Mn(e, r), i;
    }(T),
        Hn = new E("color", "ql-color", {
      scope: h.INLINE
    }),
        Vn = new $n("color", "color", {
      scope: h.INLINE
    }),
        Gn = new E("background", "ql-bg", {
      scope: h.INLINE
    }),
        Xn = new $n("background", "background-color", {
      scope: h.INLINE
    });

    function Yn(t) {
      return (Yn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function Qn(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }

    function Zn(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    function Jn(t, e, n) {
      return e && Zn(t.prototype, e), n && Zn(t, n), t;
    }

    function tr(t, e, n) {
      return (tr = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, n) {
        var r = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = ir(t));) {
            ;
          }

          return t;
        }(t, e);

        if (r) {
          var o = Object.getOwnPropertyDescriptor(r, e);
          return o.get ? o.get.call(n) : o.value;
        }
      })(t, e, n || t);
    }

    function er(t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          writable: !0,
          configurable: !0
        }
      }), e && nr(t, e);
    }

    function nr(t, e) {
      return (nr = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      })(t, e);
    }

    function rr(t) {
      var e = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = ir(t);

        if (e) {
          var o = ir(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return or(this, n);
      };
    }

    function or(t, e) {
      return !e || "object" !== Yn(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }(t) : e;
    }

    function ir(t) {
      return (ir = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
    }

    var ur = function (t) {
      er(n, t);
      var e = rr(n);

      function n() {
        return Qn(this, n), e.apply(this, arguments);
      }

      return Jn(n, [{
        key: "code",
        value: function value(t, e) {
          return xt(this.children.map(function (t) {
            return t.length() <= 1 ? "" : t.domNode.innerText;
          }).join("\n").slice(t, t + e));
        }
      }, {
        key: "html",
        value: function value(t, e) {
          return "<pre>\n".concat(this.code(t, e), "\n</pre>");
        }
      }], [{
        key: "create",
        value: function value(t) {
          var e = tr(ir(n), "create", this).call(this, t);
          return e.setAttribute("spellcheck", !1), e;
        }
      }]), n;
    }(hn),
        ar = function (t) {
      er(n, t);
      var e = rr(n);

      function n() {
        return Qn(this, n), e.apply(this, arguments);
      }

      return Jn(n, null, [{
        key: "register",
        value: function value() {
          tn.register(ur);
        }
      }]), n;
    }(ve),
        cr = function (t) {
      er(n, t);
      var e = rr(n);

      function n() {
        return Qn(this, n), e.apply(this, arguments);
      }

      return n;
    }(ne);

    cr.blotName = "code", cr.tagName = "CODE", ar.blotName = "code-block", ar.className = "ql-code-block", ar.tagName = "DIV", ur.blotName = "code-block-container", ur.className = "ql-code-block-container", ur.tagName = "DIV", ur.allowedChildren = [ar], ar.allowedChildren = [St, Ht, It], ar.requiredContainer = ur, ar.TAB = "  ";
    var lr = {
      scope: h.BLOCK,
      whitelist: ["rtl"]
    },
        sr = new k("direction", "dir", lr),
        fr = new E("direction", "ql-direction", lr),
        hr = new T("direction", "direction", lr);

    function pr(t) {
      return (pr = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function yr(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }

    function dr(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    function vr(t, e, n) {
      return (vr = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, n) {
        var r = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = Or(t));) {
            ;
          }

          return t;
        }(t, e);

        if (r) {
          var o = Object.getOwnPropertyDescriptor(r, e);
          return o.get ? o.get.call(n) : o.value;
        }
      })(t, e, n || t);
    }

    function br(t, e) {
      return (br = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      })(t, e);
    }

    function mr(t) {
      var e = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = Or(t);

        if (e) {
          var o = Or(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return gr(this, n);
      };
    }

    function gr(t, e) {
      return !e || "object" !== pr(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }(t) : e;
    }

    function Or(t) {
      return (Or = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
    }

    var wr = {
      scope: h.INLINE,
      whitelist: ["serif", "monospace"]
    },
        _r = new E("font", "ql-font", wr),
        jr = new (function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && br(t, e);
      }(i, t);
      var e,
          n,
          r,
          o = mr(i);

      function i() {
        return yr(this, i), o.apply(this, arguments);
      }

      return e = i, (n = [{
        key: "value",
        value: function value(t) {
          return vr(Or(i.prototype), "value", this).call(this, t).replace(/["']/g, "");
        }
      }]) && dr(e.prototype, n), r && dr(e, r), i;
    }(T))("font", "font-family", wr),
        Nr = new E("size", "ql-size", {
      scope: h.INLINE,
      whitelist: ["small", "large", "huge"]
    }),
        kr = new T("size", "font-size", {
      scope: h.INLINE,
      whitelist: ["10px", "18px", "32px"]
    });

    function Sr(t, e) {
      var n = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }

      return n;
    }

    function xr(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? Sr(Object(n), !0).forEach(function (e) {
          Ar(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Sr(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }

      return t;
    }

    function Er(t) {
      return (Er = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function Ar(t, e, n) {
      return e in t ? Object.defineProperty(t, e, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = n, t;
    }

    function Rr(t, e) {
      return function (t) {
        if (Array.isArray(t)) return t;
      }(t) || function (t, e) {
        if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(t))) return;
        var n = [],
            r = !0,
            o = !1,
            i = void 0;

        try {
          for (var u, a = t[Symbol.iterator](); !(r = (u = a.next()).done) && (n.push(u.value), !e || n.length !== e); r = !0) {
            ;
          }
        } catch (t) {
          o = !0, i = t;
        } finally {
          try {
            r || null == a.return || a.return();
          } finally {
            if (o) throw i;
          }
        }

        return n;
      }(t, e) || function (t, e) {
        if (!t) return;
        if ("string" == typeof t) return Tr(t, e);
        var n = Object.prototype.toString.call(t).slice(8, -1);
        "Object" === n && t.constructor && (n = t.constructor.name);
        if ("Map" === n || "Set" === n) return Array.from(t);
        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Tr(t, e);
      }(t, e) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function Tr(t, e) {
      (null == e || e > t.length) && (e = t.length);

      for (var n = 0, r = new Array(e); n < e; n++) {
        r[n] = t[n];
      }

      return r;
    }

    function Pr(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    function Cr(t, e) {
      return (Cr = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      })(t, e);
    }

    function Lr(t) {
      var e = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = Ir(t);

        if (e) {
          var o = Ir(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return Dr(this, n);
      };
    }

    function Dr(t, e) {
      return !e || "object" !== Er(e) && "function" != typeof e ? qr(t) : e;
    }

    function qr(t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }

    function Ir(t) {
      return (Ir = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
    }

    var Br = J("quill:clipboard"),
        Mr = [[Node.TEXT_NODE, function (t, e) {
      var n = t.data;
      if ("O:P" === t.parentNode.tagName) return e.insert(n.trim());
      if (0 === n.trim().length && -1 !== n.indexOf("\n")) return e;

      if (!function t(e) {
        if (null == e) return !1;
        Hr.has(e) || ("PRE" === e.tagName ? Hr.set(e, !0) : Hr.set(e, t(e.parentNode)));
        return Hr.get(e);
      }(t)) {
        var r = function r(t, e) {
          var n = e.replace(/[^\u00a0]/g, "");
          return n.length < 1 && t ? " " : n;
        };

        n = (n = n.replace(/\r\n/g, " ").replace(/\n/g, " ")).replace(/\s\s+/g, r.bind(r, !0)), (null == t.previousSibling && $r(t.parentNode) || null != t.previousSibling && $r(t.previousSibling)) && (n = n.replace(/^\s+/, r.bind(r, !1))), (null == t.nextSibling && $r(t.parentNode) || null != t.nextSibling && $r(t.nextSibling)) && (n = n.replace(/\s+$/, r.bind(r, !1)));
      }

      return e.insert(n);
    }], [Node.TEXT_NODE, Xr], ["br", function (t, e) {
      Wr(e, "\n") || e.insert("\n");
      return e;
    }], [Node.ELEMENT_NODE, Xr], [Node.ELEMENT_NODE, function (t, e, n) {
      var r = n.query(t);
      if (null == r) return e;

      if (r.prototype instanceof B) {
        var o = {},
            i = r.value(t);
        if (null != i) return o[r.blotName] = i, new u.a().insert(o, r.formats(t, n));
      } else if (r.prototype instanceof q && !Wr(e, "\n") && e.insert("\n"), "function" == typeof r.formats) return Kr(e, r.blotName, r.formats(t, n));

      return e;
    }], [Node.ELEMENT_NODE, function (t, e, n) {
      var r = k.keys(t),
          o = E.keys(t),
          i = T.keys(t),
          u = {};
      if (r.concat(o).concat(i).forEach(function (e) {
        var r = n.query(e, h.ATTRIBUTE);
        null != r && (u[r.attrName] = r.value(t), u[r.attrName]) || (null == (r = Ur[e]) || r.attrName !== e && r.keyName !== e || (u[r.attrName] = r.value(t) || void 0), null == (r = zr[e]) || r.attrName !== e && r.keyName !== e || (r = zr[e], u[r.attrName] = r.value(t) || void 0));
      }), Object.keys(u).length > 0) return Kr(e, u);
      return e;
    }], [Node.ELEMENT_NODE, function (t, e) {
      var n = {},
          r = t.style || {};
      "italic" === r.fontStyle && (n.italic = !0);
      -1 !== r.textDecoration.indexOf("underline") && (n.underline = !0);
      -1 !== r.textDecoration.indexOf("line-through") && (n.strike = !0);
      (0 === r.fontWeight.indexOf("bold") || parseInt(r.fontWeight, 10) >= 700) && (n.bold = !0);
      Object.keys(n).length > 0 && (e = Kr(e, n));
      if (parseFloat(r.textIndent || 0) > 0) return new u.a().insert("\t").concat(e);
      return e;
    }], ["li", function (t, e, n) {
      var r = n.query(t);
      if (null == r || "list" !== r.blotName || !Wr(e, "\n")) return e;
      var o = -1,
          i = t.parentNode;

      for (; null != i;) {
        -1 !== ["OL", "UL"].indexOf(i.tagName) && (o += 1), i = i.parentNode;
      }

      return o <= 0 ? e : e.reduce(function (t, e) {
        return e.attributes && "number" == typeof e.attributes.indent ? t.push(e) : t.insert(e.insert, xr({
          indent: o
        }, e.attributes || {}));
      }, new u.a());
    }], ["ol, ul", function (t, e) {
      var n = "OL" === t.tagName ? "ordered" : "bullet";
      return Kr(e, "list", n);
    }], ["pre", function (t, e, n) {
      var r = n.query("code-block"),
          o = !r || r.formats(t, n);
      return Kr(e, "code-block", o);
    }], ["tr", function (t, e) {
      var n = "TABLE" === t.parentNode.tagName ? t.parentNode : t.parentNode.parentNode,
          r = Array.from(n.querySelectorAll("tr")).indexOf(t) + 1;
      return Kr(e, "table", r);
    }], ["b", Gr.bind(Gr, "bold")], ["i", Gr.bind(Gr, "italic")], ["strike", Gr.bind(Gr, "strike")], ["style", function () {
      return new u.a();
    }]],
        Ur = [Ln, sr].reduce(function (t, e) {
      return t[e.keyName] = e, t;
    }, {}),
        zr = [qn, Xn, Vn, hr, jr, kr].reduce(function (t, e) {
      return t[e.keyName] = e, t;
    }, {}),
        Fr = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && Cr(t, e);
      }(i, t);
      var e,
          n,
          r,
          o = Lr(i);

      function i(t, e) {
        var n;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, i), (n = o.call(this, t, e)).quill.root.addEventListener("copy", function (t) {
          return n.onCaptureCopy(t, !1);
        }), n.quill.root.addEventListener("cut", function (t) {
          return n.onCaptureCopy(t, !0);
        }), n.quill.root.addEventListener("paste", n.onCapturePaste.bind(qr(n))), n.matchers = [], Mr.concat(n.options.matchers).forEach(function (t) {
          var e = Rr(t, 2),
              r = e[0],
              o = e[1];
          n.addMatcher(r, o);
        }), n;
      }

      return e = i, (n = [{
        key: "addMatcher",
        value: function value(t, e) {
          this.matchers.push([t, e]);
        }
      }, {
        key: "convert",
        value: function value(t) {
          var e = t.html,
              n = t.text,
              r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          if (r[ar.blotName]) return new u.a().insert(n, Ar({}, ar.blotName, r[ar.blotName]));
          if (!e) return new u.a().insert(n || "");
          var o = new DOMParser().parseFromString(e, "text/html"),
              i = o.body,
              a = new WeakMap(),
              c = this.prepareMatching(i, a),
              l = Rr(c, 2),
              s = l[0],
              f = l[1],
              h = Vr(this.quill.scroll, i, s, f, a);
          return Wr(h, "\n") && (null == h.ops[h.ops.length - 1].attributes || r.table) ? h.compose(new u.a().retain(h.length() - 1).delete(1)) : h;
        }
      }, {
        key: "dangerouslyPasteHTML",
        value: function value(t, e) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : tn.sources.API;

          if ("string" == typeof t) {
            var r = this.convert({
              html: t,
              text: ""
            });
            this.quill.setContents(r, e), this.quill.setSelection(0, tn.sources.SILENT);
          } else {
            var o = this.convert({
              html: e,
              text: ""
            });
            this.quill.updateContents(new u.a().retain(t).concat(o), n), this.quill.setSelection(t + o.length(), tn.sources.SILENT);
          }
        }
      }, {
        key: "onCaptureCopy",
        value: function value(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];

          if (!t.defaultPrevented && t.clipboardData) {
            t.preventDefault();
            var n = this.quill.selection.getRange(),
                r = Rr(n, 1),
                o = r[0];

            if (null != o) {
              var i = this.onCopy(o, e),
                  u = i.html,
                  a = i.text;
              t.clipboardData.setData("text/plain", a), t.clipboardData.setData("text/html", u), e && (this.raiseCallback("onCut", t), this.quill.deleteText(o, tn.sources.USER));
            }
          }
        }
      }, {
        key: "onCapturePaste",
        value: function value(t) {
          if (!t.defaultPrevented && this.quill.isEnabled() && (this.raiseCallback("onPaste", t), t.clipboardData)) {
            t.preventDefault();
            var e = this.quill.getSelection(!0);

            if (null != e) {
              var n = t.clipboardData.getData("text/html"),
                  r = t.clipboardData.getData("text/plain"),
                  o = Array.from(t.clipboardData.files || []);
              !n && o.length > 0 ? this.quill.uploader.upload(e, o) : this.onPaste(e, {
                html: n,
                text: r
              });
            }
          }
        }
      }, {
        key: "raiseCallback",
        value: function value(t, e) {
          var n = this.options[t];
          n && "function" == typeof n && n(e);
        }
      }, {
        key: "onCopy",
        value: function value(t) {
          var e = this.quill.getText(t);
          return {
            html: this.quill.getSemanticHTML(t),
            text: e
          };
        }
      }, {
        key: "onPaste",
        value: function value(t, e) {
          var n = e.text,
              r = e.html,
              o = this.quill.getFormat(t.index),
              i = this.convert({
            text: n,
            html: r
          }, o);
          Br.log("onPaste", i, {
            text: n,
            html: r
          });
          var a = new u.a().retain(t.index).delete(t.length).concat(i);
          this.quill.updateContents(a, tn.sources.USER), this.quill.setSelection(a.length() - t.length, tn.sources.SILENT), this.quill.scrollIntoView();
        }
      }, {
        key: "prepareMatching",
        value: function value(t, e) {
          var n = [],
              r = [];
          return this.matchers.forEach(function (o) {
            var i = Rr(o, 2),
                u = i[0],
                a = i[1];

            switch (u) {
              case Node.TEXT_NODE:
                r.push(a);
                break;

              case Node.ELEMENT_NODE:
                n.push(a);
                break;

              default:
                Array.from(t.querySelectorAll(u)).forEach(function (t) {
                  e.has(t) ? e.get(t).push(a) : e.set(t, [a]);
                });
            }
          }), [n, r];
        }
      }]) && Pr(e.prototype, n), r && Pr(e, r), i;
    }(ze);

    function Kr(t, e, n) {
      return "object" === Er(e) ? Object.keys(e).reduce(function (t, n) {
        return Kr(t, n, e[n]);
      }, t) : t.reduce(function (t, r) {
        if (r.attributes && r.attributes[e]) return t.push(r);
        var o = n ? Ar({}, e, n) : {};
        return t.insert(r.insert, xr(xr({}, o), r.attributes));
      }, new u.a());
    }

    function Wr(t, e) {
      for (var n = "", r = t.ops.length - 1; r >= 0 && n.length < e.length; --r) {
        var o = t.ops[r];
        if ("string" != typeof o.insert) break;
        n = o.insert + n;
      }

      return n.slice(-1 * e.length) === e;
    }

    function $r(t) {
      return 0 !== t.childNodes.length && -1 !== ["address", "article", "blockquote", "canvas", "dd", "div", "dl", "dt", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "header", "iframe", "li", "main", "nav", "ol", "output", "p", "pre", "section", "table", "td", "tr", "ul", "video"].indexOf(t.tagName.toLowerCase());
    }

    Fr.DEFAULTS = {
      matchers: []
    };
    var Hr = new WeakMap();

    function Vr(t, e, n, r, o) {
      return e.nodeType === e.TEXT_NODE ? r.reduce(function (n, r) {
        return r(e, n, t);
      }, new u.a()) : e.nodeType === e.ELEMENT_NODE ? Array.from(e.childNodes || []).reduce(function (i, u) {
        var a = Vr(t, u, n, r, o);
        return u.nodeType === e.ELEMENT_NODE && (a = n.reduce(function (e, n) {
          return n(u, e, t);
        }, a), a = (o.get(u) || []).reduce(function (e, n) {
          return n(u, e, t);
        }, a)), i.concat(a);
      }, new u.a()) : new u.a();
    }

    function Gr(t, e, n) {
      return Kr(n, t, !0);
    }

    function Xr(t, e, n) {
      if (!Wr(e, "\n")) {
        if ($r(t)) return e.insert("\n");
        if (e.length() > 0 && t.nextSibling) for (var r = t.nextSibling; null != r;) {
          if ($r(r)) return e.insert("\n");
          var o = n.query(r);
          if (o && o.prototype instanceof be) return e.insert("\n");
          r = r.firstChild;
        }
      }

      return e;
    }

    function Yr(t) {
      return (Yr = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function Qr(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    function Zr(t, e) {
      return (Zr = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      })(t, e);
    }

    function Jr(t) {
      var e = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = no(t);

        if (e) {
          var o = no(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return to(this, n);
      };
    }

    function to(t, e) {
      return !e || "object" !== Yr(e) && "function" != typeof e ? eo(t) : e;
    }

    function eo(t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }

    function no(t) {
      return (no = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
    }

    var ro = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && Zr(t, e);
      }(i, t);
      var e,
          n,
          r,
          o = Jr(i);

      function i(t, e) {
        var n;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, i), (n = o.call(this, t, e)).lastRecorded = 0, n.ignoreChange = !1, n.clear(), n.quill.on(tn.events.EDITOR_CHANGE, function (t, e, r, o) {
          t !== tn.events.TEXT_CHANGE || n.ignoreChange || (n.options.userOnly && o !== tn.sources.USER ? n.transform(e) : n.record(e, r));
        }), n.quill.keyboard.addBinding({
          key: "z",
          shortKey: !0
        }, n.undo.bind(eo(n))), n.quill.keyboard.addBinding({
          key: "z",
          shortKey: !0,
          shiftKey: !0
        }, n.redo.bind(eo(n))), /Win/i.test(navigator.platform) && n.quill.keyboard.addBinding({
          key: "y",
          shortKey: !0
        }, n.redo.bind(eo(n))), n.quill.root.addEventListener("beforeinput", function (t) {
          "historyUndo" === t.inputType ? (n.undo(), t.preventDefault()) : "historyRedo" === t.inputType && (n.redo(), t.preventDefault());
        }), n;
      }

      return e = i, (n = [{
        key: "change",
        value: function value(t, e) {
          if (0 !== this.stack[t].length) {
            var n = this.stack[t].pop(),
                r = this.quill.getContents(),
                o = n.invert(r);
            this.stack[e].push(o), this.lastRecorded = 0, this.ignoreChange = !0, this.quill.updateContents(n, tn.sources.USER), this.ignoreChange = !1;

            var i = function (t, e) {
              var n = e.reduce(function (t, e) {
                return t + (e.delete || 0);
              }, 0),
                  r = e.length() - n;
              return function (t, e) {
                var n = e.ops[e.ops.length - 1];
                return null != n && (null != n.insert ? "string" == typeof n.insert && n.insert.endsWith("\n") : null != n.attributes && Object.keys(n.attributes).some(function (e) {
                  return null != t.query(e, h.BLOCK);
                }));
              }(t, e) && (r -= 1), r;
            }(this.quill.scroll, n);

            this.quill.setSelection(i);
          }
        }
      }, {
        key: "clear",
        value: function value() {
          this.stack = {
            undo: [],
            redo: []
          };
        }
      }, {
        key: "cutoff",
        value: function value() {
          this.lastRecorded = 0;
        }
      }, {
        key: "record",
        value: function value(t, e) {
          if (0 !== t.ops.length) {
            this.stack.redo = [];
            var n = t.invert(e),
                r = Date.now();

            if (this.lastRecorded + this.options.delay > r && this.stack.undo.length > 0) {
              var o = this.stack.undo.pop();
              n = n.compose(o);
            } else this.lastRecorded = r;

            0 !== n.length() && (this.stack.undo.push(n), this.stack.undo.length > this.options.maxStack && this.stack.undo.shift());
          }
        }
      }, {
        key: "redo",
        value: function value() {
          this.change("redo", "undo");
        }
      }, {
        key: "transform",
        value: function value(t) {
          oo(this.stack.undo, t), oo(this.stack.redo, t);
        }
      }, {
        key: "undo",
        value: function value() {
          this.change("undo", "redo");
        }
      }]) && Qr(e.prototype, n), r && Qr(e, r), i;
    }(ze);

    function oo(t, e) {
      for (var n = e, r = t.length - 1; r >= 0; r -= 1) {
        var o = t[r];
        t[r] = n.transform(o, !0), n = o.transform(n), 0 === t[r].length() && t.splice(r, 1);
      }
    }

    function io(t) {
      return (io = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function uo(t, e) {
      return function (t) {
        if (Array.isArray(t)) return t;
      }(t) || function (t, e) {
        if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(t))) return;
        var n = [],
            r = !0,
            o = !1,
            i = void 0;

        try {
          for (var u, a = t[Symbol.iterator](); !(r = (u = a.next()).done) && (n.push(u.value), !e || n.length !== e); r = !0) {
            ;
          }
        } catch (t) {
          o = !0, i = t;
        } finally {
          try {
            r || null == a.return || a.return();
          } finally {
            if (o) throw i;
          }
        }

        return n;
      }(t, e) || function (t, e) {
        if (!t) return;
        if ("string" == typeof t) return ao(t, e);
        var n = Object.prototype.toString.call(t).slice(8, -1);
        "Object" === n && t.constructor && (n = t.constructor.name);
        if ("Map" === n || "Set" === n) return Array.from(t);
        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ao(t, e);
      }(t, e) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function ao(t, e) {
      (null == e || e > t.length) && (e = t.length);

      for (var n = 0, r = new Array(e); n < e; n++) {
        r[n] = t[n];
      }

      return r;
    }

    function co(t, e) {
      var n = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }

      return n;
    }

    function lo(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? co(Object(n), !0).forEach(function (e) {
          so(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : co(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }

      return t;
    }

    function so(t, e, n) {
      return e in t ? Object.defineProperty(t, e, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = n, t;
    }

    function fo(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    function ho(t, e, n) {
      return e && fo(t.prototype, e), n && fo(t, n), t;
    }

    function po(t, e) {
      return (po = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      })(t, e);
    }

    function yo(t) {
      var e = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = bo(t);

        if (e) {
          var o = bo(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return vo(this, n);
      };
    }

    function vo(t, e) {
      return !e || "object" !== io(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }(t) : e;
    }

    function bo(t) {
      return (bo = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
    }

    ro.DEFAULTS = {
      delay: 1e3,
      maxStack: 100,
      userOnly: !1
    };

    var mo = J("quill:keyboard"),
        go = {
      backspace: "backspace",
      tab: "tab",
      enter: "enter",
      escape: "escape",
      pageup: "pageUp",
      pagedown: "pageDown",
      end: "end",
      home: "home",
      arrowleft: "leftArrow",
      arrowup: "upArrow",
      arrowright: "rightArrow",
      arrowdown: "downArrow",
      delete: "del",
      " ": "space",
      "*": "asterisk",
      "-": "minus",
      alt: "alt",
      control: "control",
      shift: "shift",
      left: "leftArrow",
      up: "upArrow",
      right: "rightArrow",
      down: "downArrow",
      multiply: "asterisk",
      spacebar: "space",
      del: "del",
      subtract: "minus",
      esc: "escape"
    },
        Oo = {
      8: "backspace",
      9: "tab",
      13: "enter",
      27: "escape",
      33: "pageUp",
      34: "pageDown",
      35: "end",
      36: "home",
      37: "leftArrow",
      38: "upArrow",
      39: "rightArrow",
      40: "downArrow",
      46: "del",
      32: "space",
      106: "asterisk",
      109: "minus",
      189: "minus",
      173: "minus",
      16: "shift",
      17: "control",
      18: "alt"
    },
        wo = /Mac/i.test(navigator.platform) ? "metaKey" : "ctrlKey",
        _o = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && po(t, e);
      }(n, t);
      var e = yo(n);

      function n(t, r) {
        var o;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, n), (o = e.call(this, t, r)).bindings = {}, Object.keys(o.options.bindings).forEach(function (t) {
          o.options.bindings[t] && o.addBinding(o.options.bindings[t]);
        }), o.addBinding({
          key: "enter",
          shiftKey: null
        }, o.handleEnter), o.addBinding({
          key: "enter",
          metaKey: null,
          ctrlKey: null,
          altKey: null
        }, function () {}), /Firefox/i.test(navigator.userAgent) ? (o.addBinding({
          key: "backspace"
        }, {
          collapsed: !0
        }, o.handleBackspace), o.addBinding({
          key: "del"
        }, {
          collapsed: !0
        }, o.handleDelete)) : (o.addBinding({
          key: "backspace"
        }, {
          collapsed: !0,
          prefix: /^.?$/
        }, o.handleBackspace), o.addBinding({
          key: "del"
        }, {
          collapsed: !0,
          suffix: /^.?$/
        }, o.handleDelete)), o.addBinding({
          key: "backspace"
        }, {
          collapsed: !1
        }, o.handleDeleteRange), o.addBinding({
          key: "del"
        }, {
          collapsed: !1
        }, o.handleDeleteRange), o.addBinding({
          key: "backspace",
          altKey: null,
          ctrlKey: null,
          metaKey: null,
          shiftKey: null
        }, {
          collapsed: !0,
          offset: 0
        }, o.handleBackspace), o.listen(), o;
      }

      return ho(n, null, [{
        key: "match",
        value: function value(t, e) {
          return !["altKey", "ctrlKey", "metaKey", "shiftKey"].some(function (n) {
            return !!e[n] !== t[n] && null !== e[n];
          }) && (e.key === n.normalizeKeyName(t) || e.key === t.which);
        }
      }, {
        key: "normalizeKeyName",
        value: function value(t) {
          var e = t.key,
              n = t.which,
              r = !!e;
          return (e = r ? e : n) && (e = r ? go[e.toLowerCase()] || e : Oo[e] || String.fromCharCode(e)), e;
        }
      }]), ho(n, [{
        key: "addBinding",
        value: function value(t) {
          var e = this,
              n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              o = xo(t);

          if (null != o) {
            "function" == typeof n && (n = {
              handler: n
            }), "function" == typeof r && (r = {
              handler: r
            });
            var i = Array.isArray(o.key) ? o.key : [o.key];
            i.forEach(function (t) {
              var i = lo(lo(lo({}, o), {}, {
                key: t
              }, n), r);
              e.bindings[i.key] = e.bindings[i.key] || [], e.bindings[i.key].push(i);
            });
          } else mo.warn("Attempted to add invalid keyboard binding", o);
        }
      }, {
        key: "listen",
        value: function value() {
          var t = this;
          this.quill.root.addEventListener("keydown", function (e) {
            if (!e.defaultPrevented && !e.isComposing) {
              var r = n.normalizeKeyName(e),
                  o = (t.bindings[r] || []).concat(t.bindings[e.which] || []).filter(function (t) {
                return n.match(e, t);
              });

              if (0 !== o.length) {
                var i = t.quill.getSelection();

                if (null != i && t.quill.hasFocus()) {
                  var u = uo(t.quill.getLine(i.index), 2),
                      a = u[0],
                      c = u[1],
                      l = uo(t.quill.getLeaf(i.index), 2),
                      s = l[0],
                      f = l[1],
                      h = uo(0 === i.length ? [s, f] : t.quill.getLeaf(i.index + i.length), 2),
                      p = h[0],
                      y = h[1],
                      d = s instanceof K ? s.value().slice(0, f) : "",
                      v = p instanceof K ? p.value().slice(y) : "",
                      b = {
                    collapsed: 0 === i.length,
                    empty: 0 === i.length && a.length() <= 1,
                    format: t.quill.getFormat(i),
                    line: a,
                    offset: c,
                    prefix: d,
                    suffix: v,
                    event: e
                  };
                  o.some(function (e) {
                    if (null != e.collapsed && e.collapsed !== b.collapsed) return !1;
                    if (null != e.empty && e.empty !== b.empty) return !1;
                    if (null != e.offset && e.offset !== b.offset) return !1;

                    if (Array.isArray(e.format)) {
                      if (e.format.every(function (t) {
                        return null == b.format[t];
                      })) return !1;
                    } else if ("object" === io(e.format) && !Object.keys(e.format).every(function (t) {
                      return !0 === e.format[t] ? null != b.format[t] : !1 === e.format[t] ? null == b.format[t] : $()(e.format[t], b.format[t]);
                    })) return !1;

                    return !(null != e.prefix && !e.prefix.test(b.prefix)) && !(null != e.suffix && !e.suffix.test(b.suffix)) && !0 !== e.handler.call(t, i, b, e);
                  }) && e.preventDefault();
                }
              }
            }
          });
        }
      }, {
        key: "handleBackspace",
        value: function value(t, e) {
          var n = /[\uD800-\uDBFF][\uDC00-\uDFFF]$/.test(e.prefix) ? 2 : 1;

          if (!(0 === t.index || this.quill.getLength() <= 1)) {
            var r = {},
                o = uo(this.quill.getLine(t.index), 1)[0],
                a = new u.a().retain(t.index - n).delete(n);

            if (0 === e.offset) {
              var c = uo(this.quill.getLine(t.index - 1), 1)[0];
              if (c) if (!("block" === c.statics.blotName && c.length() <= 1)) {
                var l = o.formats(),
                    s = this.quill.getFormat(t.index - 1, 1);

                if (r = i.AttributeMap.diff(l, s) || {}, Object.keys(r).length > 0) {
                  var f = new u.a().retain(t.index + o.length() - 2).retain(1, r);
                  a = a.compose(f);
                }
              }
            }

            this.quill.updateContents(a, tn.sources.USER), this.quill.focus();
          }
        }
      }, {
        key: "handleDelete",
        value: function value(t, e) {
          var n = /^[\uD800-\uDBFF][\uDC00-\uDFFF]/.test(e.suffix) ? 2 : 1;

          if (!(t.index >= this.quill.getLength() - n)) {
            var r = {},
                o = uo(this.quill.getLine(t.index), 1)[0],
                a = new u.a().retain(t.index).delete(n);

            if (e.offset >= o.length() - 1) {
              var c = uo(this.quill.getLine(t.index + 1), 1)[0];

              if (c) {
                var l = o.formats(),
                    s = this.quill.getFormat(t.index, 1);
                r = i.AttributeMap.diff(l, s) || {}, Object.keys(r).length > 0 && (a = a.retain(c.length() - 1).retain(1, r));
              }
            }

            this.quill.updateContents(a, tn.sources.USER), this.quill.focus();
          }
        }
      }, {
        key: "handleDeleteRange",
        value: function value(t) {
          var e = this.quill.getLines(t),
              n = {};

          if (e.length > 1) {
            var r = e[0].formats(),
                o = e[e.length - 1].formats();
            n = i.AttributeMap.diff(o, r) || {};
          }

          this.quill.deleteText(t, tn.sources.USER), Object.keys(n).length > 0 && this.quill.formatLine(t.index, 1, n, tn.sources.USER), this.quill.setSelection(t.index, tn.sources.SILENT), this.quill.focus();
        }
      }, {
        key: "handleEnter",
        value: function value(t, e) {
          var n = this,
              r = Object.keys(e.format).reduce(function (t, r) {
            return n.quill.scroll.query(r, h.BLOCK) && !Array.isArray(e.format[r]) && (t[r] = e.format[r]), t;
          }, {}),
              o = new u.a().retain(t.index).delete(t.length).insert("\n", r);
          this.quill.updateContents(o, tn.sources.USER), this.quill.setSelection(t.index + 1, tn.sources.SILENT), this.quill.focus(), Object.keys(e.format).forEach(function (t) {
            null == r[t] && (Array.isArray(e.format[t]) || "code" !== t && "link" !== t && n.quill.format(t, e.format[t], tn.sources.USER));
          });
        }
      }]), n;
    }(ze);

    function jo(t) {
      return {
        key: "tab",
        shiftKey: !t,
        format: {
          "code-block": !0
        },
        handler: function handler(e) {
          var n = this.quill.scroll.query("code-block"),
              r = 0 === e.length ? this.quill.getLines(e.index, 1) : this.quill.getLines(e),
              o = e.index,
              i = e.length;
          r.forEach(function (e, r) {
            t ? (e.insertAt(0, n.TAB), 0 === r ? o += n.TAB.length : i += n.TAB.length) : 0 === e.domNode.textContent.indexOf(n.TAB) && (e.deleteAt(0, n.TAB.length), 0 === r ? o -= n.TAB.length : i -= n.TAB.length);
          }), this.quill.update(tn.sources.USER), this.quill.setSelection(o, i, tn.sources.SILENT);
        }
      };
    }

    function No(t, e) {
      var n;
      return so(n = {
        key: t,
        shiftKey: e,
        altKey: null
      }, "leftArrow" === t ? "prefix" : "suffix", /^$/), so(n, "handler", function (n) {
        var r = n.index;
        return "rightArrow" === t && (r += n.length + 1), !(uo(this.quill.getLeaf(r), 1)[0] instanceof B) || ("ArrowLeft" === t ? e ? this.quill.setSelection(n.index - 1, n.length + 1, tn.sources.USER) : this.quill.setSelection(n.index - 1, tn.sources.USER) : e ? this.quill.setSelection(n.index, n.length + 1, tn.sources.USER) : this.quill.setSelection(n.index + n.length + 1, tn.sources.USER), !1);
      }), n;
    }

    function ko(t) {
      return {
        key: t[0],
        shortKey: !0,
        handler: function handler(e, n) {
          this.quill.format(t, !n.format[t], tn.sources.USER);
        }
      };
    }

    function So(t) {
      return {
        key: t ? "upArrow" : "downArrow",
        collapsed: !0,
        format: ["table"],
        handler: function handler(e, n) {
          var r = t ? "prev" : "next",
              o = n.line,
              i = o.parent[r];

          if (null != i) {
            if ("table-row" === i.statics.blotName) {
              for (var u = i.children.head, a = o; null != a.prev;) {
                a = a.prev, u = u.next;
              }

              var c = u.offset(this.quill.scroll) + Math.min(n.offset, u.length() - 1);
              this.quill.setSelection(c, 0, tn.sources.USER);
            }
          } else {
            var l = o.table()[r];
            null != l && (t ? this.quill.setSelection(l.offset(this.quill.scroll) + l.length() - 1, 0, tn.sources.USER) : this.quill.setSelection(l.offset(this.quill.scroll), 0, tn.sources.USER));
          }

          return !1;
        }
      };
    }

    function xo(t) {
      if ("string" == typeof t || "number" == typeof t) t = {
        key: t
      };else {
        if ("object" !== io(t)) return null;
        t = c()(t);
      }
      return t.shortKey && (t[wo] = t.shortKey, delete t.shortKey), t;
    }

    function Eo(t) {
      return (Eo = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function Ao(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    function Ro(t, e) {
      return (Ro = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      })(t, e);
    }

    function To(t) {
      var e = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = Co(t);

        if (e) {
          var o = Co(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return Po(this, n);
      };
    }

    function Po(t, e) {
      return !e || "object" !== Eo(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }(t) : e;
    }

    function Co(t) {
      return (Co = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
    }

    _o.DEFAULTS = {
      bindings: {
        bold: ko("bold"),
        italic: ko("italic"),
        underline: ko("underline"),
        indent: {
          key: "tab",
          format: ["blockquote", "indent", "list"],
          handler: function handler(t, e) {
            return !(!e.collapsed || 0 === e.offset) || (this.quill.format("indent", "+1", tn.sources.USER), !1);
          }
        },
        outdent: {
          key: "tab",
          shiftKey: !0,
          format: ["blockquote", "indent", "list"],
          handler: function handler(t, e) {
            return !(!e.collapsed || 0 === e.offset) || (this.quill.format("indent", "-1", tn.sources.USER), !1);
          }
        },
        "outdent backspace": {
          key: "backspace",
          collapsed: !0,
          shiftKey: null,
          metaKey: null,
          ctrlKey: null,
          altKey: null,
          format: ["indent", "list"],
          offset: 0,
          handler: function handler(t, e) {
            null != e.format.indent ? this.quill.format("indent", "-1", tn.sources.USER) : null != e.format.list && this.quill.format("list", !1, tn.sources.USER);
          }
        },
        "indent code-block": jo(!0),
        "outdent code-block": jo(!1),
        "remove tab": {
          key: "tab",
          shiftKey: !0,
          collapsed: !0,
          prefix: /\t$/,
          handler: function handler(t) {
            this.quill.deleteText(t.index - 1, 1, tn.sources.USER);
          }
        },
        tab: {
          key: "tab",
          handler: function handler(t, e) {
            if (e.format.table) return !0;
            this.quill.history.cutoff();
            var n = new u.a().retain(t.index).delete(t.length).insert("\t");
            return this.quill.updateContents(n, tn.sources.USER), this.quill.history.cutoff(), this.quill.setSelection(t.index + 1, tn.sources.SILENT), !1;
          }
        },
        "blockquote empty enter": {
          key: "enter",
          collapsed: !0,
          format: ["blockquote"],
          empty: !0,
          handler: function handler() {
            this.quill.format("blockquote", !1, tn.sources.USER);
          }
        },
        "list empty enter": {
          key: "enter",
          collapsed: !0,
          format: ["list"],
          empty: !0,
          handler: function handler(t, e) {
            var n = {
              list: !1
            };
            e.format.indent && (n.indent = !1), this.quill.formatLine(t.index, t.length, n, tn.sources.USER);
          }
        },
        "checklist enter": {
          key: "enter",
          collapsed: !0,
          format: {
            list: "checked"
          },
          handler: function handler(t) {
            var e = uo(this.quill.getLine(t.index), 2),
                n = e[0],
                r = e[1],
                o = lo(lo({}, n.formats()), {}, {
              list: "checked"
            }),
                i = new u.a().retain(t.index).insert("\n", o).retain(n.length() - r - 1).retain(1, {
              list: "unchecked"
            });
            this.quill.updateContents(i, tn.sources.USER), this.quill.setSelection(t.index + 1, tn.sources.SILENT), this.quill.scrollIntoView();
          }
        },
        "header enter": {
          key: "enter",
          collapsed: !0,
          format: ["header"],
          suffix: /^$/,
          handler: function handler(t, e) {
            var n = uo(this.quill.getLine(t.index), 2),
                r = n[0],
                o = n[1],
                i = new u.a().retain(t.index).insert("\n", e.format).retain(r.length() - o - 1).retain(1, {
              header: null
            });
            this.quill.updateContents(i, tn.sources.USER), this.quill.setSelection(t.index + 1, tn.sources.SILENT), this.quill.scrollIntoView();
          }
        },
        "table backspace": {
          key: "backspace",
          format: ["table"],
          collapsed: !0,
          offset: 0,
          handler: function handler() {}
        },
        "table delete": {
          key: "del",
          format: ["table"],
          collapsed: !0,
          suffix: /^$/,
          handler: function handler() {}
        },
        "table enter": {
          key: "enter",
          shiftKey: null,
          format: ["table"],
          handler: function handler(t) {
            var e = this.quill.getModule("table");

            if (e) {
              var n = uo(e.getTable(t), 4),
                  r = n[0],
                  o = function (t, e, n, r) {
                if (null == e.prev && null == e.next) return null == n.prev && null == n.next ? 0 === r ? -1 : 1 : null == n.prev ? -1 : 1;
                if (null == e.prev) return -1;
                if (null == e.next) return 1;
                return null;
              }(0, n[1], n[2], n[3]);

              if (null == o) return;
              var i = r.offset();

              if (o < 0) {
                var a = new u.a().retain(i).insert("\n");
                this.quill.updateContents(a, tn.sources.USER), this.quill.setSelection(t.index + 1, t.length, tn.sources.SILENT);
              } else if (o > 0) {
                i += r.length();
                var c = new u.a().retain(i).insert("\n");
                this.quill.updateContents(c, tn.sources.USER), this.quill.setSelection(i, tn.sources.USER);
              }
            }
          }
        },
        "table tab": {
          key: "tab",
          shiftKey: null,
          format: ["table"],
          handler: function handler(t, e) {
            var n = e.event,
                r = e.line,
                o = r.offset(this.quill.scroll);
            n.shiftKey ? this.quill.setSelection(o - 1, tn.sources.USER) : this.quill.setSelection(o + r.length(), tn.sources.USER);
          }
        },
        "list autofill": {
          key: "space",
          shiftKey: null,
          collapsed: !0,
          format: {
            list: !1,
            "code-block": !1,
            blockquote: !1,
            header: !1,
            table: !1
          },
          prefix: /^\s*?(\d+\.|-|\*|\[ ?\]|\[x\])$/,
          handler: function handler(t, e) {
            if (null == this.quill.scroll.query("list")) return !0;
            var n,
                r = e.prefix.length,
                o = uo(this.quill.getLine(t.index), 2),
                i = o[0],
                a = o[1];
            if (a > r) return !0;

            switch (e.prefix.trim()) {
              case "[]":
              case "[ ]":
                n = "unchecked";
                break;

              case "[x]":
                n = "checked";
                break;

              case "-":
              case "*":
                n = "bullet";
                break;

              default:
                n = "ordered";
            }

            this.quill.insertText(t.index, " ", tn.sources.USER), this.quill.history.cutoff();
            var c = new u.a().retain(t.index - a).delete(r + 1).retain(i.length() - 2 - a).retain(1, {
              list: n
            });
            return this.quill.updateContents(c, tn.sources.USER), this.quill.history.cutoff(), this.quill.setSelection(t.index - r, tn.sources.SILENT), !1;
          }
        },
        "code exit": {
          key: "enter",
          collapsed: !0,
          format: ["code-block"],
          prefix: /^$/,
          suffix: /^\s*$/,
          handler: function handler(t) {
            for (var e = uo(this.quill.getLine(t.index), 2), n = e[0], r = e[1], o = 2, i = n; null != i && i.length() <= 1 && i.formats()["code-block"];) {
              if (i = i.prev, (o -= 1) <= 0) {
                var a = new u.a().retain(t.index + n.length() - r - 2).retain(1, {
                  "code-block": null
                }).delete(1);
                return this.quill.updateContents(a, tn.sources.USER), this.quill.setSelection(t.index - 1, tn.sources.SILENT), !1;
              }
            }

            return !0;
          }
        },
        "embed left": No("ArrowLeft", !1),
        "embed left shift": No("ArrowLeft", !0),
        "embed right": No("ArrowRight", !1),
        "embed right shift": No("ArrowRight", !0),
        "table down": So(!1),
        "table up": So(!0)
      }
    };

    var Lo = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && Ro(t, e);
      }(i, t);
      var e,
          n,
          r,
          o = To(i);

      function i(t, e) {
        var n;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, i), (n = o.call(this, t, e)).addDragOverHandler(), n.addDropHandler(), n;
      }

      return e = i, (n = [{
        key: "addDragOverHandler",
        value: function value() {
          var t = window.navigator.userAgent.toLowerCase();
          (-1 !== t.indexOf("msie ") || -1 !== t.indexOf("trident/") || -1 !== t.indexOf("edge/")) && this.quill.root.addEventListener("dragover", function (t) {
            t.preventDefault();
          });
        }
      }, {
        key: "addDropHandler",
        value: function value() {
          var t = this;
          this.quill.root.addEventListener("drop", function (e) {
            var n;
            e.preventDefault();
            var r = t.options.onDrop;
            if (r && "function" == typeof r && r(e), document.caretRangeFromPoint) n = document.caretRangeFromPoint(e.clientX, e.clientY);else {
              if (!document.caretPositionFromPoint) return;
              var o = document.caretPositionFromPoint(e.clientX, e.clientY);
              (n = document.createRange()).setStart(o.offsetNode, o.offset), n.setEnd(o.offsetNode, o.offset);
            }
            var i = t.quill.selection.normalizeNative(n),
                u = t.quill.selection.normalizedToRange(i);
            t.upload(u, e.dataTransfer.files);
          });
        }
      }, {
        key: "upload",
        value: function value(t, e) {
          var n = this,
              r = [];
          Array.from(e).forEach(function (t) {
            t && -1 !== n.options.mimetypes.indexOf(t.type) && r.push(t);
          }), r.length > 0 && this.options.handler.call(this, t, r, this.options.imageBlot);
        }
      }]) && Ao(e.prototype, n), r && Ao(e, r), i;
    }(ze);

    Lo.DEFAULTS = {
      mimetypes: ["image/png", "image/jpeg"],
      imageBlot: "image",
      handler: function handler(t, e, n) {
        var r = this,
            o = e.map(function (t) {
          return new Promise(function (e) {
            var n = new FileReader();
            n.onload = function (t) {
              e(t.target.result);
            }, n.readAsDataURL(t);
          });
        });
        Promise.all(o).then(function (e) {
          var o = e.reduce(function (t, e) {
            return t.insert((i = e, (o = n) in (r = {}) ? Object.defineProperty(r, o, {
              value: i,
              enumerable: !0,
              configurable: !0,
              writable: !0
            }) : r[o] = i, r));
            var r, o, i;
          }, new u.a().retain(t.index).delete(t.length));
          r.quill.updateContents(o, lt.sources.USER), r.quill.setSelection(t.index + e.length, lt.sources.SILENT);
        });
      }
    };
    var Do = Lo;
    tn.register({
      "blots/block": ve,
      "blots/block/embed": be,
      "blots/break": Ht,
      "blots/container": hn,
      "blots/cursor": It,
      "blots/embed": On,
      "blots/inline": ne,
      "blots/scroll": Pn,
      "blots/text": St,
      "modules/clipboard": Fr,
      "modules/history": ro,
      "modules/keyboard": _o,
      "modules/uploader": Do
    });
    var qo = tn;

    function Io(t) {
      return (Io = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function Bo(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }

    function Mo(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    function Uo(t, e, n) {
      return (Uo = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, n) {
        var r = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = Wo(t));) {
            ;
          }

          return t;
        }(t, e);

        if (r) {
          var o = Object.getOwnPropertyDescriptor(r, e);
          return o.get ? o.get.call(n) : o.value;
        }
      })(t, e, n || t);
    }

    function zo(t, e) {
      return (zo = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      })(t, e);
    }

    function Fo(t) {
      var e = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = Wo(t);

        if (e) {
          var o = Wo(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return Ko(this, n);
      };
    }

    function Ko(t, e) {
      return !e || "object" !== Io(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }(t) : e;
    }

    function Wo(t) {
      return (Wo = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
    }

    var $o = new (function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && zo(t, e);
      }(i, t);
      var e,
          n,
          r,
          o = Fo(i);

      function i() {
        return Bo(this, i), o.apply(this, arguments);
      }

      return e = i, (n = [{
        key: "add",
        value: function value(t, e) {
          if ("+1" === e || "-1" === e) {
            var n = this.value(t) || 0;
            e = "+1" === e ? n + 1 : n - 1;
          }

          return 0 === e ? (this.remove(t), !0) : Uo(Wo(i.prototype), "add", this).call(this, t, e);
        }
      }, {
        key: "canAdd",
        value: function value(t, e) {
          return Uo(Wo(i.prototype), "canAdd", this).call(this, t, e) || Uo(Wo(i.prototype), "canAdd", this).call(this, t, parseInt(e, 10));
        }
      }, {
        key: "value",
        value: function value(t) {
          return parseInt(Uo(Wo(i.prototype), "value", this).call(this, t), 10) || void 0;
        }
      }]) && Mo(e.prototype, n), r && Mo(e, r), i;
    }(E))("indent", "ql-indent", {
      scope: h.BLOCK,
      whitelist: [1, 2, 3, 4, 5, 6, 7, 8]
    });

    function Ho(t) {
      return (Ho = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function Vo(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }

    function Go(t, e) {
      return (Go = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      })(t, e);
    }

    function Xo(t) {
      var e = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = Qo(t);

        if (e) {
          var o = Qo(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return Yo(this, n);
      };
    }

    function Yo(t, e) {
      return !e || "object" !== Ho(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }(t) : e;
    }

    function Qo(t) {
      return (Qo = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
    }

    var Zo = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && Go(t, e);
      }(n, t);
      var e = Xo(n);

      function n() {
        return Vo(this, n), e.apply(this, arguments);
      }

      return n;
    }(ve);

    Zo.blotName = "blockquote", Zo.tagName = "blockquote";
    var Jo = Zo;

    function ti(t) {
      return (ti = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function ei(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }

    function ni(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    function ri(t, e) {
      return (ri = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      })(t, e);
    }

    function oi(t) {
      var e = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = ui(t);

        if (e) {
          var o = ui(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return ii(this, n);
      };
    }

    function ii(t, e) {
      return !e || "object" !== ti(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }(t) : e;
    }

    function ui(t) {
      return (ui = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
    }

    var ai = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && ri(t, e);
      }(i, t);
      var e,
          n,
          r,
          o = oi(i);

      function i() {
        return ei(this, i), o.apply(this, arguments);
      }

      return e = i, r = [{
        key: "formats",
        value: function value(t) {
          return this.tagName.indexOf(t.tagName) + 1;
        }
      }], (n = null) && ni(e.prototype, n), r && ni(e, r), i;
    }(ve);

    ai.blotName = "header", ai.tagName = ["H1", "H2", "H3", "H4", "H5", "H6"];
    var ci = ai;

    function li(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    function si(t, e, n) {
      return e && li(t.prototype, e), n && li(t, n), t;
    }

    function fi(t, e, n) {
      return (fi = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, n) {
        var r = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = mi(t));) {
            ;
          }

          return t;
        }(t, e);

        if (r) {
          var o = Object.getOwnPropertyDescriptor(r, e);
          return o.get ? o.get.call(n) : o.value;
        }
      })(t, e, n || t);
    }

    function hi(t) {
      return (hi = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function pi(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }

    function yi(t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          writable: !0,
          configurable: !0
        }
      }), e && di(t, e);
    }

    function di(t, e) {
      return (di = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      })(t, e);
    }

    function vi(t) {
      var e = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = mi(t);

        if (e) {
          var o = mi(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return bi(this, n);
      };
    }

    function bi(t, e) {
      return !e || "object" !== hi(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }(t) : e;
    }

    function mi(t) {
      return (mi = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
    }

    var gi = function (t) {
      yi(n, t);
      var e = vi(n);

      function n() {
        return pi(this, n), e.apply(this, arguments);
      }

      return n;
    }(hn);

    gi.blotName = "list-container", gi.tagName = "OL";

    var Oi = function (t) {
      yi(n, t);
      var e = vi(n);

      function n(t, r) {
        var o;
        pi(this, n), o = e.call(this, t, r);

        var i = r.ownerDocument.createElement("span"),
            u = function u(e) {
          if (t.isEnabled()) {
            var n = o.statics.formats(r, t);
            "checked" === n ? (o.format("list", "unchecked"), e.preventDefault()) : "unchecked" === n && (o.format("list", "checked"), e.preventDefault());
          }
        };

        return i.addEventListener("mousedown", u), i.addEventListener("touchstart", u), o.attachUI(i), o;
      }

      return si(n, null, [{
        key: "create",
        value: function value(t) {
          var e = fi(mi(n), "create", this).call(this);
          return e.setAttribute("data-list", t), e;
        }
      }, {
        key: "formats",
        value: function value(t) {
          return t.getAttribute("data-list") || void 0;
        }
      }, {
        key: "register",
        value: function value() {
          tn.register(gi);
        }
      }]), si(n, [{
        key: "format",
        value: function value(t, e) {
          t === this.statics.blotName && e ? this.domNode.setAttribute("data-list", e) : fi(mi(n.prototype), "format", this).call(this, t, e);
        }
      }]), n;
    }(ve);

    function wi(t) {
      return (wi = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function _i(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }

    function ji(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    function Ni(t, e, n) {
      return (Ni = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, n) {
        var r = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = Ei(t));) {
            ;
          }

          return t;
        }(t, e);

        if (r) {
          var o = Object.getOwnPropertyDescriptor(r, e);
          return o.get ? o.get.call(n) : o.value;
        }
      })(t, e, n || t);
    }

    function ki(t, e) {
      return (ki = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      })(t, e);
    }

    function Si(t) {
      var e = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = Ei(t);

        if (e) {
          var o = Ei(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return xi(this, n);
      };
    }

    function xi(t, e) {
      return !e || "object" !== wi(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }(t) : e;
    }

    function Ei(t) {
      return (Ei = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
    }

    Oi.blotName = "list", Oi.tagName = "LI", gi.allowedChildren = [Oi], Oi.requiredContainer = gi;

    var Ai = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && ki(t, e);
      }(i, t);
      var e,
          n,
          r,
          o = Si(i);

      function i() {
        return _i(this, i), o.apply(this, arguments);
      }

      return e = i, r = [{
        key: "create",
        value: function value() {
          return Ni(Ei(i), "create", this).call(this);
        }
      }, {
        key: "formats",
        value: function value() {
          return !0;
        }
      }], (n = [{
        key: "optimize",
        value: function value(t) {
          Ni(Ei(i.prototype), "optimize", this).call(this, t), this.domNode.tagName !== this.statics.tagName[0] && this.replaceWith(this.statics.blotName);
        }
      }]) && ji(e.prototype, n), r && ji(e, r), i;
    }(ne);

    Ai.blotName = "bold", Ai.tagName = ["STRONG", "B"];
    var Ri = Ai;

    function Ti(t) {
      return (Ti = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function Pi(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }

    function Ci(t, e) {
      return (Ci = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      })(t, e);
    }

    function Li(t) {
      var e = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = qi(t);

        if (e) {
          var o = qi(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return Di(this, n);
      };
    }

    function Di(t, e) {
      return !e || "object" !== Ti(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }(t) : e;
    }

    function qi(t) {
      return (qi = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
    }

    var Ii = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && Ci(t, e);
      }(n, t);
      var e = Li(n);

      function n() {
        return Pi(this, n), e.apply(this, arguments);
      }

      return n;
    }(Ri);

    Ii.blotName = "italic", Ii.tagName = ["EM", "I"];
    var Bi = Ii;

    function Mi(t) {
      return (Mi = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function Ui(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }

    function zi(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    function Fi(t, e, n) {
      return (Fi = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, n) {
        var r = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = Hi(t));) {
            ;
          }

          return t;
        }(t, e);

        if (r) {
          var o = Object.getOwnPropertyDescriptor(r, e);
          return o.get ? o.get.call(n) : o.value;
        }
      })(t, e, n || t);
    }

    function Ki(t, e) {
      return (Ki = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      })(t, e);
    }

    function Wi(t) {
      var e = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = Hi(t);

        if (e) {
          var o = Hi(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return $i(this, n);
      };
    }

    function $i(t, e) {
      return !e || "object" !== Mi(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }(t) : e;
    }

    function Hi(t) {
      return (Hi = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
    }

    var Vi = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && Ki(t, e);
      }(i, t);
      var e,
          n,
          r,
          o = Wi(i);

      function i() {
        return Ui(this, i), o.apply(this, arguments);
      }

      return e = i, r = [{
        key: "create",
        value: function value(t) {
          var e = Fi(Hi(i), "create", this).call(this, t);
          return e.setAttribute("href", this.sanitize(t)), e.setAttribute("rel", "noopener noreferrer"), e.setAttribute("target", "_blank"), e;
        }
      }, {
        key: "formats",
        value: function value(t) {
          return t.getAttribute("href");
        }
      }, {
        key: "sanitize",
        value: function value(t) {
          return Gi(t, this.PROTOCOL_WHITELIST) ? t : this.SANITIZED_URL;
        }
      }], (n = [{
        key: "format",
        value: function value(t, e) {
          t === this.statics.blotName && e ? this.domNode.setAttribute("href", this.constructor.sanitize(e)) : Fi(Hi(i.prototype), "format", this).call(this, t, e);
        }
      }]) && zi(e.prototype, n), r && zi(e, r), i;
    }(ne);

    function Gi(t, e) {
      var n = document.createElement("a");
      n.href = t;
      var r = n.href.slice(0, n.href.indexOf(":"));
      return e.indexOf(r) > -1;
    }

    function Xi(t) {
      return (Xi = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function Yi(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }

    function Qi(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    function Zi(t, e, n) {
      return (Zi = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, n) {
        var r = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = nu(t));) {
            ;
          }

          return t;
        }(t, e);

        if (r) {
          var o = Object.getOwnPropertyDescriptor(r, e);
          return o.get ? o.get.call(n) : o.value;
        }
      })(t, e, n || t);
    }

    function Ji(t, e) {
      return (Ji = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      })(t, e);
    }

    function tu(t) {
      var e = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = nu(t);

        if (e) {
          var o = nu(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return eu(this, n);
      };
    }

    function eu(t, e) {
      return !e || "object" !== Xi(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }(t) : e;
    }

    function nu(t) {
      return (nu = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
    }

    Vi.blotName = "link", Vi.tagName = "A", Vi.SANITIZED_URL = "about:blank", Vi.PROTOCOL_WHITELIST = ["http", "https", "mailto", "tel"];

    var ru = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && Ji(t, e);
      }(i, t);
      var e,
          n,
          r,
          o = tu(i);

      function i() {
        return Yi(this, i), o.apply(this, arguments);
      }

      return e = i, r = [{
        key: "create",
        value: function value(t) {
          return "super" === t ? document.createElement("sup") : "sub" === t ? document.createElement("sub") : Zi(nu(i), "create", this).call(this, t);
        }
      }, {
        key: "formats",
        value: function value(t) {
          return "SUB" === t.tagName ? "sub" : "SUP" === t.tagName ? "super" : void 0;
        }
      }], (n = null) && Qi(e.prototype, n), r && Qi(e, r), i;
    }(ne);

    ru.blotName = "script", ru.tagName = ["SUB", "SUP"];
    var ou = ru;

    function iu(t) {
      return (iu = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function uu(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }

    function au(t, e) {
      return (au = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      })(t, e);
    }

    function cu(t) {
      var e = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = su(t);

        if (e) {
          var o = su(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return lu(this, n);
      };
    }

    function lu(t, e) {
      return !e || "object" !== iu(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }(t) : e;
    }

    function su(t) {
      return (su = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
    }

    var fu = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && au(t, e);
      }(n, t);
      var e = cu(n);

      function n() {
        return uu(this, n), e.apply(this, arguments);
      }

      return n;
    }(Ri);

    fu.blotName = "strike", fu.tagName = ["S", "STRIKE"];
    var hu = fu;

    function pu(t) {
      return (pu = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function yu(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }

    function du(t, e) {
      return (du = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      })(t, e);
    }

    function vu(t) {
      var e = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = mu(t);

        if (e) {
          var o = mu(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return bu(this, n);
      };
    }

    function bu(t, e) {
      return !e || "object" !== pu(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }(t) : e;
    }

    function mu(t) {
      return (mu = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
    }

    var gu = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && du(t, e);
      }(n, t);
      var e = vu(n);

      function n() {
        return yu(this, n), e.apply(this, arguments);
      }

      return n;
    }(ne);

    gu.blotName = "underline", gu.tagName = "U";
    var Ou = gu;

    function wu(t) {
      return (wu = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function _u(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }

    function ju(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    function Nu(t, e, n) {
      return (Nu = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, n) {
        var r = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = Eu(t));) {
            ;
          }

          return t;
        }(t, e);

        if (r) {
          var o = Object.getOwnPropertyDescriptor(r, e);
          return o.get ? o.get.call(n) : o.value;
        }
      })(t, e, n || t);
    }

    function ku(t, e) {
      return (ku = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      })(t, e);
    }

    function Su(t) {
      var e = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = Eu(t);

        if (e) {
          var o = Eu(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return xu(this, n);
      };
    }

    function xu(t, e) {
      return !e || "object" !== wu(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }(t) : e;
    }

    function Eu(t) {
      return (Eu = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
    }

    var Au = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && ku(t, e);
      }(i, t);
      var e,
          n,
          r,
          o = Su(i);

      function i() {
        return _u(this, i), o.apply(this, arguments);
      }

      return e = i, r = [{
        key: "create",
        value: function value(t) {
          if (null == window.katex) throw new Error("Formula module requires KaTeX.");
          var e = Nu(Eu(i), "create", this).call(this, t);
          return "string" == typeof t && (window.katex.render(t, e, {
            throwOnError: !1,
            errorColor: "#f00"
          }), e.setAttribute("data-value", t)), e;
        }
      }, {
        key: "value",
        value: function value(t) {
          return t.getAttribute("data-value");
        }
      }], (n = [{
        key: "html",
        value: function value() {
          var t = this.value().formula;
          return "<span>".concat(t, "</span>");
        }
      }]) && ju(e.prototype, n), r && ju(e, r), i;
    }(On);

    Au.blotName = "formula", Au.className = "ql-formula", Au.tagName = "SPAN";
    var Ru = Au;

    function Tu(t) {
      return (Tu = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function Pu(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }

    function Cu(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    function Lu(t, e, n) {
      return (Lu = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, n) {
        var r = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = Bu(t));) {
            ;
          }

          return t;
        }(t, e);

        if (r) {
          var o = Object.getOwnPropertyDescriptor(r, e);
          return o.get ? o.get.call(n) : o.value;
        }
      })(t, e, n || t);
    }

    function Du(t, e) {
      return (Du = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      })(t, e);
    }

    function qu(t) {
      var e = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = Bu(t);

        if (e) {
          var o = Bu(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return Iu(this, n);
      };
    }

    function Iu(t, e) {
      return !e || "object" !== Tu(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }(t) : e;
    }

    function Bu(t) {
      return (Bu = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
    }

    var Mu = ["alt", "height", "width"],
        Uu = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && Du(t, e);
      }(i, t);
      var e,
          n,
          r,
          o = qu(i);

      function i() {
        return Pu(this, i), o.apply(this, arguments);
      }

      return e = i, r = [{
        key: "create",
        value: function value(t) {
          var e = Lu(Bu(i), "create", this).call(this, t);
          return "string" == typeof t && e.setAttribute("src", this.sanitize(t)), e;
        }
      }, {
        key: "formats",
        value: function value(t) {
          return Mu.reduce(function (e, n) {
            return t.hasAttribute(n) && (e[n] = t.getAttribute(n)), e;
          }, {});
        }
      }, {
        key: "match",
        value: function value(t) {
          return /\.(jpe?g|gif|png)$/.test(t) || /^data:image\/.+;base64/.test(t);
        }
      }, {
        key: "register",
        value: function value() {
          /Firefox/i.test(navigator.userAgent) && setTimeout(function () {
            document.execCommand("enableObjectResizing", !1, !1);
          }, 1);
        }
      }, {
        key: "sanitize",
        value: function value(t) {
          return Gi(t, ["http", "https", "data"]) ? t : "//:0";
        }
      }, {
        key: "value",
        value: function value(t) {
          return t.getAttribute("src");
        }
      }], (n = [{
        key: "format",
        value: function value(t, e) {
          Mu.indexOf(t) > -1 ? e ? this.domNode.setAttribute(t, e) : this.domNode.removeAttribute(t) : Lu(Bu(i.prototype), "format", this).call(this, t, e);
        }
      }]) && Cu(e.prototype, n), r && Cu(e, r), i;
    }(B);

    Uu.blotName = "image", Uu.tagName = "IMG";
    var zu = Uu;

    function Fu(t) {
      return (Fu = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function Ku(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }

    function Wu(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    function $u(t, e, n) {
      return ($u = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, n) {
        var r = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = Xu(t));) {
            ;
          }

          return t;
        }(t, e);

        if (r) {
          var o = Object.getOwnPropertyDescriptor(r, e);
          return o.get ? o.get.call(n) : o.value;
        }
      })(t, e, n || t);
    }

    function Hu(t, e) {
      return (Hu = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      })(t, e);
    }

    function Vu(t) {
      var e = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = Xu(t);

        if (e) {
          var o = Xu(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return Gu(this, n);
      };
    }

    function Gu(t, e) {
      return !e || "object" !== Fu(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }(t) : e;
    }

    function Xu(t) {
      return (Xu = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
    }

    var Yu = ["height", "width"],
        Qu = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && Hu(t, e);
      }(i, t);
      var e,
          n,
          r,
          o = Vu(i);

      function i() {
        return Ku(this, i), o.apply(this, arguments);
      }

      return e = i, r = [{
        key: "create",
        value: function value(t) {
          var e = $u(Xu(i), "create", this).call(this, t);
          return e.setAttribute("frameborder", "0"), e.setAttribute("allowfullscreen", !0), e.setAttribute("src", this.sanitize(t)), e;
        }
      }, {
        key: "formats",
        value: function value(t) {
          return Yu.reduce(function (e, n) {
            return t.hasAttribute(n) && (e[n] = t.getAttribute(n)), e;
          }, {});
        }
      }, {
        key: "sanitize",
        value: function value(t) {
          return Vi.sanitize(t);
        }
      }, {
        key: "value",
        value: function value(t) {
          return t.getAttribute("src");
        }
      }], (n = [{
        key: "format",
        value: function value(t, e) {
          Yu.indexOf(t) > -1 ? e ? this.domNode.setAttribute(t, e) : this.domNode.removeAttribute(t) : $u(Xu(i.prototype), "format", this).call(this, t, e);
        }
      }, {
        key: "html",
        value: function value() {
          var t = this.value().video;
          return '<a href="'.concat(t, '">').concat(t, "</a>");
        }
      }]) && Wu(e.prototype, n), r && Wu(e, r), i;
    }(be);

    Qu.blotName = "video", Qu.className = "ql-video", Qu.tagName = "IFRAME";
    var Zu = Qu;

    function Ju(t, e, n) {
      return e in t ? Object.defineProperty(t, e, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = n, t;
    }

    function ta(t, e) {
      return function (t) {
        if (Array.isArray(t)) return t;
      }(t) || function (t, e) {
        if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(t))) return;
        var n = [],
            r = !0,
            o = !1,
            i = void 0;

        try {
          for (var u, a = t[Symbol.iterator](); !(r = (u = a.next()).done) && (n.push(u.value), !e || n.length !== e); r = !0) {
            ;
          }
        } catch (t) {
          o = !0, i = t;
        } finally {
          try {
            r || null == a.return || a.return();
          } finally {
            if (o) throw i;
          }
        }

        return n;
      }(t, e) || function (t, e) {
        if (!t) return;
        if ("string" == typeof t) return ea(t, e);
        var n = Object.prototype.toString.call(t).slice(8, -1);
        "Object" === n && t.constructor && (n = t.constructor.name);
        if ("Map" === n || "Set" === n) return Array.from(t);
        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ea(t, e);
      }(t, e) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function ea(t, e) {
      (null == e || e > t.length) && (e = t.length);

      for (var n = 0, r = new Array(e); n < e; n++) {
        r[n] = t[n];
      }

      return r;
    }

    function na(t) {
      return (na = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function ra(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }

    function oa(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    function ia(t, e, n) {
      return e && oa(t.prototype, e), n && oa(t, n), t;
    }

    function ua(t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          writable: !0,
          configurable: !0
        }
      }), e && aa(t, e);
    }

    function aa(t, e) {
      return (aa = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      })(t, e);
    }

    function ca(t) {
      var e = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = ha(t);

        if (e) {
          var o = ha(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return la(this, n);
      };
    }

    function la(t, e) {
      return !e || "object" !== na(e) && "function" != typeof e ? sa(t) : e;
    }

    function sa(t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }

    function fa(t, e, n) {
      return (fa = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, n) {
        var r = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = ha(t));) {
            ;
          }

          return t;
        }(t, e);

        if (r) {
          var o = Object.getOwnPropertyDescriptor(r, e);
          return o.get ? o.get.call(n) : o.value;
        }
      })(t, e, n || t);
    }

    function ha(t) {
      return (ha = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
    }

    var pa = new E("code-token", "hljs", {
      scope: h.INLINE
    }),
        ya = function (t) {
      ua(n, t);
      var e = ca(n);

      function n(t, r, o) {
        var i;
        return ra(this, n), i = e.call(this, t, r, o), pa.add(i.domNode, o), i;
      }

      return ia(n, null, [{
        key: "formats",
        value: function value(t, e) {
          for (; null != t && t !== e.domNode;) {
            if (t.classList && t.classList.contains(ar.className)) return fa(ha(n), "formats", this).call(this, t, e);
            t = t.parentNode;
          }
        }
      }]), ia(n, [{
        key: "format",
        value: function value(t, e) {
          t !== n.blotName ? fa(ha(n.prototype), "format", this).call(this, t, e) : e ? pa.add(this.domNode, e) : (pa.remove(this.domNode), this.domNode.classList.remove(this.statics.className));
        }
      }, {
        key: "optimize",
        value: function value() {
          for (var t, e = arguments.length, r = new Array(e), o = 0; o < e; o++) {
            r[o] = arguments[o];
          }

          (t = fa(ha(n.prototype), "optimize", this)).call.apply(t, [this].concat(r)), pa.value(this.domNode) || this.unwrap();
        }
      }]), n;
    }(ne);

    ya.blotName = "code-token", ya.className = "ql-token";

    var da = function (t) {
      ua(n, t);
      var e = ca(n);

      function n() {
        return ra(this, n), e.apply(this, arguments);
      }

      return ia(n, [{
        key: "format",
        value: function value(t, e) {
          t === this.statics.blotName && e ? this.domNode.setAttribute("data-language", e) : fa(ha(n.prototype), "format", this).call(this, t, e);
        }
      }, {
        key: "replaceWith",
        value: function value(t, e) {
          return this.formatAt(0, this.length(), ya.blotName, !1), fa(ha(n.prototype), "replaceWith", this).call(this, t, e);
        }
      }], [{
        key: "create",
        value: function value(t) {
          var e = fa(ha(n), "create", this).call(this, t);
          return "string" == typeof t && e.setAttribute("data-language", t), e;
        }
      }, {
        key: "formats",
        value: function value(t) {
          return t.getAttribute("data-language") || "plain";
        }
      }, {
        key: "register",
        value: function value() {}
      }]), n;
    }(ar),
        va = function (t) {
      ua(n, t);
      var e = ca(n);

      function n() {
        return ra(this, n), e.apply(this, arguments);
      }

      return ia(n, [{
        key: "attach",
        value: function value() {
          fa(ha(n.prototype), "attach", this).call(this), this.forceNext = !1, this.scroll.emitMount(this);
        }
      }, {
        key: "format",
        value: function value(t, e) {
          t === da.blotName && (this.forceNext = !0, this.children.forEach(function (n) {
            n.format(t, e);
          }));
        }
      }, {
        key: "formatAt",
        value: function value(t, e, r, o) {
          r === da.blotName && (this.forceNext = !0), fa(ha(n.prototype), "formatAt", this).call(this, t, e, r, o);
        }
      }, {
        key: "highlight",
        value: function value(t) {
          var e = this,
              n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];

          if (null != this.children.head) {
            var r = Array.from(this.domNode.childNodes).filter(function (t) {
              return t !== e.uiNode;
            }),
                o = "".concat(r.map(function (t) {
              return t.textContent;
            }).join("\n"), "\n"),
                i = da.formats(this.children.head.domNode);

            if (n || this.forceNext || this.cachedText !== o) {
              if (o.trim().length > 0 || null == this.cachedText) {
                var a = this.children.reduce(function (t, e) {
                  return t.concat(me(e, !1));
                }, new u.a()),
                    c = t(o, i);
                a.diff(c).reduce(function (t, n) {
                  var r = n.retain,
                      o = n.attributes;
                  return r ? (o && Object.keys(o).forEach(function (n) {
                    -1 !== [da.blotName, ya.blotName].indexOf(n) && e.formatAt(t, r, n, o[n]);
                  }), t + r) : t;
                }, 0);
              }

              this.cachedText = o, this.forceNext = !1;
            }
          }
        }
      }, {
        key: "html",
        value: function value(t, e) {
          var n = ta(this.children.find(t), 1)[0],
              r = n ? da.formats(n.domNode) : "plain";
          return '<pre data-language="'.concat(r, '">\n').concat(this.code(t, e), "\n</pre>");
        }
      }, {
        key: "optimize",
        value: function value(t) {
          if (fa(ha(n.prototype), "optimize", this).call(this, t), null != this.parent && null != this.children.head && null != this.uiNode) {
            var e = da.formats(this.children.head.domNode);
            e !== this.uiNode.value && (this.uiNode.value = e);
          }
        }
      }]), n;
    }(ur);

    va.allowedChildren = [da], da.requiredContainer = va, da.allowedChildren = [ya, It, St, Ht];

    var ba = function (t) {
      ua(n, t);
      var e = ca(n);

      function n(t, r) {
        var o;
        if (ra(this, n), null == (o = e.call(this, t, r)).options.hljs) throw new Error("Syntax module requires highlight.js. Please include the library on the page before Quill.");
        return o.languages = o.options.languages.reduce(function (t, e) {
          return t[e.key] = !0, t;
        }, {}), o.highlightBlot = o.highlightBlot.bind(sa(o)), o.initListener(), o.initTimer(), o;
      }

      return ia(n, null, [{
        key: "register",
        value: function value() {
          tn.register(ya, !0), tn.register(da, !0), tn.register(va, !0);
        }
      }]), ia(n, [{
        key: "initListener",
        value: function value() {
          var t = this;
          this.quill.on(tn.events.SCROLL_BLOT_MOUNT, function (e) {
            if (e instanceof va) {
              var n = t.quill.root.ownerDocument.createElement("select");
              t.options.languages.forEach(function (t) {
                var e = t.key,
                    r = t.label,
                    o = n.ownerDocument.createElement("option");
                o.textContent = r, o.setAttribute("value", e), n.appendChild(o);
              }), n.addEventListener("change", function () {
                e.format(da.blotName, n.value), t.quill.root.focus(), t.highlight(e, !0);
              }), null == e.uiNode && (e.attachUI(n), e.children.head && (n.value = da.formats(e.children.head.domNode)));
            }
          });
        }
      }, {
        key: "initTimer",
        value: function value() {
          var t = this,
              e = null;
          this.quill.on(tn.events.SCROLL_OPTIMIZE, function () {
            clearTimeout(e), e = setTimeout(function () {
              t.highlight(), e = null;
            }, t.options.interval);
          });
        }
      }, {
        key: "highlight",
        value: function value() {
          var t = this,
              e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null,
              n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];

          if (!this.quill.selection.composing) {
            this.quill.update(tn.sources.USER);
            var r = this.quill.getSelection(),
                o = null == e ? this.quill.scroll.descendants(va) : [e];
            o.forEach(function (e) {
              e.highlight(t.highlightBlot, n);
            }), this.quill.update(tn.sources.SILENT), null != r && this.quill.setSelection(r, tn.sources.SILENT);
          }
        }
      }, {
        key: "highlightBlot",
        value: function value(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "plain";
          if ("plain" === (e = this.languages[e] ? e : "plain")) return xt(t).split("\n").reduce(function (t, n, r) {
            return 0 !== r && t.insert("\n", Ju({}, ar.blotName, e)), t.insert(n);
          }, new u.a());
          var n = this.quill.root.ownerDocument.createElement("div");
          return n.classList.add(ar.className), n.innerHTML = this.options.hljs.highlight(e, t).value, Vr(this.quill.scroll, n, [function (t, e) {
            var n = pa.value(t);
            return n ? e.compose(new u.a().retain(e.length(), Ju({}, ya.blotName, n))) : e;
          }], [function (t, n) {
            return t.data.split("\n").reduce(function (t, n, r) {
              return 0 !== r && t.insert("\n", Ju({}, ar.blotName, e)), t.insert(n);
            }, n);
          }], new WeakMap());
        }
      }]), n;
    }(ze);

    function ma(t, e) {
      return function (t) {
        if (Array.isArray(t)) return t;
      }(t) || function (t, e) {
        if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(t))) return;
        var n = [],
            r = !0,
            o = !1,
            i = void 0;

        try {
          for (var u, a = t[Symbol.iterator](); !(r = (u = a.next()).done) && (n.push(u.value), !e || n.length !== e); r = !0) {
            ;
          }
        } catch (t) {
          o = !0, i = t;
        } finally {
          try {
            r || null == a.return || a.return();
          } finally {
            if (o) throw i;
          }
        }

        return n;
      }(t, e) || function (t, e) {
        if (!t) return;
        if ("string" == typeof t) return ga(t, e);
        var n = Object.prototype.toString.call(t).slice(8, -1);
        "Object" === n && t.constructor && (n = t.constructor.name);
        if ("Map" === n || "Set" === n) return Array.from(t);
        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ga(t, e);
      }(t, e) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function ga(t, e) {
      (null == e || e > t.length) && (e = t.length);

      for (var n = 0, r = new Array(e); n < e; n++) {
        r[n] = t[n];
      }

      return r;
    }

    function Oa(t) {
      return (Oa = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function wa(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }

    function _a(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    function ja(t, e, n) {
      return e && _a(t.prototype, e), n && _a(t, n), t;
    }

    function Na(t, e, n) {
      return (Na = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, n) {
        var r = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = Aa(t));) {
            ;
          }

          return t;
        }(t, e);

        if (r) {
          var o = Object.getOwnPropertyDescriptor(r, e);
          return o.get ? o.get.call(n) : o.value;
        }
      })(t, e, n || t);
    }

    function ka(t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          writable: !0,
          configurable: !0
        }
      }), e && Sa(t, e);
    }

    function Sa(t, e) {
      return (Sa = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      })(t, e);
    }

    function xa(t) {
      var e = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = Aa(t);

        if (e) {
          var o = Aa(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return Ea(this, n);
      };
    }

    function Ea(t, e) {
      return !e || "object" !== Oa(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }(t) : e;
    }

    function Aa(t) {
      return (Aa = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
    }

    ba.DEFAULTS = {
      hljs: window.hljs,
      interval: 1e3,
      languages: [{
        key: "plain",
        label: "Plain"
      }, {
        key: "bash",
        label: "Bash"
      }, {
        key: "cpp",
        label: "C++"
      }, {
        key: "cs",
        label: "C#"
      }, {
        key: "css",
        label: "CSS"
      }, {
        key: "diff",
        label: "Diff"
      }, {
        key: "xml",
        label: "HTML/XML"
      }, {
        key: "java",
        label: "Java"
      }, {
        key: "javascript",
        label: "Javascript"
      }, {
        key: "markdown",
        label: "Markdown"
      }, {
        key: "php",
        label: "PHP"
      }, {
        key: "python",
        label: "Python"
      }, {
        key: "ruby",
        label: "Ruby"
      }, {
        key: "sql",
        label: "SQL"
      }]
    };

    var Ra = function (t) {
      ka(n, t);
      var e = xa(n);

      function n() {
        return wa(this, n), e.apply(this, arguments);
      }

      return ja(n, [{
        key: "cellOffset",
        value: function value() {
          return this.parent ? this.parent.children.indexOf(this) : -1;
        }
      }, {
        key: "format",
        value: function value(t, e) {
          t === n.blotName && e ? this.domNode.setAttribute("data-row", e) : Na(Aa(n.prototype), "format", this).call(this, t, e);
        }
      }, {
        key: "row",
        value: function value() {
          return this.parent;
        }
      }, {
        key: "rowOffset",
        value: function value() {
          return this.row() ? this.row().rowOffset() : -1;
        }
      }, {
        key: "table",
        value: function value() {
          return this.row() && this.row().table();
        }
      }], [{
        key: "create",
        value: function value(t) {
          var e = Na(Aa(n), "create", this).call(this);
          return t ? e.setAttribute("data-row", t) : e.setAttribute("data-row", La()), e;
        }
      }, {
        key: "formats",
        value: function value(t) {
          if (t.hasAttribute("data-row")) return t.getAttribute("data-row");
        }
      }]), n;
    }(ve);

    Ra.blotName = "table", Ra.tagName = "TD";

    var Ta = function (t) {
      ka(n, t);
      var e = xa(n);

      function n() {
        return wa(this, n), e.apply(this, arguments);
      }

      return ja(n, [{
        key: "checkMerge",
        value: function value() {
          if (Na(Aa(n.prototype), "checkMerge", this).call(this) && null != this.next.children.head) {
            var t = this.children.head.formats(),
                e = this.children.tail.formats(),
                r = this.next.children.head.formats(),
                o = this.next.children.tail.formats();
            return t.table === e.table && t.table === r.table && t.table === o.table;
          }

          return !1;
        }
      }, {
        key: "optimize",
        value: function value() {
          for (var t, e = this, r = arguments.length, o = new Array(r), i = 0; i < r; i++) {
            o[i] = arguments[i];
          }

          (t = Na(Aa(n.prototype), "optimize", this)).call.apply(t, [this].concat(o)), this.children.forEach(function (t) {
            if (null != t.next) {
              var n = t.formats(),
                  r = t.next.formats();

              if (n.table !== r.table) {
                var o = e.splitAfter(t);
                o && o.optimize(), e.prev && e.prev.optimize();
              }
            }
          });
        }
      }, {
        key: "rowOffset",
        value: function value() {
          return this.parent ? this.parent.children.indexOf(this) : -1;
        }
      }, {
        key: "table",
        value: function value() {
          return this.parent && this.parent.parent;
        }
      }]), n;
    }(hn);

    Ta.blotName = "table-row", Ta.tagName = "TR";

    var Pa = function (t) {
      ka(n, t);
      var e = xa(n);

      function n() {
        return wa(this, n), e.apply(this, arguments);
      }

      return n;
    }(hn);

    Pa.blotName = "table-body", Pa.tagName = "TBODY";

    var Ca = function (t) {
      ka(n, t);
      var e = xa(n);

      function n() {
        return wa(this, n), e.apply(this, arguments);
      }

      return ja(n, [{
        key: "balanceCells",
        value: function value() {
          var t = this,
              e = this.descendants(Ta),
              n = e.reduce(function (t, e) {
            return Math.max(e.children.length, t);
          }, 0);
          e.forEach(function (e) {
            new Array(n - e.children.length).fill(0).forEach(function () {
              var n;
              null != e.children.head && (n = Ra.formats(e.children.head.domNode));
              var r = t.scroll.create(Ra.blotName, n);
              e.appendChild(r), r.optimize();
            });
          });
        }
      }, {
        key: "cells",
        value: function value(t) {
          return this.rows().map(function (e) {
            return e.children.at(t);
          });
        }
      }, {
        key: "deleteColumn",
        value: function value(t) {
          var e = ma(this.descendant(Pa), 1)[0];
          null != e && null != e.children.head && e.children.forEach(function (e) {
            var n = e.children.at(t);
            null != n && n.remove();
          });
        }
      }, {
        key: "insertColumn",
        value: function value(t) {
          var e = this,
              n = ma(this.descendant(Pa), 1)[0];
          null != n && null != n.children.head && n.children.forEach(function (n) {
            var r = n.children.at(t),
                o = Ra.formats(n.children.head.domNode),
                i = e.scroll.create(Ra.blotName, o);
            n.insertBefore(i, r);
          });
        }
      }, {
        key: "insertRow",
        value: function value(t) {
          var e = this,
              n = ma(this.descendant(Pa), 1)[0];

          if (null != n && null != n.children.head) {
            var r = La(),
                o = this.scroll.create(Ta.blotName);
            n.children.head.children.forEach(function () {
              var t = e.scroll.create(Ra.blotName, r);
              o.appendChild(t);
            });
            var i = n.children.at(t);
            n.insertBefore(o, i);
          }
        }
      }, {
        key: "rows",
        value: function value() {
          var t = this.children.head;
          return null == t ? [] : t.children.map(function (t) {
            return t;
          });
        }
      }]), n;
    }(hn);

    function La() {
      var t = Math.random().toString(36).slice(2, 6);
      return "row-".concat(t);
    }

    function Da(t) {
      return (Da = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function qa(t, e) {
      return function (t) {
        if (Array.isArray(t)) return t;
      }(t) || function (t, e) {
        if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(t))) return;
        var n = [],
            r = !0,
            o = !1,
            i = void 0;

        try {
          for (var u, a = t[Symbol.iterator](); !(r = (u = a.next()).done) && (n.push(u.value), !e || n.length !== e); r = !0) {
            ;
          }
        } catch (t) {
          o = !0, i = t;
        } finally {
          try {
            r || null == a.return || a.return();
          } finally {
            if (o) throw i;
          }
        }

        return n;
      }(t, e) || function (t, e) {
        if (!t) return;
        if ("string" == typeof t) return Ia(t, e);
        var n = Object.prototype.toString.call(t).slice(8, -1);
        "Object" === n && t.constructor && (n = t.constructor.name);
        if ("Map" === n || "Set" === n) return Array.from(t);
        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Ia(t, e);
      }(t, e) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function Ia(t, e) {
      (null == e || e > t.length) && (e = t.length);

      for (var n = 0, r = new Array(e); n < e; n++) {
        r[n] = t[n];
      }

      return r;
    }

    function Ba(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }

    function Ma(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    function Ua(t, e, n) {
      return e && Ma(t.prototype, e), n && Ma(t, n), t;
    }

    function za(t, e) {
      return (za = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      })(t, e);
    }

    function Fa(t) {
      var e = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = Wa(t);

        if (e) {
          var o = Wa(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return Ka(this, n);
      };
    }

    function Ka(t, e) {
      return !e || "object" !== Da(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }(t) : e;
    }

    function Wa(t) {
      return (Wa = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
    }

    Ca.blotName = "table-container", Ca.tagName = "TABLE", Ca.allowedChildren = [Pa], Pa.requiredContainer = Ca, Pa.allowedChildren = [Ta], Ta.requiredContainer = Pa, Ta.allowedChildren = [Ra], Ra.requiredContainer = Ta;

    var $a = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && za(t, e);
      }(n, t);
      var e = Fa(n);

      function n() {
        var t;
        Ba(this, n);

        for (var r = arguments.length, o = new Array(r), i = 0; i < r; i++) {
          o[i] = arguments[i];
        }

        return (t = e.call.apply(e, [this].concat(o))).listenBalanceCells(), t;
      }

      return Ua(n, null, [{
        key: "register",
        value: function value() {
          tn.register(Ra), tn.register(Ta), tn.register(Pa), tn.register(Ca);
        }
      }]), Ua(n, [{
        key: "balanceTables",
        value: function value() {
          this.quill.scroll.descendants(Ca).forEach(function (t) {
            t.balanceCells();
          });
        }
      }, {
        key: "deleteColumn",
        value: function value() {
          var t = qa(this.getTable(), 3),
              e = t[0],
              n = t[2];
          null != n && (e.deleteColumn(n.cellOffset()), this.quill.update(tn.sources.USER));
        }
      }, {
        key: "deleteRow",
        value: function value() {
          var t = qa(this.getTable(), 2)[1];
          null != t && (t.remove(), this.quill.update(tn.sources.USER));
        }
      }, {
        key: "deleteTable",
        value: function value() {
          var t = qa(this.getTable(), 1)[0];

          if (null != t) {
            var e = t.offset();
            t.remove(), this.quill.update(tn.sources.USER), this.quill.setSelection(e, tn.sources.SILENT);
          }
        }
      }, {
        key: "getTable",
        value: function value() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.quill.getSelection();
          if (null == t) return [null, null, null, -1];
          var e = this.quill.getLine(t.index),
              n = qa(e, 2),
              r = n[0],
              o = n[1];
          if (null == r || r.statics.blotName !== Ra.blotName) return [null, null, null, -1];
          var i = r.parent,
              u = i.parent.parent;
          return [u, i, r, o];
        }
      }, {
        key: "insertColumn",
        value: function value(t) {
          var e = this.quill.getSelection(),
              n = qa(this.getTable(e), 3),
              r = n[0],
              o = n[1],
              i = n[2];

          if (null != i) {
            var u = i.cellOffset();
            r.insertColumn(u + t), this.quill.update(tn.sources.USER);
            var a = o.rowOffset();
            0 === t && (a += 1), this.quill.setSelection(e.index + a, e.length, tn.sources.SILENT);
          }
        }
      }, {
        key: "insertColumnLeft",
        value: function value() {
          this.insertColumn(0);
        }
      }, {
        key: "insertColumnRight",
        value: function value() {
          this.insertColumn(1);
        }
      }, {
        key: "insertRow",
        value: function value(t) {
          var e = this.quill.getSelection(),
              n = qa(this.getTable(e), 3),
              r = n[0],
              o = n[1];

          if (null != n[2]) {
            var i = o.rowOffset();
            r.insertRow(i + t), this.quill.update(tn.sources.USER), t > 0 ? this.quill.setSelection(e, tn.sources.SILENT) : this.quill.setSelection(e.index + o.children.length, e.length, tn.sources.SILENT);
          }
        }
      }, {
        key: "insertRowAbove",
        value: function value() {
          this.insertRow(0);
        }
      }, {
        key: "insertRowBelow",
        value: function value() {
          this.insertRow(1);
        }
      }, {
        key: "insertTable",
        value: function value(t, e) {
          var n = this.quill.getSelection();

          if (null != n) {
            var r = new Array(t).fill(0).reduce(function (t) {
              var n = new Array(e).fill("\n").join("");
              return t.insert(n, {
                table: La()
              });
            }, new u.a().retain(n.index));
            this.quill.updateContents(r, tn.sources.USER), this.quill.setSelection(n.index, tn.sources.SILENT), this.balanceTables();
          }
        }
      }, {
        key: "listenBalanceCells",
        value: function value() {
          var t = this;
          this.quill.on(tn.events.SCROLL_OPTIMIZE, function (e) {
            e.some(function (e) {
              return -1 !== ["TD", "TR", "TBODY", "TABLE"].indexOf(e.target.tagName) && (t.quill.once(tn.events.TEXT_CHANGE, function (e, n, r) {
                r === tn.sources.USER && t.balanceTables();
              }), !0);
            });
          });
        }
      }]), n;
    }(ze);

    qo.register({
      "attributors/attribute/direction": sr,
      "attributors/class/align": Dn,
      "attributors/class/background": Gn,
      "attributors/class/color": Hn,
      "attributors/class/direction": fr,
      "attributors/class/font": _r,
      "attributors/class/size": Nr,
      "attributors/style/align": qn,
      "attributors/style/background": Xn,
      "attributors/style/color": Vn,
      "attributors/style/direction": hr,
      "attributors/style/font": jr,
      "attributors/style/size": kr
    }, !0), qo.register({
      "formats/align": Dn,
      "formats/direction": fr,
      "formats/indent": $o,
      "formats/background": Xn,
      "formats/color": Vn,
      "formats/font": _r,
      "formats/size": Nr,
      "formats/blockquote": Jo,
      "formats/code-block": ar,
      "formats/header": ci,
      "formats/list": Oi,
      "formats/bold": Ri,
      "formats/code": cr,
      "formats/italic": Bi,
      "formats/link": Vi,
      "formats/script": ou,
      "formats/strike": hu,
      "formats/underline": Ou,
      "formats/formula": Ru,
      "formats/image": zu,
      "formats/video": Zu,
      "modules/syntax": ba,
      "modules/table": $a
    }, !0);
    e.default = qo;
  }]).default;
});